import type { Dict } from "../types";

export const zhTW: Dict = {
  "chat.amrCard.switchTitle": "模型呼叫失敗，目前任務已暫停",
  "chat.amrCard.switchBody":
    "可切換到 Open Design Cloud 官方模型服務，無需設定 API Key。完成登入、授權與儲值後，將自動重試目前任務。",
  "chat.amrCard.chipOfficial": "官方代管",
  "chat.amrCard.chipNoKey": "無需 API Key",
  "chat.amrCard.chipAutoRetry": "授權後自動重試",
  "chat.amrCard.switchCta": "切換到 Open Design Cloud 並重試",
  "chat.amrError.authMessage":
    "Open Design Cloud 帳號尚未授權。完成授權後將自動重試目前任務。",
  "chat.amrError.balanceMessage":
    "Open Design Cloud 帳戶餘額不足。儲值後即可繼續執行目前任務。",
  "chat.amrError.authorizeCta": "授權並重試",
  "chat.amrError.rechargeCta": "為 Open Design Cloud 儲值",
  "chat.amrBalanceGate.title": "升級方案，繼續創作",
  "chat.amrBalanceGate.message": "餘額不足（目前 {balance}），升級方案或儲值後，任務馬上就能開始。",
  "chat.amrBalanceGate.benefitsTitle": "Open Design Cloud 為你提供",
  "chat.amrBalanceGate.benefit1": "無需 API Key，海量模型任選",
  "chat.amrBalanceGate.benefit2": "自帶 SOTA Design Agent，零設定",
  "chat.amrBalanceGate.benefit3": "官方服務，穩定有保障",
  "chat.amrBalanceGate.benefit4": "持續升級：一鍵部署、多模態、團隊版等",
  "chat.amrBalanceGate.laterCta": "暫不需要",
  "chat.amrBalanceGate.plansCta": "升級方案",
  "chat.amrBalanceGate.signedOutTitle": "登入 Open Design Cloud，開始創作",
  "chat.amrBalanceGate.signedOutMessage": "目前使用的是 Open Design Cloud 智能體，登入後這個任務馬上就能開始。",
  "chat.amrBalanceGate.signInCta": "立即登入",
  "chat.amrBalanceGate.watchingWallet": "儲值到帳後將自動繼續。",
  "chat.amrLowBalance.title": "餘額不多了",
  "chat.amrLowBalance.message": "餘額僅剩 {balance}，可能不夠完成這個任務，建議先儲值或升級方案。",
  "chat.amrLowBalance.rechargeCta": "去儲值",
  "chat.amrLowBalance.proceedCta": "仍要發起任務",
  "chat.amrLowBalance.dontRemind": "不再提示",
  "chat.amrArtifactUpgrade.title": "用更強模型繼續完善作品",
  "chat.amrArtifactUpgrade.message": "解鎖進階模型、更多任務並行與更高每月積分。",
  "chat.amrArtifactUpgrade.benefit1": "更多進階模型，如 Fable 5、GPT-5.6",
  "chat.amrArtifactUpgrade.benefit2": "任務並行處理最高提升 10 倍",
  "chat.amrArtifactUpgrade.benefit3": "每月積分最高提升 300 倍",
  "chat.amrArtifactUpgrade.benefit4": "尖峰時段優先排隊，生成更快",
  "chat.amrArtifactUpgrade.promoBanner": "訂閱方案限時最高省 67%",
  "chat.amrArtifactUpgrade.countdownLabel": "優惠倒數",
  "chat.amrArtifactUpgrade.plansCta": "立即升級方案，最高省 67%",
  "chat.amrArtifactUpgrade.homePlansCta": "省 67% 升級",
  "chat.amrArtifactUpgrade.laterCta": "繼續使用 Free 並傳送",
  "chat.amrArtifactUpgrade.homeTitle": "作品已完成，讓下一個創意更進一步",
  "chat.amrArtifactUpgrade.homeMessage": "升級即可解鎖進階模型、更多並行任務與更高每月積分。",
  "chat.amrArtifactUpgrade.homeArtifactCta": "查看作品",
  "chat.antigravityError.launchTerminalCta": "透過終端機登入",
  "chat.antigravityError.launchSwitchModelCta": "在終端機中切換模型",
  "chat.connectionDropped":
    "與模型服務的連線在回應完成前中斷了——通常是網路或代理不穩定。請重試。",
  "chat.runError.title.authRequired": "需要授權",
  "chat.runError.title.balance": "餘額不足",
  "chat.runError.title.connectionDropped": "連線中斷",
  "chat.runError.title.signInRequired": "需要登入",
  "chat.runError.title.rateLimited": "已達用量上限",
  "chat.runError.title.generic": "任務執行失敗",
  "chat.runError.title.artifactMissing": "未產生檔案產物",
  "chat.runError.signInMessage.amr":
    "Open Design Cloud 智慧體尚未登入，前往登入即可正常使用",
  "chat.runError.signInMessage.other":
    "{agent}尚未登入，請在本機檢查登入狀態。推薦使用 Open Design Cloud 智慧體，更穩定划算",
  "chat.runError.agentFallback": "智慧體",
  "chat.runError.sourceLabel": "查看錯誤詳情",
  "chat.runError.sourceExpandAria": "展開錯誤原始碼",
  "chat.runError.sourceCollapseAria": "收合錯誤原始碼",
  "chat.runError.title.cliMissing": "智慧體尚未安裝",
  "chat.runError.title.promptTooLarge": "內容過長",
  "chat.runError.title.modelUnavailable": "模型不可用",
  "chat.runError.title.upstreamUnavailable": "服務暫時無法使用",
  "chat.runError.title.toolLoop": "操作陷入循環",
  "chat.runError.title.outputInvalid": "輸出異常",
  "chat.runError.title.runtimeConfig": "設定錯誤",
  "chat.runError.cliMissingMessage": "找不到 {agent} 的命令列工具。請先安裝並確認它在 PATH 中，然後重試。",
  "chat.runError.promptTooLargeMessage": "本輪輸入超出了模型的上下文上限。請縮短提示詞、減少附件，或另開對話後重試。",
  "chat.runError.modelUnavailableMessage": "所選模型不可用或不存在。請在設定中切換到其他可用模型後重試。",
  "chat.runError.rateLimitedMessage": "已觸發模型服務的用量上限。請稍後重試，或切換到其他模型／服務。",
  "chat.runError.upstreamUnavailableMessage": "模型服務暫時無法使用，通常是上游波動或網路／代理問題。請稍後重試。",
  "chat.runError.toolLoopMessage": "{agent} 不斷重複同一操作卻沒有進展，已自動停止。請檢查目標檔案或指令後重試。",
  "chat.runError.outputInvalidMessage": "模型輸出了異常內容，本輪已被中斷。通常重試即可恢復。",
  "chat.runError.runtimeConfigMessage": "所選智慧體的執行階段設定有誤，無法啟動本輪任務。請更新到最新版本或聯絡支援。",
  "chat.runError.title.quotaExhausted": "額度已用盡",
  "chat.runError.title.timedOut": "執行逾時",
  "chat.runError.title.emptyOutput": "沒有任何輸出",
  "chat.runError.title.sessionExpired": "工作階段已過期",
  "chat.runError.title.gitBashMissing": "缺少 Git Bash",
  "chat.runError.title.cpuUnsupported": "處理器不支援",
  "chat.runError.quotaExhaustedMessage": "所用模型服務的額度或帳單上限已用盡，重試也無法恢復。請前往對應服務儲值，或切換到其他模型／服務。",
  "chat.runError.workspaceCreditsMessage": "工作區額度已用盡。請儲值（或聯絡工作區管理員補充），或切換到其他模型／服務。",
  "chat.runError.timedOutMessage": "本次執行耗時過長已被中斷。請重試，或縮小任務範圍後再試。",
  "chat.runError.inactivityTimeoutMessage": "智能體長時間沒有新輸出，已依逾時中斷。通常重試即可繼續。",
  "chat.runError.emptyOutputMessage": "智能體本次結束時沒有產生任何輸出。這通常是暫時的，重試即可再次執行。",
  "chat.runError.sessionExpiredMessage": "要恢復的工作階段已過期，已為你重置。重試即可開始一次全新執行。",
  "chat.runError.gitBashMissingMessage": "在 Windows 上執行此智能體需要 Git Bash，但找不到。請安裝 Git for Windows 後重試。",
  "chat.runError.cpuUnsupportedMessage": "此智能體的執行時需要此裝置處理器不支援的指令集（AVX2），因此無法啟動。請將 Open Design 更新到最新版本，新版本附帶相容的執行時。",
  "common.cancel": "取消",
  "chat.selectFromLibrary": "從資源庫匯入",
  "chat.importFigma": "從 Figma 匯入",
  "chat.plus.group.files": "檔案",
  "chat.plus.group.code": "程式碼",
  "chat.plus.group.designs": "設計",
  "chat.plus.group.other": "其他",
  "chat.plus.attachFiles": "附加檔案",
  "chat.plus.referenceProject": "引用其他專案",
  "chat.plus.linkLocalCode": "連結本機程式碼",
  "chat.plus.uploadFig": "上傳 .fig 檔案",
  "chat.plus.learnHow": "查看方法",
  "chat.plus.designSystem": "設計系統",
  "chat.plus.skills": "技能",
  "chat.plus.noSkills": "暫無可用技能",
  "chat.plus.connectors": "連接器",
  "chat.plus.plugins": "外掛",
  "chat.plus.mcp": "MCP",
  "chat.referenceProject.title": "引用其他專案",
  "chat.referenceProject.search": "搜尋專案…",
  "chat.referenceProject.empty": "沒有符合「{query}」的專案",
  "chat.referenceProject.emptyAll": "暫無其他專案",
  "chat.referenceProject.loadFailed": "無法載入專案。請確認 daemon 正在執行後再試一次。",
  "chat.referenceProject.confirm": "引用專案",
  "chat.contextPrompt.referenceProject":
    "請把 Open Design 專案「{name}」作為參考上下文。它的本機路徑是：{path}。在設計或修改前，如有幫助請先搜尋並讀取這個目錄。",
  "chat.contextPrompt.localCode":
    "請把本機程式碼目錄「{name}」作為程式碼參考。它的絕對路徑是：{path}。如有幫助請先讀取相關檔案，並與既有實作保持一致。",
  "chat.figmaHelp.title": "如何下載 .fig 檔案",
  "chat.figmaHelp.intro": "從 Figma 網頁版或桌面版：",
  "chat.figmaHelp.step1": "開啟 Figma 檔案。",
  "chat.figmaHelp.step2": "前往 File → Save local copy...（網頁版在主選單 → File）。",
  "chat.figmaHelp.step3": "Figma 會下載一個 .fig 檔案，將它拖入輸入框或上傳。",
  "chat.figmaHelp.note": ".fig 檔案會在本機解析，不會上傳到 Figma。",
  "designFiles.library.label": "從資源庫匯入",
  "designFiles.library.title": "從資源庫匯入",
  "libraryPicker.title": "從資源庫匯入",
  "libraryPicker.searchPlaceholder": "搜尋資源庫…",
  "libraryPicker.empty": "資源庫尚無內容",
  "libraryPicker.allKinds": "全部",
  "libraryPicker.add": "匯入",
  "libraryPicker.loading": "載入中…",
  "common.save": "儲存",
  "common.close": "關閉",
  "common.clear": "清除",
  "common.delete": "刪除",
  "common.rename": "重新命名",
  "common.edit": "編輯",
  "common.preview": "預覽",
  "common.share": "分享",
  "common.search": "搜尋",
  "common.searchEllipsis": "搜尋…",
  "common.loading": "載入中…",
  "common.all": "全部",
  "common.none": "無",
  "common.default": "預設",
  "common.installed": "已安裝",
  "common.notInstalled": "未安裝",
  "common.active": "使用中",
  "common.offline": "未執行",
  "common.selected": "已選",
  "common.create": "建立",
  "common.openPreview": "開啟預覽",
  "common.exitFullscreen": "離開全螢幕",
  "common.fullscreen": "全螢幕",
  "common.openInNewTab": "在新分頁中開啟",
  "common.exportPdf": "匯出為 PDF",
  "common.exportZip": "下載為 .zip",
  "common.exportHtml": "匯出為獨立 HTML",
  "common.exportImage": "匯出為圖片",
  "common.exportImageFailed": "圖片截圖失敗，請重試或使用瀏覽器的截圖工具。",
  "common.justNow": "剛剛",
  "common.minutesAgo": "{n} 分鐘前",
  "common.hoursAgo": "{n} 小時前",
  "common.daysAgo": "{n} 天前",
  "common.weeksAgo": "{n}w ago",
  "common.now": "剛剛",
  "common.minutesShort": "{n}分",
  "common.hoursShort": "{n}時",
  "common.daysShort": "{n}天",
  "common.untitled": "未命名",
  "plugins.availableDetails.provenance": "來源",
  "plugins.availableDetails.provenanceLine":
    "來自 {source} · {trust} · {resolved}",
  "plugins.availableDetails.provenanceLineWithIntegrity":
    "來自 {source} · {trust} · {resolved} · {integrity}",
  "plugins.availableDetails.install": "安裝",
  "plugins.availableDetails.version": "版本",
  "plugins.availableDetails.pluginVersion": "外掛版本",
  "plugins.availableDetails.copyInstallCommand": "複製安裝指令",
  "plugins.availableDetails.copied": "已複製",
  "plugins.availableDetails.deprecatedPrefix": "已淘汰：{message}",
  "plugins.availableDetails.deprecatedFallback": "此版本已標記為淘汰。",
  "plugins.availableDetails.yanked": "已撤回。",
  "plugins.availableDetails.yankedWithReason": "已撤回：{reason}",
  "plugins.availableDetails.versionDeprecatedSuffix": "（已淘汰）",
  "plugins.availableDetails.versionYankedSuffix": "（已撤回）",
  "plugins.availableDetails.ref": "參照",
  "plugins.availableDetails.integrity": "Integrity",
  "plugins.availableDetails.permissions": "權限",
  "plugins.availableDetails.capabilitySummary": "功能摘要",
  "plugins.actions.copyInstallCommand": "複製安裝命令",
  "plugins.actions.copyPluginId": "複製外掛 ID",
  "plugins.actions.copyReadmeBadge": "複製 README 徽章",
  "plugins.actions.openSourceGithub": "在 GitHub 開啟原始碼",
  "plugins.actions.openSource": "開啟原始碼",
  "plugins.actions.openHomepage": "開啟專案首頁",
  "plugins.actions.openMarketplace": "在外掛市場開啟",
  "app.brand": "Open Design",
  "app.brandPill": "研究預覽版",
  "app.brandSubtitle": "由 Nexu Labs 出品",
  "app.welcomeLoading": "正在載入工作區…",
  "settings.welcomeKicker": "",
  "settings.welcomeTitle": "歡迎使用 Open Design",
  "settings.welcomeSubtitle": "",
  "settings.onboardingCreateTitle": "從一句需求開始",
  "settings.onboardingCreateBody":
    "描述你想做的網站、應用、Deck、圖片或影片，Open Design 會建立專案，並保留可繼續編輯的產出。",
  "settings.onboardingMemoryTitle": "保存工作上下文",
  "settings.onboardingMemoryBody":
    "把偏好、專案事實和長期規則寫入 Memory，後續對話會自動帶上正確背景。",
  "settings.onboardingMemoryCalloutTitle": "已儲存到你的記憶",
  "settings.onboardingMemoryCalloutBody":
    "這些回答會構成你的記憶檔案。Open Design 會在每個任務中重複使用它，並在你工作時持續學習。",
  "settings.onboardingMemoryBenefitIntent": "從一句簡短需求就能理解你的意圖",
  "settings.onboardingMemoryBenefitFewerQuestions": "跳過重複的設定提問",
  "settings.onboardingMemoryBenefitPersonalized":
    "依你的角色、受眾和品味量身打造產出",
  "settings.onboardingSystemsTitle": "接入你的設計系統",
  "settings.onboardingSystemsBody":
    "選擇或建立品牌系統，讓生成結果跟隨真實的顏色、字體和產品語言。",
  "settings.onboardingExecutionTitle": "選擇生成方式",
  "settings.onboardingExecutionBody":
    "官方 CLI，一鍵配置、開箱即用。一個 Key 自由選擇海量模型，價格更優惠。",
  "settings.onboardingAmrCloudBenefitOfficial": "官方推薦",
  "settings.onboardingAmrCloudBenefitReady": "免部署即用",
  "settings.onboardingAmrCloudBenefitModels": "支援 Claude Opus 4.8",
  "settings.onboardingAmrCloudBenefitPricing": "SOTA Harness",
  "settings.onboardingAmrCloudUpcomingLabel": "即將支援",
  "settings.onboardingAmrCloudUpcomingImageVideo": "生圖/影片",
  "settings.onboardingAmrCloudUpcomingSkills": "海量 Skills",
  "settings.onboardingAmrCloudUpcomingRouting": "智慧路由",
  "settings.onboardingAmrModelSourceLabel": "Open Design Cloud",
  "settings.onboardingAmrCloudAuthorizeAction": "授權使用",
  "settings.onboardingAmrCloudAuthorizedAction": "已授權",
  "settings.onboardingStepConnect": "連接",
  "settings.onboardingStepDesignSystem": "建構設計系統",
  "settings.onboardingStepProfile": "關於你",
  "settings.onboardingStepNewsletter": "保持關注",
  "settings.onboardingNewsletterTitle": "保持同步",
  "settings.onboardingNewsletterBody":
    "在信箱裡收到產品更新、新模版、設計系統與大使活動。選填——可以跳過。",
  "settings.onboardingConnectTitle": "選擇執行方式",
  "settings.onboardingConnectBody": "",
  "settings.onboardingCloudTitle": "登入 Open Design",
  "settings.onboardingCloudBody":
    "登入後可直接用雲端 AI 開始設計，無需任何複雜設定。",
  "settings.onboardingCloudSignIn": "登入 Open Design 雲端",
  "settings.onboardingCloudContinue": "繼續（已登入）",
  "settings.onboardingCloudAlternative": "使用本機 CLI 或自己的 API Key",
  "settings.onboardingCloudRights": "保留所有權利。",
  "settings.onboardingCloudOr": "或",
  "settings.onboardingGateTooltipNoRuntime":
    "後續流程由 AI 執行，請先選擇一種執行方式。",
  "settings.onboardingGateTooltipAmr":
    "後續流程由 AI 執行，請先登入 Open Design Cloud。",
  "settings.onboardingGateTooltipLocal":
    "後續流程由 AI 執行，請先選擇一個可用的本機 CLI。",
  "settings.onboardingGateTooltipByok":
    "後續流程由 AI 執行，請先填寫並測試通過你的模型 Key。",
  "settings.onboardingRecommended": "推荐",
  "settings.onboardingAmrCloudOfficialBadge": "官方",
  "settings.onboardingLocalTitle": "本地 Coding Agent",
  "settings.onboardingLocalBody":
    "使用已安裝的 CLI，如 Claude Code、Codex、Cursor、Gemini 或 OpenCode。",
  "settings.onboardingLocalAction": "開啟 CLI 設定",
  "settings.onboardingCliScanHint": "通常 5 到 10 秒內完成掃描。",
  "settings.onboardingByokTitle": "自己的模型 Key",
  "settings.onboardingByokBody": "使用你自己的模型服務憑證。",
  "settings.onboardingByokAction": "開啟 BYOK 設定",
  "settings.onboardingDesignTitle": "設計系統",
  "settings.onboardingDesignBody": "生成一次，後續複用。",
  "settings.onboardingDesignIntroGenerateTitle": "用既有內容生成",
  "settings.onboardingDesignIntroGenerateBody":
    "從 GitHub、本地程式碼倉庫、Figma 檔案，或現成圖片等內容資產中上傳你的設計系統。",
  "settings.onboardingDesignIntroReuseTitle": "後續產物直接複用",
  "settings.onboardingDesignIntroReuseBody":
    "後續生成原型、Slide 和其他內容時，都可以參考現有的字體、間距、Logo 樣式、色調等。",
  "settings.onboardingDesignIntroSkipTitle": "也可以先跳過",
  "settings.onboardingDesignIntroSkipBody":
    "現在不想生成也沒關係，可以直接進入產品。",
  "settings.onboardingGithubTitle": "從 GitHub 匯入",
  "settings.onboardingGithubBody": "使用前端倉庫。",
  "settings.onboardingUploadTitle": "上傳本地檔案",
  "settings.onboardingUploadBody": "添加專案文件、截圖、CSS、文件或素材。",
  "settings.onboardingPromptTitle": "用一句話生成",
  "settings.onboardingPromptBody": "描述產品或品牌。",
  "settings.onboardingProfileTitle": "關於你",
  "settings.onboardingProfileBody": "可選資訊，用於優化預設配置。",
  "settings.onboardingRoleLabel": "你的身份",
  "settings.onboardingOrgSizeLabel": "組織規模",
  "settings.onboardingUseCaseLabel": "使用場景",
  "settings.onboardingSourceLabel": "從哪裡聽說的",
  "settings.onboardingSourceX": "🐦 X / Twitter",
  "settings.onboardingSourceGithub": "🐙 GitHub",
  "settings.onboardingSourceYoutube": "▶️ YouTube",
  "settings.onboardingSourceTiktok": "🎵 TikTok",
  "settings.onboardingSourceReddit": "👽 Reddit",
  "settings.onboardingSourceLinkedin": "💼 LinkedIn",
  "settings.onboardingSourceMetaSocial": "📸 Instagram / Threads / Facebook",
  "settings.onboardingSourceSearch": "🔍 搜尋（Google / Bing）",
  "settings.onboardingSourceAiTool": "🤖 AI 工具（ChatGPT / Perplexity）",
  "settings.onboardingSourceFriend": "👥 朋友或同事",
  "settings.onboardingSourceCommunity": "💬 Discord / 社群",
  "settings.onboardingSourceEmail": "✉️ 電子郵件 / 電子報",
  "settings.onboardingSourceBlog": "📝 部落格 / 文章",
  "settings.onboardingSourceOther": "✨ 其他",
  "settings.onboardingSourceOtherPlaceholder": "告訴我們具體在哪（選填）",
  "settings.onboardingSelectPlaceholder": "請選擇",
  "settings.onboardingSelectMultiplePlaceholder": "可選擇多個",
  "settings.onboardingOrgSolo": "個人使用（1 人）",
  "settings.onboardingOrgTeam": "小團隊（2-10 人）",
  "settings.onboardingOrgStartup": "新創 / 中小企業（11-50 人）",
  "settings.onboardingOrgGrowth": "成長期公司（51-200 人）",
  "settings.onboardingOrgMidMarket": "中大型公司（201-1000 人）",
  "settings.onboardingOrgEnterprise": "大型企業（1000+ 人）",
  "settings.onboardingRolePm": "📋 產品經理",
  "settings.onboardingRoleDesigner": "🎨 設計師",
  "settings.onboardingRoleEngineer": "💻 研發",
  "settings.onboardingRoleMarketing": "📣 行銷",
  "settings.onboardingRoleAgency": "📣 行銷代理商",
  "settings.onboardingRoleGrowth": "📈 增長",
  "settings.onboardingRoleOps": "⚙️ 營運",
  "settings.onboardingRoleFounder": "🚀 創辦人 / 管理者",
  "settings.onboardingRoleStudent": "🎓 學生 / 教育者",
  "settings.onboardingRoleOther": "✨ 其他",
  "settings.onboardingUseProduct": "🎨 產品設計",
  "settings.onboardingUseDesignSystem": "🧩 設計系統",
  "settings.onboardingUsePrototype": "📱 原型 / 應用介面",
  "settings.onboardingUseLanding": "🌐 落地頁",
  "settings.onboardingUseAds": "📣 廣告 / 社群內容",
  "settings.onboardingUseDashboard": "📊 儀表板 / 內部工具",
  "settings.onboardingUseDeck": "🖥️ 簡報 / 提案",
  "settings.onboardingUseMarketing": "📈 行銷 / 成長",
  "settings.onboardingUseEngineering": "🤝 工程交付",
  "settings.onboardingUseAgency": "💼 代理商 / 客戶專案",
  "settings.onboardingBack": "上一步",
  "settings.onboardingContinue": "继续",
  "settings.onboardingFinish": "完成設定",
  "settings.kicker": "設定",
  "settings.title": "執行模式",
  "settings.subtitle": "在本機 CLI 與 BYOK 之間選擇。",
  "settings.modeAria": "執行模式",
  "settings.protocolAria": "API 協定",
  "settings.modeDaemon": "本機 CLI",
  "settings.modeDaemonHelp": "透過本機的程式碼代理 CLI 執行",
  "settings.modeDaemonOffline": "背景守護程序未執行",
  "settings.modeDaemonOfflineMeta": "守護程序未執行",
  "settings.modeDaemonInstalledMeta": "已安裝 {count} 個",
  "settings.modeApi": "API 提供方",
  "settings.modeApiMeta": "BYOK",
  "settings.byokNoFileToolsNotice":
    "BYOK 無法讀取、寫入或編輯專案檔案。需要變更程式碼時，請使用 Local CLI。",
  "settings.byokDraftNotice":
    "必填項補齊前，此設定只會儲存為草稿；目前的執行設定將繼續維持生效。",
  "settings.codeAgent": "程式碼代理",
  "settings.codeAgentHint": "選擇用來執行提示詞的 CLI。",
  "settings.rescan": "↻ 重新掃描",
  "settings.rescanTitle": "重新掃描 PATH",
  "settings.rescanRunning": "掃描中...",
  "settings.rescanSuccess": "掃描完成，{count} 個可用。",
  "settings.designSystemRenameFailed":
    "重新命名失敗，請檢查背景守護程序後重試。",
  "settings.rescanFailed": "掃描失敗，請檢查背景守護程序後重試。",
  "settings.test": "測試",
  "settings.testTitle": "傳送極小的測試提示以驗證連線",
  "settings.testRunning": "正在測試連線…",
  "settings.byokReadyToTest": "可測試連線",
  "settings.testCancel": "取消",
  "settings.testRetry": "重試測試",
  "settings.required": "必填",
  "settings.testMissingFields": "填寫 {fields} 以測試連線。",
  "settings.testSuccessApi": "已連線。{ms} 毫秒回應 — '{sample}'",
  "settings.testSuccessCli": "{agentName} 在 {ms} 毫秒內回應 — '{sample}'",
  "settings.testAuthFailed": "驗證失敗，請檢查 API 金鑰。",
  "settings.testForbidden": "存取被拒絕，請確認帳戶、地區或組織。",
  "settings.testNotFoundModel": "此端點找不到模型 '{model}'。",
  "settings.testInvalidModelId":
    "模型 ID '{model}' 格式無效。自訂 ID 必須以字母或數字開頭，且不能包含空格。",
  "settings.testInvalidBaseUrl": "Base URL 無效或無法連線。",
  "settings.testRateLimited": "供應商對測試進行了限流，設定看起來有效。",
  "settings.testUpstream": "供應商回傳 {status}，請稍後再試。",
  "settings.testTimeout": "測試在 {ms} 毫秒後逾時。",
  "settings.testAgentMissing": "{agentName} 未安裝，或不在 PATH 中。",
  "settings.testAgentSpawn": "無法啟動 {agentName}：{detail}。",
  "settings.testUnknown": "測試失敗：{detail}",
  "settings.agentInstall.install": "安裝",
  "settings.agentInstall.docs": "文件",
  "settings.agentInstall.pathHint":
    "如果你透過 npm 或 Homebrew 安裝了 CLI，但仍顯示為未安裝，請確認該工具的 bin 目錄已加入 Open Design daemon 繼承的 PATH（在 macOS 上，Terminal 與 GUI 應用的 PATH 可能不同）。請參閱 QUICKSTART.md（「Local agent CLI and PATH」章節）。",
  "settings.agentInstall.stepOpenLinks":
    "在目標代理卡片上開啟「安裝」或「文件」連結。",
  "settings.agentInstall.stepAuth":
    "返回 Open Design 前，請先在對應 CLI 完成驗證（登入或新增 API 憑證）。",
  "settings.agentInstall.stepRescan": "在此區域點擊「重新掃描」。",
  "settings.agentInstall.stepSelect": "當代理顯示為已安裝後，選擇該代理卡片。",
  "settings.noAgentsDetected":
    "尚未偵測到任何代理。請安裝 Claude Code、Codex、OpenCode、Cursor Agent 或 Qwen 其中之一，然後點擊「重新掃描」。",
  "settings.agentInstalledGroup": "你的 CLI（{count}）",
  "settings.agentInstallGroup": "可安裝（{count}）",
  "settings.agentAuthRequired": "需要認證",
  "settings.agentAuthUnknown": "認證狀態未知",
  "settings.amrCloud": "Open Design Cloud",
  "settings.amrAuthorize": "授權",
  "settings.amrBenefitOfficial": "官方維護",
  "settings.amrBenefitLowerPrice": "價格更低",
  "settings.amrBenefitManyModels": "海量模型",
  "settings.amrPromoBonus": "限時儲值贈 100%",
  "settings.amrSignInToContinue": "授權後繼續",
  "settings.amrSignIn": "登入",
  "settings.amrSignedIn": "已登入",
  "settings.amrWalletBalance": "錢包餘額",
  "settings.amrWalletUnavailable": "餘額暫不可用",
  "settings.amrWalletUpdatedAt": "更新於 {time}",
  "settings.amrWalletCached": "快取",
  "settings.amrWalletRefresh": "重新整理",
  "settings.amrWalletRefreshTitle": "重新整理 Open Design Cloud 錢包餘額",
  "settings.amrNotSignedIn": "未授權",
  "settings.amrSigningIn": "登入中…",
  "settings.amrActivationHint": "沒有彈出登入頁?點擊下方按鈕重新喚起",
  "settings.amrActivationBrowserFailed":
    "無法自動開啟瀏覽器,請開啟下方的登入頁繼續。",
  "settings.amrActivationOpen": "開啟登入頁",
  "settings.amrCancelSignIn": "取消登入",
  "settings.amrAccountStatus": "Open Design Cloud 帳戶狀態",
  "settings.amrConsole": "管理",
  "settings.amrLoginErrorCompact": "Open Design Cloud 登入失敗。",
  "settings.advanced": "進階",
  "settings.amrLogin": "登入",
  "settings.amrLogout": "登出",
  "settings.amrLoggingIn": "登入中…",
  "settings.amrLoggingOut": "登出中…",
  "settings.amrLoggedInAs": "已登入 {email}",
  "settings.amrLoggedInWithPlan": "已登入 {email} · {plan}",
  "settings.amrLoggedInPill": "已登入",
  "settings.amrNotLoggedIn": "未授權",
  "settings.apiSection": "API 設定",
  "settings.quickFillProvider": "快速填入提供方",
  "settings.providerPreset": "閘道預設",
  "settings.protocolGroupProtocols": "協定",
  "settings.protocolGroupGateways": "閘道",
  "settings.customProvider": "自訂提供方",
  "settings.apiKey": "API Key",
  "settings.apiKeyGetLink": "取得金鑰 ↗",
  "settings.showKey": "顯示 Key",
  "settings.hideKey": "隱藏 Key",
  "settings.show": "顯示",
  "settings.hide": "隱藏",
  "settings.model": "模型",
  "settings.apiKeyInvalid": "API key 無效。",
  "settings.apiKeyCleaned": "已移除 API key 中多餘的空白字元。",
  "settings.modelsLoadedFromAccount": "✓ 已從您的帳戶載入 {count} 個模型。",
  "settings.modelsLoadedCount": "✓ 已載入 {count} 個模型。",
  "settings.modelSourceAccount": "來自你的帳戶",
  "settings.modelSourceSuggested": "建議",
  "modelCapability.standard": "Standard",
  "modelCapability.advanced": "Advanced",
  "modelCapability.bestQuality": "Best Quality",
  "modelCapability.standardDescription": "Solid quality for regular tasks.",
  "modelCapability.advancedDescription": "Stronger quality for more demanding tasks.",
  "modelCapability.bestQualityDescription": "Best output quality for the most demanding work.",
  "modelCost.upToHalf": "低成本",
  "modelCost.halfToOne": "中成本",
  "modelCost.oneToFour": "高成本",
  "modelCost.overFour": "最高成本",
  "settings.fetchModels": "取得模型",
  "settings.fetchModelsTitle": "從此供應商取得可用模型",
  "settings.fetchModelsRunning": "正在擷取模型…",
  "settings.fetchModelsMissingFields": "填寫 {fields} 以取得模型。",
  "settings.fetchModelsInvalidBaseUrl": "輸入有效的 Base URL 以取得模型。",
  "settings.fetchModelsUnsupportedAzure":
    "Azure OpenAI 使用部署名稱，因此這裡無法進行模型探索。",
  "settings.fetchModelsUnsupportedOllama":
    "Ollama Cloud 模型探索功能尚未提供。請選擇或輸入模型。",
  "settings.fetchModelsSuccess": "已取得 {count} 個模型。",
  "settings.fetchModelsEmpty": "未傳回相容的文字模型。",
  "settings.fetchModelsUnsupported": "此通訊協定不支援模型探索。",
  "settings.fetchModelsFailed": "無法取得模型：{detail}",
  "settings.suggestedModelsHint":
    "這些是此協定的建議模型。你的提供方可能支援不同的模型。",
  "settings.baseUrl": "Base URL",
  "settings.baseUrlInvalid": "使用公網 http:// 或 https:// URL。",
  "settings.baseUrlCustomize": "自訂",
  "settings.baseUrlDefaultHint": "預設端點，通常不需要修改。",
  "settings.azureBaseUrlPlaceholder": "https://my-resource.openai.azure.com",
  "settings.azureBaseUrlHint":
    "Find this in Azure portal → your resource → Endpoint.",
  "settings.azureDeploymentModel": "部署名稱",
  "settings.azureCustomDeploymentName": "Custom deployment name",
  "settings.azureDeploymentModelHint":
    "對於 Azure OpenAI，此欄位會作為 /openai/deployments/<model> 中的部署名稱使用。請填入你在 Azure 中建立的部署名稱。",
  "settings.azureModelFetchHint":
    "請輸入您 Azure 資源中的部署名稱。Azure 部署無法自動擷取。",
  "settings.apiVersion": "API 版本",
  "settings.byokImageModel": "圖片生成模型",
  "settings.byokVideoModel": "影片生成模型",
  "settings.byokVideoI2vHint":
    "圖生視頻模型:需要參考圖(未指定時自動使用專案中最新的圖片)",
  "settings.byokSpeechModel": "語音生成模型",
  "settings.byokSpeechVoice": "音色",
  "settings.byokModelDefaultOption": "預設",
  "settings.maxTokens": "最大 tokens（可選）",
  "settings.maxTokensHint":
    "回應長度上限。每個 model 有調過的預設值（在 placeholder 顯示），留空即使用，輸入數字則覆蓋。",
  "settings.apiHint":
    "請求會透過本機 daemon 代理送到你設定的 Base URL。Key 只儲存在目前瀏覽器中，並隨提供方請求送出。",
  "settings.skipForNow": "暫時跳過",
  "settings.getStarted": "開始使用",
  "settings.envConfigure": "執行模式",
  "settings.localCli": "本機 CLI",
  "settings.anthropicApi": "Anthropic API",
  "settings.noAgentSelected": "尚未選擇代理",
  "settings.language": "介面語言",
  "settings.languageHint": "切換介面語言，設定僅儲存在當前瀏覽器。",
  "settings.appearance": "外觀",
  "settings.appearanceHint": "選擇淺色、深色或跟隨系統設定。",
  "settings.themeSystem": "系統",
  "settings.themeLight": "淺色",
  "settings.themeDark": "深色",
  "settings.agentModelHead": "模型：",
  "settings.modelPicker": "模型",
  "settings.modelSourceLive": "來自 CLI 的即時列表",
  "settings.modelSourceFallback": "內建列表",
  "settings.reasoningPicker": "推理強度",
  "settings.serviceTierPicker": "服務層級",
  "settings.modelPickerHint":
    "當 CLI 提供 `models` 命令時會自動拉取。選擇「預設」則沿用 CLI 自身的設定；選擇「自訂」可手動輸入任何 CLI 支援的模型 id。",
  "settings.modelPickerLiveHint":
    "模型列表來自這個 CLI；選「預設」會沿用 CLI 自己的設定。",
  "settings.modelPickerLiveCatalogOnlyHint": "模型列表來自這個 CLI。",
  "settings.modelPickerFallbackHint":
    "正在顯示內建預設值。點擊「重新掃描」可從 CLI 拉取即時模型。",
  "settings.cliEnvTitle": "進階：代理與自訂路徑",
  "settings.cliEnvHint":
    "用於覆蓋所選 CLI 的底層環境變數：API key、代理 base URL、自訂 home 或非標準可執行檔路徑。不填 base URL 時，CLI 會使用自己的預設端點。密鑰只保存在本機應用設定中，且只傳給所選 CLI。",
  "settings.cliEnvClaudeConfigDir": "Claude Code 設定目錄",
  "settings.cliEnvClaudeBaseUrl": "Claude proxy base URL",
  "settings.cliEnvClaudeApiKey": "Claude CLI API key",
  "settings.cliEnvCodexHome": "Codex home",
  "settings.cliEnvCodexBin": "Codex 可執行檔路徑",
  "settings.cliEnvCodexBaseUrl": "Codex/OpenAI proxy base URL",
  "settings.cliEnvCodexApiKey": "Codex/OpenAI CLI API key",
  "settings.modelCustom": "自訂（在下方填寫）…",
  "settings.modelCustomLabel": "自訂模型 id",
  "settings.modelCustomPlaceholder": "例如 anthropic/claude-sonnet-4-6",
  "settings.mediaProviders": "媒體生成提供商",
  "settings.mediaProvidersHint":
    "圖片、影片、音訊生成的 API key。存於本機並同步到本地守護程序。",
  "settings.mcpServerTitle": "MCP 伺服器",
  "settings.mcpServerHint":
    "將 Open Design 作為 MCP 伺服器暴露給你的編碼代理。",
  "settings.externalMcpTitle": "外部 MCP",
  "settings.externalMcpHint":
    "接入外部服務的 MCP 工具（Higgsfield、GitHub 等）。",
  "settings.mediaProviderApiKey": "API key",
  "settings.mediaProviderBaseUrl": "Base URL",
  "settings.mediaProviderConfigured": "已設定",
  "settings.mediaProviderUnset": "未設定",
  "settings.mediaProviderClear": "清除",
  "settings.mediaProviderClearConfirm":
    "清除已儲存的 {name} 設定？您需要再次輸入才能使用 {name}。",
  "settings.mediaProviderPlaceholder": "貼上 API key",
  "settings.mediaProviderBaseUrlPlaceholder": "覆蓋預設 Base URL",
  "settings.mediaProviderReload": "從本機守護程序重新載入",
  "settings.mediaProviderReloadError":
    "無法從本機守護程序重新載入媒體供應商設定。",
  "settings.mediaProviderReloadSuccess":
    "已從本機守護程序重新載入媒體供應商設定。",
  "settings.mediaProviderLoadError":
    "無法從本機守護程序載入媒體供應商設定。目前將使用瀏覽器中儲存的設定。",
  "settings.mediaProviderComingSoonHint":
    "我們在路線圖中追蹤這些提供者；守護程式尚未提供客戶端，因此暫無可配置項。",
  "settings.privacy": "隱私",
  "settings.privacyHint": "與 Open Design 團隊共享哪些資料",
  "settings.privacyConsentKicker": "協助我們改進 Open Design",
  "settings.privacyConsentLead":
    "分享使用資料後，我們能更了解 Open Design 在真實工作流裡的表現，並優先改進真正影響體驗的地方。",
  "settings.privacyConsentFooter": "你可以隨時在 設定 → 隱私 中修改這些選項。",
  "settings.privacyConsentShare": "分享",
  "settings.privacyConsentDecline": "不分享",
  "settings.privacyConsentAccept": "我知道了",
  "settings.privacyConsentBannerFooter":
    "預設開啟資料分享。你可以隨時在 設定 → 隱私 中關閉。",
  "settings.privacyConsentPolicyLink": "閱讀隱私政策",
  "settings.privacyMetrics": "匿名指標",
  "settings.privacyMetricsHint":
    "執行次數、token 用量、錯誤率、耗時等基礎使用指標。",
  "settings.privacyContent": "對話內容",
  "settings.privacyContentHint":
    "在移除金鑰等敏感資訊後，我們會使用 prompt、助手回覆、工具輸入/輸出，以及品質回看所需的上下文。",
  "settings.privacyInstallationId": "匿名 ID",
  "settings.privacyOptedOut": "已退出",
  "settings.privacyDataDeletion": "刪除我的資料",
  "settings.privacyDataDeletionHint":
    "輪換你的匿名 ID 並停止傳送。既有資料依保留政策自然過期。",
  "settings.about": "關於",
  "settings.aboutHint": "版本與執行環境詳情",
  "settings.appVersion": "版本",
  "settings.appChannel": "通道",
  "settings.appRuntime": "執行環境",
  "settings.appPlatform": "平台",
  "settings.appArchitecture": "架構",
  "settings.runtimePackaged": "已封裝應用程式",
  "settings.runtimeDevelopment": "開發環境",
  "settings.versionUnavailable": "守護程式離線時無法取得版本詳情。",
  "settings.allowSilentUpdates": "允許以後自動安裝應用內更新",
  "settings.allowSilentUpdatesDesc": "有可套用的應用內更新時，下次啟動將自動安裝。不會立刻升級目前版本。安裝器更新仍會先詢問。",
  "settings.installLatest": "安裝最新版本",
  "settings.alreadyLatest": "目前已是最新版本",
  "settings.mcpTitle": "MCP server",
  "settings.mcpHint":
    "讓其他專案中的程式碼代理（Claude Code、Cursor、VS Code、Antigravity、Zed、Windsurf）讀取您的 Open Design 專案。您可以直接將設計匯入應用程式，無需先匯出 zip。",
  "settings.mcpDaemonError":
    "無法連線到本地守護程序以解析安裝路徑（{error}）。請確認 Open Design 正在執行，然後重新開啟此面板。",
  "settings.mcpBuildDaemon": "請先建置守護行程。",
  "settings.mcpNodeMissing": "缺少 Node 執行檔。",
  "settings.mcpBuildHint":
    "缺少 apps/daemon/dist/cli.js。請執行 `pnpm --filter @open-design/daemon build` 後重新整理。",
  "settings.mcpMethodCli": "CLI 指令",
  "settings.mcpInstructionCli": "在您的終端機中執行此指令。",
  "settings.mcpMethodToml": "TOML 設定檔",
  "settings.mcpInstructionCodex":
    "將此表格附加到 {path}。Codex CLI 與 Codex IDE 擴充功能共用相同的設定。",
  "settings.mcpMethodOneClick": "一鍵安裝",
  "settings.mcpInstructionCursor":
    "點擊「在 Cursor 中安裝」以透過核准對話框安裝，或將此 JSON 合併至 {path}。",
  "settings.mcpDeeplinkInstallCursor": "在 Cursor 中安裝",
  "settings.mcpMethodJson": "JSON 設定檔",
  "settings.mcpInstructionKiro":
    "開啟 {path} 並合併此 JSON。若要使用 workspace 層級設定，請使用 .kiro/settings/mcp.json。",
  "settings.mcpInstructionCopilot":
    "開啟 Command Palette（{shortcut}），執行「MCP: Open User Configuration」，然後合併此 JSON。Copilot Chat 必須處於 Agent 模式，工具才會顯示。",
  "settings.mcpInstructionAntigravity":
    "在 Antigravity 中：Agent 面板「⋯」選單 → MCP Servers → Manage MCP Servers → View raw config。合併此 JSON。",
  "settings.mcpInstructionZed":
    "開啟 Zed Settings（{shortcut}），然後將此內容合併至最上層物件。Zed 使用「context_servers」，而非「mcpServers」。",
  "settings.mcpInstructionWindsurf":
    "開啟 {path}（或使用 Cascade 中的 MCPs 圖示 → Configure）並合併：",
  "settings.mcpCopyAria": "複製 MCP 設定片段",
  "settings.mcpResolvingFailed": "# 解析路徑失敗，請見上方錯誤",
  "settings.mcpLoadingPaths": "# 正在從本地守護行程載入安裝路徑…",
  "settings.mcpCopied": "已複製",
  "settings.mcpCopy": "複製",
  "settings.mcpCursorApproval": "Cursor 會在寫入設定檔前彈出核准對話框。",
  "settings.mcpCodexOneClickInstall": "安裝至 Codex",
  "settings.mcpCodexOneClickUninstall": "從 Codex 移除",
  "settings.mcpCodexOneClickUnavailable":
    "在 PATH 上找不到 Codex CLI — 請安裝 Codex 或手動貼上程式碼片段。",
  "settings.mcpCodexInstallSuccess":
    "已安裝。請重新啟動 Codex 以載入新的伺服器。",
  "settings.mcpCodexUninstallSuccess": "已從 Codex 移除。",
  "settings.mcpCodexBusy": "處理中…",
  "settings.mcpCodexInstallError": "操作失敗：{error}",
  "settings.mcpRestartNote": "重新啟動您的客戶端以套用新的 server。",
  "settings.mcpRestartDetail":
    "大部分編輯器只在啟動時載入 MCP server。在 Cursor / VS Code / Antigravity / Windsurf 中，您可以從 Command Palette 執行「Developer: Reload Window」，無需完整重新啟動。Zed 與 Claude Code 則需要結束並重新開啟。",
  "settings.mcpCapabilitiesTitle": "您的 agent 可以執行的操作",
  "settings.mcpCapabilityRead":
    "讀取或搜尋專案中的任何檔案（HTML、JSX、CSS、JSON、SVG、Markdown）。",
  "settings.mcpCapabilityPull":
    "透過單一呼叫拉取設計套件：包含進入點檔案以及所有引用的 CSS 變數、元件與字型。",
  "settings.mcpCapabilityDefault":
    "預設使用您在 Open Design 中開啟的專案與檔案，因此您可以說「在我的應用程式中建置這個」，無需重新說明是哪個設計。",
  "settings.mcpRunningNote":
    "Open Design 必須正在執行，MCP 工具呼叫才能成功。如果您在開啟 Open Design 之前就已啟動 coding agent，請重新啟動 agent，使其能夠連線到正在執行的守護行程。",
  "entry.tabDesigns": "我的設計",
  "entry.tabTemplates": "範本",
  "entry.tabDesignSystems": "設計系統",
  "entry.tabConnectors": "連接器",
  "entry.openSettingsTitle": "設定",
  "entry.openSettingsAria": "開啟設定",
  "entry.discordLabel": "加入 Discord",
  "entry.discordAria": "加入 Open Design Discord",
  "entry.discordAriaWithOnline": "加入 Open Design Discord - {online}",
  "entry.discordOnlineLabel": "{count} 在線",
  "entry.followXLabel": "在 X 上追蹤 @OpenDesignHQ",
  "entry.followThreadsLabel": "Follow Open Design on Threads",
  "entry.followInstagramLabel": "在 Instagram 上追蹤 @opendesign.ai",
  "entry.followLinkedinLabel": "在 LinkedIn 上追蹤 Open Design",
  "entry.followXiaohongshuLabel": "在小紅書上追蹤 Open Design",
  "entry.youtubeLabel": "Open Design on YouTube",
  "entry.resizeAria": "調整側邊欄寬度",
  "entry.loadingWorkspace": "正在載入工作區…",
  "entry.useEverywhereTitle": "隨處使用",
  "entry.useEverywhereAria": "開啟「隨處使用」指南（CLI、MCP、HTTP、Skills）",
  "entry.workspaceTeamsLabel": "團隊版",
  "entry.workspaceTeamsTitle": "團隊版工作區 — 告訴我們你的團隊需求",
  "entry.workspaceTeamsAria": "開啟團隊版工作區頁面",
  "entry.navExpand": "展開側欄",
  "entry.navCollapse": "收合側欄",
  "entry.navNewProject": "新建專案",
  "entry.navHome": "主頁",
  "entry.navProjects": "專案",
  "entry.navTasks": "自動化",
  "entry.navPlugins": "外掛",
  "entry.navDesignSystems": "設計體系",
  "entry.navBrands": "品牌套件",
  "entry.navIntegrations": "整合",
  "messageCenter.openAria": "開啟消息中心",
  "messageCenter.unreadCount": "{count} 則未讀",
  "messageCenter.title": "消息中心",
  "messageCenter.subtitle": "Open Design 更新、平台公告和權益提醒",
  "messageCenter.filterAll": "全部",
  "messageCenter.filterUnread": "未讀",
  "messageCenter.filterRead": "已讀",
  "messageCenter.markAllRead": "全部標為已讀",
  "messageCenter.emptyAllTitle": "暫時沒有消息",
  "messageCenter.emptyUnreadTitle": "都看完了",
  "messageCenter.emptyReadTitle": "暫時沒有已讀消息",
  "messageCenter.emptyBody": "新消息會出現在這裡。",
  "messageCenter.close": "關閉消息中心",
  "messageCenter.desktopSettings": "桌面提醒設定",
  "messageCenter.desktopSettingsHint": "任務完成音效和系統通知仍在設定中管理。",
  "workspaceTabs.project": "專案",
  "workspaceTabs.pluginDetails": "外掛詳細資料",
  "workspaceTabs.marketplace": "市集",
  "homeHero.title": "今天想和你的 Agent 一起設計什麼？",
  "homeHero.startWithTemplate": "從範本開始…",
  "homeHero.startBlankProject": "…或建立一個空白專案",
  "homeHero.templatePicker.label": "範本",
  "homeHero.templatePicker.searchPlaceholder": "搜尋範本",
  "homeHero.templatePicker.projectTypes": "專案類型",
  "homeHero.templatesScrollHint": "向上捲動以探索更多範本",
  "homeHero.templatesCollapse": "收合範本",
  "homeHero.subtitlePrefix": "開源的 Claude Design 替代方案。",
  "homeHero.placeholder": "描述您想要產生的內容…",
  "homeHero.placeholderActive": "編輯範例查詢或撰寫您自己的查詢…",
  "homeHero.carousel.hint": "上傳檔案、連結設計系統，或描述你想創作的內容",
  "homeHero.carousel.onePageBrief": "撰寫一頁專案簡介",
  "homeHero.carousel.notesToDeck": "把我的筆記變成簡報",
  "homeHero.carousel.signupFlow": "設計一個註冊流程",
  "homeHero.carousel.improveBrief": "改進現有的專案簡介",
  "homeHero.carousel.loadingAnimation": "製作一個載入動畫",
  "homeHero.carousel.teamUpdateSlides": "為團隊匯報設計投影片",
  "homeHero.carousel.ordersDashboard": "做一個訂單追蹤儀表板原型",
  "homeHero.carousel.productDetail": "排版一個商品詳情頁",
  "homeHero.carousel.caseStudy": "梳理一個案例研究大綱",
  "homeHero.carousel.landingIntro": "為登陸頁設計一段簡短的開場",
  "homeHero.carousel.pitchDeck": "為新產品製作一份提案簡報",
  "homeHero.carousel.appIdea": "描述一個應用程式創意",
  "homeHero.carousel.landingLayout": "勾勒一個登陸頁版面",
  "homeHero.skills": "技能",
  "homeHero.addMenu": "新增內容",
  "homeHero.addPlugin": "新增外掛",
  "homeHero.addConnectors": "新增連接器",
  "homeHero.addMcp": "新增 MCP 伺服器",
  "homeHero.noPlugins": "尚無已安裝的外掛",
  "homeHero.noMcp": "尚無 MCP 伺服器",
  "homeHero.noConnectors": "尚無已連接的連接器",
  "homeHero.applying": "套用中…",
  "homeHero.pluginTitle": "外掛：{title}",
  "homeHero.pluginPrefix": "外掛：{title}",
  "homeHero.skillPrefix": "技能：{title}",
  "homeHero.removePlugin": "移除外掛",
  "homeHero.removePluginAria": "移除外掛 {title}",
  "homeHero.clearActivePlugin": "清除使用中的外掛",
  "homeHero.clearActiveSkill": "清除使用中的技能",
  "homeHero.contextItemsResolved": "已解析 {n} 個情境項目",
  "homeHero.removeFile": "移除檔案",
  "homeHero.contextSearchResults": "情境搜尋結果",
  "homeHero.contextSurfaces": "情境介面",
  "homeHero.loadingContext": "正在載入上下文…",
  "homeHero.noResults": "找不到「{query}」的結果。",
  "homeHero.searchPrompt": "搜尋檔案、外掛、技能、MCP 伺服器與連接器。",
  "homeHero.parameters": "{n} 個參數",
  "homeHero.details": "詳細資料",
  "homeHero.toRun": "執行",
  "homeHero.forNewLine": "換行",
  "homeHero.run": "執行",
  "homeHero.typeSomethingToRun": "輸入內容以執行",
  "homeHero.promptExamples": "範例提示詞",
  "homeHero.footer.designSystem": "風格",
  "homeHero.footer.autoDesignSystem": "自動",
  "homeHero.footer.autoDesignSystemSummary":
    "根據目前 Prompt 自動匹配合適的設計系統與視覺風格。",
  "homeHero.footer.ratio": "比例",
  "homeHero.footer.duration": "時長",
  "homeHero.footer.resolution": "解析度",
  "homeHero.footer.speakerNotes": "备注",
  "homeHero.footer.noSpeakerNotes": "無備忘稿",
  "homeHero.footer.availableCount": "{n} 个可用",
  "homeHero.footer.noMatches": "无匹配结果",
  "homeHero.moreShortcuts": "更多",
  "homeHero.railAria": "選擇專案類別或入門捷徑",
  "homeHero.subTypeAria": "選擇子類型",
  "homeHero.subTypeMore": "更多",
  "homeHero.confirmReplaceTitle": "取代目前的提示詞？",
  "homeHero.confirmReplaceBody": "使用 {title} 將取代目前輸入框中的文字。",
  "homeHero.confirmReplace": "取代",
  "homeHero.chip.prototype": "原型",
  "homeHero.chip.webClone": "網站復刻",
  "homeHero.chip.liveArtifact": "即時看板",
  "homeHero.chip.deck": "簡報",
  "homeHero.chip.image": "圖片",
  "homeHero.chip.video": "影片",
  "homeHero.chip.hyperframes": "HyperFrames",
  "homeHero.chip.webgl": "WebGL 體驗",
  "homeHero.chip.webglDesc": "著色器、3D 與生成式 GPU 視覺",
  "homeHero.chip.worker": "Worker 視覺化",
  "homeHero.chip.workerDesc": "離主執行緒模擬、粒子與資料視覺化",
  "homeHero.chip.audio": "音訊",
  "homeHero.chip.createBrandKit": "建立品牌套件",
  "homeHero.chip.createPlugin": "建立外掛",
  "homeHero.chip.figma": "從 Figma 匯入",
  "homeHero.chip.folder": "從資料夾匯入",
  "homeHero.chip.template": "從範本建立",
  "homeHero.chip.liveArtifactHint": "建立可即時預覽的互動式 HTML/CSS/JS 成品。",
  "homeHero.chip.hyperframesHint":
    "製作以 HTML 為基礎的動態效果：字幕、音訊反應視覺與場景轉場。",
  "homeHero.chip.createBrandKitHint":
    "從網站擷取一個品牌套件，然後在任意對話中套用它。",
  "homeHero.chip.createPluginHint":
    "編寫可重複使用的 Open Design 外掛並將其加入「我的外掛」。",
  "homeHero.chip.figmaHint": "將 Figma 畫格遷移至使用中的設計系統。",
  "homeHero.chip.folderHint": "匯入現有的本機資料夾並繼續編輯。",
  "homeHero.chip.templateHint": "從內建範本開始。",
  "homeHero.chip.wireframe": "線框圖",
  "homeHero.chip.mobile": "行動應用",
  "homeHero.chip.document": "文件",
  "homeHero.chip.prototypeDesc": "可互動的應用原型",
  "homeHero.chip.webCloneDesc": "依原始碼證據復刻網站",
  "homeHero.chip.wireframeDesc": "低保真畫面與流程",
  "homeHero.chip.mobileDesc": "iOS 與 Android 畫面",
  "homeHero.chip.deckDesc": "簡報與提案簡報",
  "homeHero.chip.documentDesc": "履歷、報告與 PDF",
  "homeHero.chip.imageDesc": "海報、圖形與插畫",
  "homeHero.chip.videoDesc": "短片、Reels 與宣傳片",
  "homeHero.chip.audioDesc": "配音、音樂與音效",
  "homeHero.chip.hyperframesDesc": "動態圖形與循環動畫",
  "homeHero.chip.liveArtifactDesc": "資料驅動的即時儀表板",
  "homeHero.chip.createBrandKitDesc": "從網站擷取品牌設計系統",
  "homeHero.chip.prototypeNext":
    "開啟對話,建構可逐輪打磨的高保真可點擊網頁原型。",
  "homeHero.chip.webCloneNext": "開啟使用 web-clone skill 的對話，先貼目標 URL，再偵察、復刻並稽核產物。",
  "homeHero.chip.wireframeNext":
    "開啟對話,先以低保真畫面與流程驗證結構,再進行視覺設計。",
  "homeHero.chip.mobileNext": "開啟對話,排版 iOS 與 Android 的行動端畫面。",
  "homeHero.chip.deckNext": "開啟對話,產生可簡報、可匯出的投影片。",
  "homeHero.chip.documentNext": "開啟對話,草擬精美的文件——履歷、報告或 PDF。",
  "homeHero.chip.imageNext": "開啟對話,產生符合品牌的圖片並持續迭代。",
  "homeHero.chip.videoNext": "開啟對話,產生可繼續打磨的短影片。",
  "homeHero.chip.audioNext": "開啟對話,建立配音、音樂或音效。",
  "homeHero.chip.webClonePromptSeed": "想要復刻的網站連結：",
  "homeWorkingDir.trigger": "選擇工作目錄",
  "homeWorkingDir.pick": "選擇目錄",
  "homeWorkingDir.replace": "修改工作目錄",
  "homeWorkingDir.recent": "最近使用的目錄",
  "homeWorkingDir.recentEmpty": "尚無最近使用的目錄",
  "homeWorkingDir.clear": "移除工作目錄",
  "homeWorkingDir.hint": "讓 Agent 可讀取該本機目錄（不會匯入 Design Files）",
  "homeWorkingDir.missing": "該工作目錄已不存在，請重新選擇",
  "homeWorkingDir.applyFailed": "無法設定工作目錄，該資料夾可能已不存在",
  "workingDirPicker.title": "目錄",
  "workingDirPicker.homeTitle": "預設存在本機儲存，點擊可選擇資料夾",
  "workingDirPicker.processing": "處理中…",
  "workingDirPicker.select": "本機儲存",
  "workingDirPicker.clearAria": "清除工作目錄",
  "workingDirPicker.replaceFailed": "替換工作目錄失敗",
  "workingDirPicker.unavailable": "未選擇目錄 — 啟動桌面版以使用原生選擇器",
  "workingDirPicker.openUnavailable": "請在桌面版中開啟此專案以顯示資料夾。",
  "workingDirPicker.openFailed": "無法顯示此資料夾",
  "workingDirPicker.showInFileManager": "在檔案管理器中顯示",
  "workingDirPicker.replace": "選擇資料夾…",
  "workingDirPicker.recent": "最近使用的目錄",
  "workingDirPicker.defaultLabel": "本機儲存",
  "handoff.toTarget": "交付給 {target}",
  "handoff.openInTarget": "在 {target} 中開啟",
  "handoff.openAction": "開啟",
  "handoff.menuTitle": "在哪個編輯器中開啟？",
  "handoff.action": "交付",
  "handoff.fallbackTitle": "未找到編輯器 - 使用 {target} 開啟",
  "handoff.chooseTargetAria": "選擇交付目標",
  "handoff.optionsAria": "交付選項",
  "handoff.editorSection": "透過編輯器開啟",
  "handoff.cliSection": "複製給 CLI",
  "handoff.clickOpen": "點擊開啟",
  "handoff.framework": "程式碼框架",
  "handoff.framework.react": "React",
  "handoff.framework.vue": "Vue.js",
  "handoff.framework.svelte": "Svelte",
  "handoff.framework.solid": "SolidJS",
  "handoff.framework.next": "Next.js",
  "handoff.framework.vanilla": "JS",
  "handoff.frameworkPrompt.react": "React",
  "handoff.frameworkPrompt.vue": "Vue.js",
  "handoff.frameworkPrompt.svelte": "Svelte",
  "handoff.frameworkPrompt.solid": "SolidJS",
  "handoff.frameworkPrompt.next": "Next.js / React",
  "handoff.frameworkPrompt.vanilla": "原生 JavaScript、HTML 和 CSS",
  "handoff.amrWebsite": "開啟 Open Design Cloud 官網",
  "handoff.copyPrompt": "複製提示詞",
  "handoff.copyPromptForTarget": "複製給 {target} 的提示詞",
  "handoff.copied": "已複製",
  "handoff.projectPathUnavailable": "尚未取得專案本機路徑，請稍後再試。",
  "handoff.copyFailed": "瀏覽器拒絕寫入剪貼簿，請稍後再試。",
  "handoff.promptIntro": "請基於這個 Open Design 專案的本機資料夾繼續實作：",
  "handoff.promptTarget": "目標",
  "handoff.promptCli": "CLI",
  "handoff.promptStepsLead": "你現在是在 {cli} 中接手，請：",
  "handoff.promptReadFiles":
    "先進入或讀取這個目錄，優先閱讀 DESIGN.md、README、現有 HTML/CSS/JS、素材和 package.json（如果存在）。",
  "handoff.promptKeepDesign":
    "保持目前的視覺、佈局、互動和素材，不要只描述方案。",
  "handoff.promptProduceCode":
    "產出或修改真實可執行的 {framework} 程式碼；如果專案已有更明確的工程棧，先說明衝突並優先保持可執行。",
  "handoff.promptVerify": "完成後告訴我執行、預覽和驗證命令。",
  "handoff.promptCommandHint": "如果要先切到專案目錄，可以用：",
  "handoff.promptProject": "專案",
  "handoff.promptProjectId": "專案 ID",
  "handoff.notInstalled": "未安裝",
  "handoff.notDetectedTitle": "{target} - 未在 $PATH 中偵測到",
  "designSystemPicker.select": "選擇設計系統",
  "designSystemPicker.loading": "正在載入設計系統…",
  "designSystemPicker.searchPlaceholder": "搜尋設計系統（標題 / 分類 / 摘要）",
  "designSystemPicker.searchCompactPlaceholder": "搜尋設計系統",
  "designSystemPicker.noneTitle": "不指定設計系統",
  "designSystemPicker.noneSummary": "讓模型自由發揮",
  "designSystemPicker.empty": "沒有符合的設計系統",
  "designSystemPicker.openPreview": "開啟預覽",
  "designSystemPicker.loadingPreview": "正在載入預覽…",
  "designSystemPicker.noPreview":
    "沒有預覽頁面 — 請在「設計系統」中查看完整預覽",
  "designSystemPicker.previewHint": "將滑鼠懸停在左側項目上查看預覽",
  "designSystemPicker.fullscreenAria": "{title} 全螢幕預覽",
  "designSystemPicker.closeFullscreen": "關閉全螢幕預覽",
  "designSystemPicker.closeEsc": "關閉 (Esc)",
  "designSystemPicker.previewFrameTitle": "{title} 預覽",
  "designSystemPicker.fullscreenFrameTitle": "{title} 全螢幕預覽",
  "recentProjects.title": "最近的專案",
  "recentProjects.viewAll": "檢視全部",
  "recentProjects.empty": "尚無專案 — 輸入提示以開始建立一個。",
  "pluginsHome.title": "社群",
  "pluginsHome.subtitle":
    "隨附於此執行環境、可立即使用的 Open Design 工作流程。挑選一個以載入起始提示，或瀏覽登錄檔取得更多。",
  "pluginsHome.browseRegistry": "瀏覽登錄檔",
  "pluginsHome.count": "{total} 個中的 {filtered} 個",
  "pluginsHome.loadingCatalog": "正在載入目錄…",
  "pluginsHome.emptyCatalog":
    "目錄是空的。內建外掛隨 Open Design 一同提供，應會自動出現在此處 — 若問題持續發生，請嘗試重新啟動 daemon。",
  "pluginsHome.emptyFiltered": "沒有符合目前篩選條件的外掛程式。",
  "pluginsHome.clearFilters": "清除篩選條件",
  "pluginsHome.modeAria": "外掛程式模式",
  "pluginsHome.featured": "已儲存",
  "pluginsHome.totalInCatalog": "型錄中有 {n} 個",
  "pluginsHome.categoryFilterAria": "類別篩選",
  "pluginsHome.subcategoryFilterAria": "{label} 子類別篩選",
  "pluginsHome.allCategory": "所有{label}",
  "pluginsHome.searchPlaceholder": "搜尋外掛…",
  "pluginsHome.searchAria": "搜尋外掛程式",
  "pluginsHome.clearSearch": "清除搜尋",
  "pluginsHome.sortAria": "排序方式",
  "pluginsHome.sortHot": "熱門",
  "pluginsHome.sortNewest": "最新",
  "pluginsHome.facet.import": "匯入",
  "pluginsHome.facet.create": "建立",
  "pluginsHome.facet.export": "匯出",
  "pluginsHome.facet.share": "分享",
  "pluginsHome.facet.deploy": "部署",
  "pluginsHome.facet.refine": "優化",
  "pluginsHome.facet.extend": "擴充",
  "pluginsHome.facet.figma": "Figma",
  "pluginsHome.facet.github": "GitHub",
  "pluginsHome.facet.codeFolder": "程式碼／資料夾",
  "pluginsHome.facet.url": "URL",
  "pluginsHome.facet.screenshot": "螢幕擷取畫面",
  "pluginsHome.facet.pdf": "PDF",
  "pluginsHome.facet.pptx": "PPTX",
  "pluginsHome.facet.framer": "Framer",
  "pluginsHome.facet.webflow": "Webflow",
  "pluginsHome.facet.slides": "投影片",
  "pluginsHome.facet.publicLink": "公開連結",
  "pluginsHome.facet.githubPr": "GitHub PR",
  "pluginsHome.facet.githubGist": "GitHub Gist",
  "pluginsHome.subfacet.business-dashboards": "數據儀表板",
  "pluginsHome.subfacet.app-prototypes": "應用",
  "pluginsHome.subfacet.landing-marketing": "著陸頁 / 行銷",
  "pluginsHome.subfacet.developer-tools": "開發者工具",
  "pluginsHome.subfacet.docs-reports": "文件 / 報告",
  "pluginsHome.subfacet.brand-design": "品牌 / 設計",
  "pluginsHome.subfacet.pitch-business": "提案 / 商務",
  "pluginsHome.subfacet.course-training": "課程 / 培訓",
  "pluginsHome.subfacet.reports-briefings": "報告 / 簡報",
  "pluginsHome.subfacet.product-sales": "產品 / 銷售",
  "pluginsHome.subfacet.engineering-talks": "技術分享",
  "pluginsHome.subfacet.creative-decks": "創意簡報",
  "pluginsHome.subfacet.ui-product-mockups": "UI / 產品樣機",
  "pluginsHome.subfacet.brand-visuals": "品牌 / Logo",
  "pluginsHome.subfacet.storyboards-motion-refs": "分鏡",
  "pluginsHome.subfacet.social-content": "社群 / 內容",
  "pluginsHome.subfacet.avatar-portrait": "頭像 / 人像",
  "pluginsHome.subfacet.illustration-style": "插畫 / 風格",
  "pluginsHome.subfacet.motion-effects": "動態 / 特效",
  "pluginsHome.subfacet.social-short-form": "社群 / 短影音",
  "pluginsHome.subfacet.marketing-product": "行銷 / 產品",
  "pluginsHome.subfacet.data-explainers": "數據 / 解說",
  "pluginsHome.subfacet.cinematic-story": "電影感 / 敘事",
  "pluginsHome.commercialCategory.student-coursework": "學生作業",
  "pluginsHome.commercialCategory.corporate-strategy": "企業策略",
  "pluginsHome.commercialCategory.professional-training": "專業培訓",
  "pluginsHome.commercialCategory.b2b-sales": "B2B 銷售",
  "pluginsHome.commercialCategory.academic-research": "學術研究",
  "pluginsHome.commercialCategory.marketing-gtm": "市場增長",
  "pluginsHome.commercialCategory.data-finance": "數據與財務",
  "pluginsHome.commercialCategory.fundraising-pitch": "融資路演",
  "pluginsHome.commercialCategory.government-policy": "政府與政策",
  "pluginsHome.commercialCategory.product-management": "產品管理",
  "pluginsHome.commercialCategory.consulting": "顧問諮詢",
  "pluginsHome.commercialCategory.career": "職涯發展",
  "pluginsHome.commercialCategory.ai-literacy": "AI 素養",
  "pluginsHome.commercialCategory.life": "生活故事",
  "pluginsHome.commercialCategory.design-craft": "設計打磨",
  "pluginsView.lede":
    "瀏覽已安裝的工作流程、探索登錄檔項目、管理來源，並為團隊散布準備外掛程式。",
  "pluginsView.importPlugin": "匯入外掛程式",
  "pluginsView.agentContext": "Agent 情境",
  "pluginsView.summaryAria": "外掛程式摘要",
  "pluginsView.areasAria": "外掛程式領域",
  "pluginsView.loading": "正在載入外掛…",
  "pluginsView.tab.installed": "已安裝",
  "pluginsView.tab.available": "可用",
  "pluginsView.tab.sources": "來源",
  "pluginsView.tab.team": "團隊",
  "pluginsView.tabHint.installed": "您的外掛程式",
  "pluginsView.tabHint.available": "來自來源",
  "pluginsView.tabHint.sources": "型錄",
  "pluginsView.tabHint.team": "企業版",
  "pluginsView.installedTitle": "已安裝的外掛程式",
  "pluginsView.installedSubtitle": "您從市集來源匯入或安裝的外掛程式。",
  "pluginsView.installedEmpty":
    "尚無已安裝的使用者外掛程式。請使用「建立／匯入」，或安裝某個「可用」項目。",
  "pluginsView.availableTitle": "可從來源取得",
  "pluginsView.availableSubtitle": "從已設定的市集探索到的型錄項目。",
  "pluginsView.availableFiltersAria": "可用外掛程式篩選",
  "pluginsView.searchAvailableAria": "搜尋可用外掛程式",
  "pluginsView.searchAvailablePlaceholder": "搜尋可用外掛程式",
  "pluginsView.clearAvailableSearch": "清除可用外掛程式搜尋",
  "pluginsView.source": "來源",
  "pluginsView.availableEmptyInstalled":
    "目前沒有可用的項目。已安裝的目錄項目會從「可用」中移除；解除安裝其中一項即可使其再次可用。",
  "pluginsView.availableEmptyFiltered": "沒有符合篩選條件的可用項目。",
  "pluginsView.availableEmptyNoSources":
    "目前沒有可用的項目。請在「來源」分頁中新增來源。",
  "pluginsView.installing": "安裝中…",
  "pluginsView.install": "安裝",
  "pluginsView.sourcesTitle": "登錄來源",
  "pluginsView.sourcesSubtitle": "提供「可用」外掛項目的市集目錄。",
  "pluginsView.sourceUrl": "來源 URL",
  "pluginsView.defaultTrust": "預設信任層級",
  "pluginsView.trust.restricted": "受限",
  "pluginsView.trust.trusted": "受信任",
  "pluginsView.trust.official": "官方",
  "pluginsView.adding": "新增中…",
  "pluginsView.addSource": "新增來源",
  "pluginsView.sourcesEmpty": "尚未設定任何登錄來源。",
  "pluginsView.pluginsCount": "{n} 個外掛",
  "pluginsView.catalogVersion": "目錄 v{version}",
  "pluginsView.trustFor": "{name} 的信任層級",
  "pluginsView.refreshing": "重新整理中…",
  "pluginsView.removing": "移除中…",
  "pluginsView.teamTitle": "私人團隊市集",
  "pluginsView.teamBody":
    "此區域保留給企業與團隊目錄、私人信任政策，以及共用的外掛生命週期控制。",
  "pluginCard.details": "詳情",
  "pluginCard.use": "使用",
  "pluginCard.useWithQuery": "帶查詢使用",
  "pluginCard.applying": "正在套用…",
  "pluginCard.duplicate": "Remix",
  "pluginCard.duplicating": "正在 Remix…",
  "pluginCard.duplicateFailed": "無法 Remix 這個範本。",
  "pluginCard.saved": "已儲存",
  "pluginCard.publish": "發布",
  "pluginCard.contribute": "貢獻",
  "pluginCard.starting": "正在啟動…",
  "pluginCard.detailsAria": "檢視 {title} 的詳情",
  "pluginCard.chooseUseAria": "選擇 {title} 的使用方式",
  "pluginCard.useOptionsAria": "{title} 的使用選項",
  "pluginCard.duplicateAria": "將 {title} Remix 成新專案",
  "pluginCard.saveAria": "儲存 {title}",
  "pluginCard.savedAria": "{title} 已儲存",
  "pluginCard.shareAria": "分享 {title}",
  "pluginCard.publishAria": "將 {title} 發布為 GitHub 儲存庫",
  "pluginCard.publishTitle": "將外掛發布為 GitHub 儲存庫",
  "pluginCard.contributeAria": "將 {title} 貢獻至 Open Design",
  "pluginCard.contributeTitle": "透過 pull request 將外掛貢獻至 Open Design",
  "skillPluginCandidate.createForMe": "建立外掛/範本",
  "skillPluginCandidate.contributeToMain": "貢獻到 open-design",
  "skillPluginCandidate.repoDescription": "這個倉庫看起來可以做成外掛。",
  "integrations.kicker": "整合",
  "integrations.lede":
    "連接外部系統，把 MCP 工具帶入智能體迴圈，並在其他 IDE、腳本與自動化流程中使用 Open Design。",
  "integrations.agentReady": "智能體就緒",
  "integrations.areasAria": "整合區域",
  "integrations.tabLabel.mcp": "MCP 伺服器",
  "integrations.tabLabel.skills": "技能",
  "integrations.tabHint.mcp": "外部工具",
  "integrations.tabHint.connectors": "帳號與 API",
  "integrations.tabHint.useEverywhere": "CLI、HTTP、MCP",
  "integrations.skillsTitle": "技能整合",
  "integrations.skillsBody":
    "技能層級的整合管理正從另一個分支搬移過來。此分頁預留給 MCP、連接器與未來的技能設定，讓它們集中在同一個整合路由中。",
  "mcpClient.title": "外部 MCP 伺服器",
  "mcpClient.subtitle": "提供給編碼智能體使用的第三方工具。",
  "mcpClient.addServer": "新增伺服器",
  "mcpClient.emptyTitle": "尚未設定 MCP 伺服器。",
  "mcpClient.emptyBody":
    "點擊「新增伺服器」即可開始 — 選擇範本（Higgsfield OpenClaw、Pollinations、Allyson、Imagician、EdgeOne Pages、GitHub、Filesystem…），或設定自訂 stdio / HTTP 伺服器。",
  "mcpClient.saveChanges": "儲存變更",
  "mcpClient.storedAt": "儲存於",
  "mcpClient.daemonError":
    "無法連線到本機 daemon。請確認 Open Design 正在執行，然後重新開啟此面板。",
  "mcpClient.saveFailed": "儲存失敗。請確認 daemon 正在執行後再試一次。",
  "useEverywhere.modalAria": "隨處使用 Open Design",
  "useEverywhere.modalTitle": "隨處使用 Open Design",
  "useEverywhere.modalSubtitle":
    "將 Open Design 接入任何 IDE、Agent 或指令碼 — CLI、HTTP、MCP 及 Skills。使用「複製 Agent 指南」並貼到 Claude Code、Codex、Cursor、openclaw 或 hermes 中，即可設定一切。",
  "useEverywhere.closeAria": "關閉隨處使用",
  "useEverywhere.closeTitle": "關閉 (Esc)",
  "useEverywhere.tabsAria": "整合介面",
  "useEverywhere.footStrong": "一鍵交接。",
  "useEverywhere.footBody":
    "複製一份結構化的 markdown 指南，讓您的 Agent 可立即據以行動 — 安裝、驗證並使用。",
  "useEverywhere.configureMcp": "設定 MCP 伺服器",
  "useEverywhere.copyGuide": "複製給 Agent 的指南",
  "useEverywhere.copy": "複製",
  "useEverywhere.copied": "已複製",
  "useEverywhere.copyFailed": "複製失敗",
  "useEverywhere.copySnippetAria": "複製程式碼片段：{label}",
  "useEverywhere.section.overview.tab": "總覽",
  "useEverywhere.section.overview.heading":
    "你的 Agent 在哪裡運作，Open Design 就在哪裡運作",
  "useEverywhere.section.overview.intro":
    "Open Design 不只是一個視窗 — 它是一個本機特權 daemon（`od`），外加一個 Skills + Design-Systems + Atoms 登錄。一旦它在您的機器上執行，任何程式碼 Agent（Claude Code、Codex、Cursor、OpenCode/openclaw、Hermes、您自己的指令碼）都能透過四個可互換的介面來驅動產生作業、檢視專案並產出設計成品。",
  "useEverywhere.section.overview.bullet1":
    "CLI — 以 `od <command>` 用於無頭指令碼、CI 及 shell 自動化。",
  "useEverywhere.section.overview.bullet2":
    "MCP server — 將 Open Design 接成 Model Context Protocol 伺服器，讓任何支援 MCP 的 Agent 都能列出技能、執行情境並讀取成品。",
  "useEverywhere.section.overview.bullet3":
    "HTTP API — `http://127.0.0.1:7456/api/*` REST + SSE 端點；與網頁 UI 使用的介面相同。",
  "useEverywhere.section.overview.bullet4":
    "Skills — 隨插即用的 `SKILL.md` 套件（相容於 Claude），任何已在您 PATH 上的 Agent 完全無需 Open Design 即可調用。",
  "useEverywhere.section.overview.bullet5":
    "標準成品 — 在 daemon 啟動前，從 Skills、內建預設外掛及社群外掛範例中產生真實的 HTML 專案。",
  "useEverywhere.section.overview.snippet1": "在本機啟動 daemon（與 web UI）",
  "useEverywhere.section.overview.snippet2": "確認可正常連線",
  "useEverywhere.section.overview.snippet3": "在啟動前匯入標準成品",
  "useEverywhere.section.overview.footer":
    "daemon 預設會寫入 `./.od/`（專案本機）。設定 `OD_DATA_DIR=~/.open-design` 即可在多個專案間共用資料。",
  "useEverywhere.section.cli.tab": "CLI · od",
  "useEverywhere.section.cli.heading": "從任何 shell 操作 Open Design",
  "useEverywhere.section.cli.intro":
    "`od` 執行檔隨 daemon 一起發佈，與 Claude Code / Codex 執行產生作業時所用的是同一個二進位檔。多數子指令都是精簡的用戶端，會 POST 至本機 daemon，因此無論你是透過 `pnpm tools-dev` 啟動，還是以打包後的應用程式執行，運作方式都相同。",
  "useEverywhere.section.cli.bullet1":
    "`od`（無參數）— 啟動 daemon 並開啟網頁 UI。",
  "useEverywhere.section.cli.bullet2":
    "`od media generate ...` — 透過統一的媒體協定產生圖片／影片／音訊位元組。",
  "useEverywhere.section.cli.bullet3":
    "`od run ...` — 從提示 + 技能啟動一次專案執行。",
  "useEverywhere.section.cli.bullet4":
    "`od plugin install <source>` / `od plugin apply <id>` — 安裝並套用社群外掛。",
  "useEverywhere.section.cli.bullet5":
    "`od skills list` / `od design-systems list` — 檢視本機可用的項目。",
  "useEverywhere.section.cli.bullet6":
    "`od status` / `od doctor` — 驗證 daemon 健康狀態並偵測您 PATH 上的 Agent CLI。",
  "useEverywhere.section.cli.snippet1": "產生影像（委派給已設定的媒體提供者）",
  "useEverywhere.section.cli.snippet2":
    "以無頭模式執行情境外掛，並以 JSON 行的形式串流事件",
  "useEverywhere.section.cli.snippet3": "盤點本機可用的技能與設計系統",
  "useEverywhere.section.cli.snippet4": "透過 CLI 檢查已植入的成品",
  "useEverywhere.section.cli.snippet5":
    "驗證環境 + 已偵測到的 Agent（Claude、Codex、Cursor、…）",
  "useEverywhere.section.cli.footer":
    "所有子指令都接受 `--daemon-url http://127.0.0.1:<port>`，以指定某個正在執行的 daemon — 在執行沙箱化的第二個執行個體進行測試時很有用。",
  "useEverywhere.section.mcp.tab": "MCP 伺服器",
  "useEverywhere.section.mcp.heading":
    "將 Open Design 以 MCP 伺服器形式開放給任何程式設計 Agent",
  "useEverywhere.section.mcp.intro":
    "Open Design 隨附一個 Model Context Protocol 伺服器（`od mcp`），讓任何支援 MCP 的用戶端 — Cursor、Claude Code、Antigravity、VS Code Copilot Chat、openclaw、hermes — 都能探索 Open Design 工具（列出技能、算繪預覽、產生媒體、執行外掛），而無需手動使用 shell。daemon 透過 `GET /api/mcp/install-info` 為每個主要用戶端發布可直接貼上的安裝程式碼片段。",
  "useEverywhere.section.mcp.bullet1":
    "Stdio 傳輸 — 不需額外連接埠，用戶端直接產生 `od mcp` 程序。",
  "useEverywhere.section.mcp.bullet2":
    "以 sidecar 模式啟動時，會透過本機 IPC 狀態 socket 自動探索運作中的 daemon URL。",
  "useEverywhere.section.mcp.bullet3":
    "針對一般安裝，會退回使用 `--daemon-url http://127.0.0.1:<port>`，讓 MCP 程序總能找到運作中的 daemon。",
  "useEverywhere.section.mcp.bullet4":
    "固定 `OD_DATA_DIR`，讓衍生的 MCP 程序寫入 daemon 已使用的相同位置（避免在 macOS 打包應用程式套件中發生 EPERM）。",
  "useEverywhere.section.mcp.snippet1":
    "通用 MCP 用戶端設定（適用於 Cursor、Claude Code、Codex、…）",
  "useEverywhere.section.mcp.snippet2":
    "或：向 daemon 索取為你的安裝量身打造的程式碼片段",
  "useEverywhere.section.mcp.snippet3":
    "即時看板 MCP 變體（讀取並重新整理儀表板）",
  "useEverywhere.section.mcp.footer":
    "在 Open Design 應用程式中，開啟「設定 → 整合」即可複製特定用戶端的安裝指令（Cursor、Claude Code、Antigravity、VS Code），而無需手動編輯 JSON。",
  "useEverywhere.section.http.tab": "HTTP API",
  "useEverywhere.section.http.heading": "與 web UI 所用相同的 REST + SSE 介面",
  "useEverywhere.section.http.intro":
    "本機 daemon 會在 `http://127.0.0.1:7456` 提供 HTTP API（連接埠可設定）。web UI 呼叫的每個端點，你的指令稿同樣可以使用。串流端點（聊天回合、專案執行）會發出 Server-Sent Events，其合約型別定義於 `@open-design/contracts`。",
  "useEverywhere.section.http.bullet1": "`GET /api/health` — daemon 存活狀態。",
  "useEverywhere.section.http.bullet2":
    "`GET /api/skills` 與 `GET /api/design-systems` — 可用的登錄。",
  "useEverywhere.section.http.bullet3":
    "`GET /api/projects` 與 `POST /api/projects` — 列出及建立專案（POST 會回傳該專案 + 第一次對話）。",
  "useEverywhere.section.http.bullet4":
    "`GET /api/projects/:id/chat` — 某次對話的 Agent 事件 SSE 串流。",
  "useEverywhere.section.http.bullet5":
    "`POST /api/plugins/:id/apply` — 綁定已安裝的外掛，並取得其算繪後的範例查詢 + 輸入。",
  "useEverywhere.section.http.bullet6":
    "`GET /api/agents` — 您 PATH 上偵測到的程式碼 Agent CLI。",
  "useEverywhere.section.http.snippet1":
    "列出已安裝的技能（Agent 會將這些作為範本使用）",
  "useEverywhere.section.http.snippet2":
    "從提示詞建立專案（完整的伺服器端流程）",
  "useEverywhere.section.http.snippet3":
    "串流一次聊天回合（SSE — 每一行都相容於 JSON-Lines）",
  "useEverywhere.section.http.footer":
    "每個請求／回應的純 TypeScript 型別都位於 `@open-design/contracts` 中 — 在您的指令碼中匯入它們，即可享有完整的自動完成，而無需接上產生器。",
  "useEverywhere.section.skills.tab": "技能與無頭模式",
  "useEverywhere.section.skills.heading":
    "適用於任何 Agent 的隨插即用 Skills — 即使 Open Design 未在執行也行",
  "useEverywhere.section.skills.intro":
    "Skill 是一個包含相容於 Claude 的 `SKILL.md`（YAML 前置資料 + 內文）的目錄。Open Design 以 `od:` 命名空間（`mode`、`preview`、`design_system`、`inputs`、…）擴充此格式，因此同一個成品既能在 Open Design 內使用，也能被像 Claude Code、Codex、openclaw 或 hermes 這類原生 Agent 使用。探索作業遵循一條優先順序鏈，因此專案可覆寫自己的技能。",
  "useEverywhere.section.skills.bullet1":
    "探索：`./.claude/skills/` → `./skills/` → `~/.claude/skills/`（專案優先）。",
  "useEverywhere.section.skills.bullet2":
    "將一個技能以符號連結方式連到多個專案，無需複製即可共用。",
  "useEverywhere.section.skills.bullet3":
    "每個技能都可宣告連接器、原子元件、設計系統需求，以及供藝廊使用的 `preview` 範例輸出。",
  "useEverywhere.section.skills.bullet4":
    "無頭模式：PATH 中含有 `od` 的 Agent 可呼叫 `od skills list`，接著執行任何技能；唯讀流程中 daemon 為選用。",
  "useEverywhere.section.skills.bullet5":
    "`pnpm seed:test-projects` 會以預設外掛範例與社群外掛範例演練相同的成品結構，接著將產生的 `index.html` 專案儲存為可重複使用的測試資料。",
  "useEverywhere.section.skills.snippet1":
    "最精簡的 SKILL.md（Claude 相容的前置資料 + Open Design 額外設定）",
  "useEverywhere.section.skills.snippet2":
    "將共用 skill 以符號連結方式加入專案（cc-switch 風格）",
  "useEverywhere.section.skills.snippet3":
    "Headless：列出 daemon 目前可見的 skills",
  "useEverywhere.section.skills.snippet4": "Headless 產物 fixture 套件",
  "useEverywhere.section.skills.footer":
    "規格：`docs/skills-protocol.md` 與 `docs/agent-adapters.md` 涵蓋完整的轉接層面（Claude Code、Codex、Cursor、支援 MCP 的 Agent、BYOK API 後援），以及各轉接器的 skill 注入策略。",
  "tasks.kicker": "自動化工作區",
  "tasks.comingSoon": "即將推出",
  "tasks.lede":
    "自動化將提示轉化為可持續的工作：Orbit 負責執行，routines 將其保留下來，schedules 決定何時觸發，live artifacts 則呈現變更內容。",
  "tasks.newAutomation": "新增自動化",
  "tasks.previewNote":
    "僅為預覽介面。Orbit 設定目前已可使用；routines、schedules 與 live artifact 的串接將隨後端分支合併後上線。",
  "tasks.primitivesAria": "自動化基本元件",
  "tasks.primitive.orbit.title": "Orbit",
  "tasks.primitive.orbit.body":
    "為長時間執行或週期性 Agent 工作提供的持久執行環境。",
  "tasks.primitive.orbit.enabled": "已啟用每日摘要",
  "tasks.primitive.orbit.manualOnly": "僅限手動",
  "tasks.primitive.routines.title": "例行任務",
  "tasks.primitive.routines.body": "可在單次對話結束後持續存在的持久任務定義。",
  "tasks.primitive.routines.meta": "產品外殼已就緒",
  "tasks.primitive.schedules.title": "排程",
  "tasks.primitive.schedules.body":
    "決定 routine 何時執行的時間或事件觸發條件。",
  "tasks.primitive.schedules.meta": "分支待處理",
  "tasks.primitive.liveArtifacts.title": "即時看板",
  "tasks.primitive.liveArtifacts.body":
    "在 Agent 工作期間持續更新的報告與筆記。",
  "tasks.primitive.liveArtifacts.meta": "預覽模型",
  "tasks.listAria": "自動化清單",
  "tasks.routinesAndRuns": "{n} 個 routines 與執行",
  "tasks.filtersAria": "自動化篩選",
  "tasks.filter.scheduled": "已排程",
  "tasks.filter.running": "執行中",
  "tasks.filter.done": "已完成",
  "tasks.configurationAria": "自動化設定",
  "tasks.slot.trigger": "觸發條件",
  "tasks.slot.pattern": "模式",
  "tasks.slot.runtime": "執行環境",
  "tasks.slot.output": "輸出",
  "tasks.liveArtifact": "即時看板",
  "tasks.viewProgress": "檢視進度",
  "tasks.pause": "暫停",
  "tasks.runNow": "立即執行",
  "tasks.openArtifact": "開啟產物",
  "tasks.status.dailyAt": "每日 · {time}",
  "tasks.status.pausedManual": "已暫停 · 僅手動",
  "tasks.sample.orbit.title": "Orbit Daily 連接器摘要",
  "tasks.sample.orbit.metaEnabled": "連接器摘要已排程",
  "tasks.sample.orbit.metaDisabled": "開啟 Orbit 設定以啟用",
  "tasks.sample.orbit.previewEnabled": "orbit_daily.html · 即時看板",
  "tasks.sample.orbit.previewDisabled": "尚無排程的執行",
  "tasks.sample.orbit.triggerEnabled": "排程 · 每日 {time}",
  "tasks.sample.orbit.triggerDisabled": "手動 · 隨需執行",
  "tasks.sample.orbit.pattern": "例行任務 · 連接器摘要",
  "tasks.sample.orbit.runtime": "Orbit · 常駐程序排程",
  "tasks.sample.orbit.output": "即時看板 · 可重新整理的報告",
  "tasks.sample.orbit.artifactMetaEnabled": "每次執行後重新整理",
  "tasks.sample.orbit.artifactMetaDisabled": "等待排程中",
  "tasks.sample.orbit.body1": "# Orbit Daily 活動摘要",
  "tasks.sample.orbit.body2": "已檢查連接器 · 成功、略過與失敗",
  "tasks.sample.orbit.body3": "重點摘要將成為可重新整理的 live artifact。",
  "tasks.sample.mcp.title": "MCP 替代方案研究",
  "tasks.sample.mcp.status": "於 orbit 中執行 · 2 小時 14 分",
  "tasks.sample.mcp.meta": "已處理 14 / 30 個來源",
  "tasks.sample.mcp.preview": "research_notes.md · 即時",
  "tasks.sample.mcp.trigger": "手動 · 單次",
  "tasks.sample.mcp.pattern": "深度研究提示",
  "tasks.sample.mcp.runtime": "遠端 · 持續性",
  "tasks.sample.mcp.output": "即時報告 · 自動更新",
  "tasks.sample.mcp.artifactMeta": "12 秒前更新",
  "tasks.sample.mcp.body1": "# MCP 替代方案 - 階段性發現",
  "tasks.sample.mcp.body2": "已審閱 14 個來源 · 入選 3 個候選",
  "tasks.sample.mcp.body3": "## 候選清單",
  "tasks.sample.mcp.body4": "- 透過 JSON-RPC 的工具呼叫結構描述……",
  "tasks.sample.mcp.body5": "- 以 gRPC 為基礎的 Agent 協定……",
  "tasks.sample.weekly.title": "每週團隊摘要",
  "tasks.sample.weekly.status": "下次：週一 上午 9:00",
  "tasks.sample.weekly.meta": "更新團隊週報文件",
  "tasks.sample.weekly.preview": "team_weekly.md · 下個產物",
  "tasks.sample.weekly.trigger": "排程 · 每週",
  "tasks.sample.weekly.pattern": "例行任務 · 團隊摘要",
  "tasks.sample.weekly.runtime": "遠端 · 週期性",
  "tasks.sample.weekly.output": "即時看板 · markdown",
  "tasks.sample.weekly.artifactMeta": "4 天前更新",
  "tasks.sample.weekly.body1": "# 團隊週報",
  "tasks.sample.weekly.body2": "## 進行中",
  "tasks.sample.weekly.body3": "- 設計系統整合檢查",
  "tasks.sample.weekly.body4": "- Connector 品質巡檢",
  "tasks.sample.weekly.body5": "## 風險",
  "tasks.sample.pr.title": "PR 審查提醒",
  "tasks.sample.pr.status": "新 PR 時 · 23 分鐘前觸發",
  "tasks.sample.pr.meta": "傳送 Slack 私訊",
  "tasks.sample.pr.preview": "上次傳送成功",
  "tasks.sample.pr.trigger": "事件 · 新 PR",
  "tasks.sample.pr.pattern": "例行任務 · 通知",
  "tasks.sample.pr.runtime": "本機 · 快速執行",
  "tasks.sample.pr.output": "訊息 · Slack 私訊",
  "tasks.sample.pr.artifactMeta": "上次觸發於 23 分鐘前",
  "tasks.sample.pr.body1": "已開啟 PR #184 供審查",
  "tasks.sample.pr.body2": "已比對審查者：design-platform、web-runtime",
  "tasks.sample.pr.body3": "傳送：Slack 私訊已送出",
  "tasks.sample.meeting.title": "會議前準備",
  "tasks.sample.meeting.status": "明天 · 上午 10:00",
  "tasks.sample.meeting.meta": "單次 · 傳送摘要",
  "tasks.sample.meeting.preview": "meeting_brief.md · 已排入佇列",
  "tasks.sample.meeting.trigger": "排程 · 單次",
  "tasks.sample.meeting.pattern": "簡報提示詞",
  "tasks.sample.meeting.runtime": "遠端 · 有限制",
  "tasks.sample.meeting.output": "產出物 + 訊息",
  "tasks.sample.meeting.artifactMeta": "已排入產生佇列",
  "tasks.sample.meeting.body1": "# 會議簡報",
  "tasks.sample.meeting.body2": "議程來源：行事曆事件 + 連結文件",
  "tasks.sample.meeting.body3": "產出內容將包含決策、阻礙事項與待解問題。",
  "tasks.sample.candidate.title": "應徵者追蹤",
  "tasks.sample.candidate.status": "失敗 · 需要處理",
  "tasks.sample.candidate.meta": "授權已過期",
  "tasks.sample.candidate.preview": "重新連接 Greenhouse 以繼續",
  "tasks.sample.candidate.trigger": "排程 · 每日",
  "tasks.sample.candidate.pattern": "例行任務 · 應徵者同步",
  "tasks.sample.candidate.runtime": "遠端 · 週期性",
  "tasks.sample.candidate.output": "即時看板 · 表格",
  "tasks.sample.candidate.artifactMeta": "已暫停，直到授權恢復",
  "tasks.sample.candidate.body1": "# 應徵者流程",
  "tasks.sample.candidate.body2": "上次成功同步：2 天前",
  "tasks.sample.candidate.body3": "需要採取行動：重新連接來源帳號。",
  "routines.title": "自動化",
  "routines.subtitle": "無需值守、依排程執行的自動化工作。",
  "routines.newAutomation": "新增自動化",
  "routines.loading": "載入中…",
  "routines.empty": "尚無自動化工作。",
  "routines.emptyHint": "點選「新增自動化」即可安排一次無人值守的代理執行。",
  "routines.runHistoryLoading": "正在載入執行記錄…",
  "routines.runHistoryEmpty": "尚無執行記錄。",
  "routines.fieldName": "名稱",
  "routines.fieldNamePlaceholder": "晨間簡報",
  "routines.fieldPrompt": "提示詞",
  "routines.fieldPromptPlaceholder":
    "擷取昨天的 GitHub 與 Linear 活動並總結有哪些變更。",
  "routines.fieldSchedule": "排程",
  "routines.fieldMinute": "每小時的第幾分鐘",
  "routines.fieldTime": "時間",
  "routines.fieldTimezone": "時區",
  "routines.fieldsetProject": "專案",
  "routines.kind.hourly": "每小時",
  "routines.kind.daily": "每天",
  "routines.kind.weekdays": "工作日",
  "routines.kind.weekly": "每週",
  "routines.weekday.short.0": "週日",
  "routines.weekday.short.1": "週一",
  "routines.weekday.short.2": "週二",
  "routines.weekday.short.3": "週三",
  "routines.weekday.short.4": "週四",
  "routines.weekday.short.5": "週五",
  "routines.weekday.short.6": "週六",
  "routines.weekday.long.0": "週日",
  "routines.weekday.long.1": "週一",
  "routines.weekday.long.2": "週二",
  "routines.weekday.long.3": "週三",
  "routines.weekday.long.4": "週四",
  "routines.weekday.long.5": "週五",
  "routines.weekday.long.6": "週六",
  "routines.timeAm": "上午",
  "routines.timePm": "下午",
  "routines.describe.hourly": "每小時的第 {minute} 分執行",
  "routines.describe.daily": "每天 {time}（{tz}）執行",
  "routines.describe.weekdays": "週一至週五 {time}（{tz}）執行",
  "routines.describe.weekly": "每{day} {time}（{tz}）執行",
  "routines.modeCreate": "每次執行建立新專案",
  "routines.modeCreateHint": "每次觸發都使用全新且隔離的工作區。",
  "routines.modeReuse": "重複使用現有專案",
  "routines.modeReuseHint": "每次執行會成為該專案中的一段新對話。",
  "routines.pickProject": "— 選擇專案 —",
  "routines.targetReuse": "→ {project}",
  "routines.targetCreate": "→ 每次執行建立新專案",
  "routines.tagPaused": "已暫停",
  "routines.metaNext": "下次：{when}",
  "routines.metaLast": "上次：",
  "routines.triggerManual": "手動",
  "routines.triggerScheduled": "排程",
  "routines.openProject": "開啟專案",
  "routines.openProjectTitle": "開啟本次執行寫入的專案",
  "routines.runNow": "立即執行",
  "routines.edit": "編輯",
  "routines.pause": "暫停",
  "routines.resume": "繼續",
  "routines.history": "歷史記錄",
  "routines.hideHistory": "隱藏歷史記錄",
  "routines.delete": "刪除",
  "routines.deleteTitle": "刪除此自動化",
  "routines.cancel": "取消",
  "routines.save": "儲存",
  "routines.saving": "儲存中…",
  "routines.create": "建立",
  "routines.creating": "建立中…",
  "routines.status.queued": "佇列中",
  "routines.status.running": "執行中",
  "routines.status.succeeded": "成功",
  "routines.status.failed": "失敗",
  "routines.status.canceled": "已取消",
  "routines.confirmDelete": "刪除此自動化？過往執行記錄及其專案將予以保留。",
  "routines.errorPickProject":
    "請選擇要重複使用的專案，或切換為「每次執行建立新專案」。",
  "routines.errorAgentEmptyOutput":
    "代理已完成執行但未產生任何輸出。模型或提供商可能返回了空回應，請檢查代理日誌中的上游錯誤。",
  "entry.helpAria": "說明",
  "entry.helpMenuAria": "說明選單",
  "entry.helpGetHelp": "在 GitHub 取得協助",
  "entry.helpSubmitFeature": "提交功能建議",
  "entry.helpWhatsNew": "最新動態",
  "entry.helpDownloadDesktop": "下載桌面端",
  "entry.githubStarLabel": "星標",
  "entry.githubStarTitle": "在 GitHub 為我們點亮 Star",
  "entry.githubStarAria": "在 GitHub 為 Open Design 點亮 Star",
  "entry.tabImageTemplates": "圖片範本",
  "entry.tabVideoTemplates": "影片範本",
  "promptTemplates.searchPlaceholder": "搜尋範本…",
  "promptTemplates.countLabel": "{n} 個結果",
  "promptTemplates.emptyImage": "還沒有安裝圖片 Prompt 範本。",
  "promptTemplates.emptyVideo": "還沒有安裝影片 Prompt 範本。",
  "promptTemplates.emptyNoMatch": "沒有符合的範本。",
  "promptTemplates.attributionFooter":
    "改編自公開 Prompt 庫，每張卡片都連結到原作者。",
  "promptTemplates.openPreviewTitle": "開啟 Prompt 與預覽",
  "promptTemplates.sourcePrefix": "來源：",
  "promptTemplates.fetchError": "無法載入此範本文字。",
  "promptTemplates.promptLabel": "Prompt 內容",
  "promptTemplates.copyPrompt": "複製 Prompt",
  "promptTemplates.copyDone": "已複製！",
  "promptTemplates.modelHint": "建議模型：{model}",
  "promptTemplates.openSource": "查看原始來源",
  "promptTemplates.openFullscreen": "開啟全螢幕預覽",
  "promptTemplates.closeFullscreen": "關閉全螢幕預覽",
  "promptTemplates.allSources": "所有來源",
  "promptTemplates.sourceFilterAria": "依來源篩選",
  "promptTemplates.retry": "重試",
  "connectors.title": "連接器",
  "connectors.subtitle": "可為即時製品提供資料的本地和未來資料來源。",
  "connectors.account": "帳號",
  "connectors.noAccount": "未連接",
  "connectors.tools": "工具",
  "connectors.connect": "連接",
  "connectors.disconnect": "中斷連接",
  "connectors.authorizationPending": "等待授權中...",
  "connectors.authorizationPendingHint": "請在已開啟的視窗中完成授權。",
  "connectors.cancelAuthorization": "取消",
  "connectors.configure": "設定",
  "connectors.unavailable": "不可用",
  "connectors.phaseStubTitle": "連接器 API 將在 Phase 3 提供；這裡是預覽入口。",
  "connectors.statusAvailable": "可用",
  "connectors.statusConnected": "已連接",
  "connectors.statusError": "錯誤",
  "connectors.statusDisabled": "已停用",
  "connectors.gateTitle": "新增 Composio API 金鑰以繼續",
  "connectors.gateBody":
    "在上方貼上金鑰並點擊「儲存金鑰」，即可載入可用的整合。",
  "connectors.aboutLabel": "簡介",
  "connectors.detailsLabel": "詳情",
  "connectors.statusLabel": "狀態",
  "connectors.category.aiAgents": "AI 代理",
  "connectors.category.aiInfrastructure": "AI 基礎設施",
  "connectors.category.accounting": "會計",
  "connectors.category.admin": "管理",
  "connectors.category.advertising": "廣告",
  "connectors.category.analytics": "分析",
  "connectors.category.automation": "自動化",
  "connectors.category.cms": "CMS",
  "connectors.category.crm": "CRM",
  "connectors.category.calendar": "日曆",
  "connectors.category.commerce": "電商",
  "connectors.category.communication": "溝通",
  "connectors.category.contacts": "聯絡人",
  "connectors.category.dataPlatform": "資料平台",
  "connectors.category.database": "資料庫",
  "connectors.category.design": "設計",
  "connectors.category.developer": "開發者工具",
  "connectors.category.documentation": "文件",
  "connectors.category.erp": "ERP",
  "connectors.category.education": "教育",
  "connectors.category.email": "郵件",
  "connectors.category.events": "活動",
  "connectors.category.fieldService": "現場服務",
  "connectors.category.finance": "財務",
  "connectors.category.fitness": "健身",
  "connectors.category.forms": "表單",
  "connectors.category.gaming": "遊戲",
  "connectors.category.hr": "人力資源",
  "connectors.category.hospitality": "旅宿與款待",
  "connectors.category.itsm": "ITSM",
  "connectors.category.integration": "整合",
  "connectors.category.localization": "在地化",
  "connectors.category.logistics": "物流",
  "connectors.category.maps": "地圖",
  "connectors.category.marketing": "行銷",
  "connectors.category.media": "媒體",
  "connectors.category.meetings": "會議",
  "connectors.category.nonprofit": "非營利",
  "connectors.category.observability": "可觀測性",
  "connectors.category.payments": "付款",
  "connectors.category.personal": "個人",
  "connectors.category.presentations": "簡報",
  "connectors.category.procurement": "採購",
  "connectors.category.product": "產品",
  "connectors.category.productivity": "生產力",
  "connectors.category.projectManagement": "專案管理",
  "connectors.category.recruiting": "招募",
  "connectors.category.research": "研究",
  "connectors.category.salesIntelligence": "銷售情報",
  "connectors.category.scheduling": "排程",
  "connectors.category.search": "搜尋",
  "connectors.category.security": "安全",
  "connectors.category.signing": "簽署",
  "connectors.category.social": "社交",
  "connectors.category.spreadsheets": "試算表",
  "connectors.category.storage": "儲存",
  "connectors.category.support": "支援",
  "connectors.category.surveys": "問卷",
  "connectors.category.tasks": "任務",
  "connectors.category.timeTracking": "時間追蹤",
  "connectors.category.video": "影片",
  "connectors.category.whiteboard": "白板",
  "connectors.categoryLabel": "類別",
  "connectors.providerLabel": "提供方",
  "connectors.toolsSection": "工具",
  "connectors.toolsLoading": "正在載入工具…",
  "connectors.noToolsAvailable":
    "目前沒有可用工具，連接後即可發現此整合提供的能力。",
  "connectors.toolDetailsUnavailable":
    "工具詳細資訊無法取得，但這個 connector 回報有 {n} 項工具。",
  "connectors.loadMoreTools": "載入更多工具",
  "connectors.openDetailsAria": "檢視 {name} 詳情",
  "connectors.toolsBadgeNone": "尚無工具",
  "connectors.toolsBadgeOne": "{n} 個工具",
  "connectors.toolsBadgeMany": "{n} 個工具",
  "connectors.searchPlaceholder": "搜尋連接器…",
  "connectors.searchAriaLabel": "依名稱、提供者或工具搜尋連接器",
  "connectors.searchClear": "清除搜尋",
  "connectors.emptyNoMatchTitle": "沒有符合「{query}」的連接器",
  "connectors.emptyNoMatchBody": "試試其他關鍵字，或清除搜尋以瀏覽完整目錄。",
  "connectors.emptyNoMatchAction": "清除搜尋",
  "newproj.tabPrototype": "原型",
  "newproj.tabLiveArtifact": "即時看板",
  "newproj.tabDeck": "投影片",
  "newproj.tabTemplate": "從範本",
  "newproj.tabMedia": "媒體",
  "newproj.tabOther": "其它",
  "newproj.titlePrototype": "新建原型",
  "newproj.titleLiveArtifact": "新建即時看板",
  "newproj.titleDeck": "新建投影片",
  "newproj.titleTemplate": "從範本開始",
  "newproj.titleImage": "新建圖片",
  "newproj.titleVideo": "新建影片",
  "newproj.titleAudio": "新建音訊",
  "newproj.titleMedia": "新建媒體",
  "newproj.titleOther": "新建專案",
  "newproj.namePlaceholder": "專案名稱",
  "newproj.fidelityLabel": "精細度",
  "newproj.fidelityWireframe": "線框圖",
  "newproj.fidelityHigh": "高擬真",
  "newproj.toggleSpeakerNotes": "使用演講備忘稿",
  "newproj.toggleSpeakerNotesHint": "減少投影片上的文字，重點放到備忘稿中。",
  "newproj.toggleAnimations": "加入動畫效果",
  "newproj.toggleAnimationsHint":
    "在範本基礎上疊加動畫效果（入場、懸停、過渡）。",
  "newproj.targetPlatformsLabel": "目標平台",
  "newproj.targetPlatformsHint":
    "可多選。響應式 Web 僅涵蓋瀏覽器斷點；如需原生跨平台版本，請加入 iOS、Android、平板應用或桌面應用。",
  "newproj.platform.responsive.label": "響應式 Web",
  "newproj.platform.responsive.hint":
    "一套 Web 體驗，適配桌面、平板與行動瀏覽器",
  "newproj.platform.webDesktop.label": "桌面 Web",
  "newproj.platform.webDesktop.hint": "瀏覽器優先的產品或著陸頁",
  "newproj.platform.mobileIos.label": "iOS 應用",
  "newproj.platform.mobileIos.hint": "iPhone 畫框與 iOS 互動規範",
  "newproj.platform.mobileAndroid.label": "Android 應用",
  "newproj.platform.mobileAndroid.hint": "Pixel 畫框與 Material 互動規範",
  "newproj.platform.tablet.label": "平板應用",
  "newproj.platform.tablet.hint": "原生風格的平板體驗，支援分割畫面",
  "newproj.platform.desktopApp.label": "桌面應用",
  "newproj.platform.desktopApp.hint": "macOS/Windows 應用外觀",
  "newproj.surfaceOptionsLabel": "配套介面",
  "newproj.includeLandingPage": "包含著陸頁",
  "newproj.includeLandingPageHint":
    "為廣告、候補名單、發布活動、應用下載或產品說明加入一個響應式行銷頁面。",
  "newproj.includeOsWidgets": "包含系統小工具",
  "newproj.includeOsWidgetsHint":
    "為行動／平板應用加入平台原生的主畫面、鎖定畫面或快捷小工具。",
  "newproj.includeOsWidgetsDisabledHint":
    "選擇 iOS、Android 或平板應用作為目標平台時可用。",
  "newproj.templateLabel": "範本",
  "newproj.noTemplatesTitle": "還沒有範本",
  "newproj.noTemplatesBody":
    "開啟任意專案，在檔案檢視器內的「分享」選單將其儲存為範本，範本將出現在這裡。",
  "newproj.savedTemplate": "已儲存的範本",
  "newproj.fileSingular": "個檔案",
  "newproj.filePlural": "個檔案",
  "newproj.create": "建立",
  "newproj.locationLabel": "儲存到",
  "newproj.locationDefault": "Open Design 專案",
  "newproj.locationExternalBase": "外部基目錄",
  "newproj.createLiveArtifact": "建立即時看板",
  "newproj.createFromTemplate": "基於範本建立",
  "newproj.createDisabledTitle":
    "請先在任意專案內透過「分享」選單將其儲存為範本。",
  "newproj.importClaudeZip": "匯入 Claude Design ZIP",
  "newproj.importClaudeZipTitle": "匯入 Claude Design 匯出的 .zip 檔案",
  "newproj.importingClaudeZip": "正在匯入…",
  "newproj.privacyFooter": "預設情況下只有你能看到自己的專案。",
  "newproj.designSystem": "設計系統",
  "newproj.dsNoneFreeform": "不指定 — 自由發揮",
  "newproj.dsNoneSubtitleEmpty": "不使用系統 token，由你決定整體配色",
  "newproj.dsNoneSubtitleSelected": "跳過系統 token，由代理自行選擇配色。",
  "newproj.dsCategoryFallback": "設計系統",
  "newproj.dsSearch": "搜尋設計系統…",
  "newproj.dsModeAria": "選擇模式",
  "newproj.dsModeSingle": "單選",
  "newproj.dsModeMulti": "多選",
  "newproj.dsNoneTitle": "不指定 — 自由發揮",
  "newproj.dsNoneSub": "跳過系統 token，由代理自行選擇配色。",
  "newproj.dsEmpty": "沒有符合「{query}」的設計系統。",
  "newproj.dsFootSingular": "只作為靈感參考。",
  "newproj.dsFootPlural": "只作為靈感參考。",
  "newproj.dsFootClear": "清除",
  "newproj.dsBadgeDefault": "預設",
  "newproj.dsPrimaryFallback": "主系統",
  "newproj.surfaceImage": "圖片",
  "newproj.surfaceVideo": "影片",
  "newproj.surfaceAudio": "音訊",
  "newproj.modelLabel": "模型",
  "newproj.modelSearch": "搜尋模型…",
  "newproj.modelEmpty": "沒有符合的模型。",
  "newproj.modelRecommended": "推薦",
  "newproj.modelMissingTitle": "選擇模型",
  "newproj.modelMissingSub": "為此情境選一個模型。",
  "newproj.aspectLabel": "比例",
  "newproj.videoLengthLabel": "時長",
  "newproj.videoLengthSeconds": "{n} 秒",
  "newproj.audioKindLabel": "音訊類型",
  "newproj.audioKindMusic": "音樂",
  "newproj.audioKindSpeech": "配音 / TTS",
  "newproj.audioKindSfx": "音效",
  "newproj.audioDurationLabel": "時長",
  "newproj.audioDurationSeconds": "{n} 秒",
  "newproj.voiceLabel": "聲音",
  "newproj.voicePlaceholder": "提供商 voice id，可選",
  "newproj.connectorsLabel": "連接器",
  "newproj.connectorsHint": "即時製品可以從這些資料來源拉取資訊。",
  "newproj.connectorsEmptyTitle": "尚未配置連接器",
  "newproj.connectorsEmptyBody":
    "連接一個資料來源，讓即時製品載入真實資料而非佔位內容。",
  "newproj.connectorsEmptyCta": "前往配置連接器 →",
  "newproj.connectorsLoading": "正在載入連接器…",
  "newproj.connectorsCountOne": "已連接 {n} 個",
  "newproj.connectorsCountMany": "已連接 {n} 個",
  "newproj.connectorsManage": "管理",
  "newproj.promptTemplateLabel": "參考範本",
  "newproj.promptTemplateNoneTitle": "不指定 — 自由發揮",
  "newproj.promptTemplateNoneSub": "跳過範本庫，自行描述需求",
  "newproj.promptTemplateRefSub": "參考範本",
  "newproj.promptTemplateSearch": "搜尋範本…",
  "newproj.promptTemplateEmpty": "目前沒有此類型的範本。",
  "newproj.promptTemplateBodyLabel": "Prompt（可繼續優化）",
  "newproj.promptTemplateOptimizeHint":
    "可隨意編輯 — 修改後的內容會作為 agent 生成時的參考。",
  "newproj.promptTemplateBodyEmpty": "內容為空 — agent 不會拿到範本參考。",
  "newproj.deleteTemplateTitle": "刪除範本",
  "newproj.deleteTemplateConfirm": "確定刪除「{name}」？此操作無法復原。",
  "newproj.deleteTemplateConfirmCta": "刪除範本",
  "newproj.deleteTemplateError": "無法刪除此範本，請重試。",
  "designs.subRecent": "最近",
  "designs.subYours": "我的設計",
  "designs.filterAria": "篩選專案",
  "designs.searchPlaceholder": "搜尋…",
  "designs.emptyNoProjects": "還沒有專案。",
  "designs.emptyNoMatch": "沒有符合的專案。",
  "designs.deleteTitle": "刪除專案",
  "designs.deleteConfirm": "確定刪除「{name}」？",
  "designs.cardFreeform": "自由設計",
  "designs.badgeLive": "即時",
  "designs.liveArtifactBadgesAria": "即時看板標記",
  "designs.liveCount": "{n} 個即時",
  "designs.statusLive": "即時看板",
  "designs.statusArchived": "已封存",
  "designs.statusError": "錯誤",
  "designs.statusRefreshing": "重新整理中…",
  "designs.statusRefreshFailed": "重新整理失敗",
  "designs.statusRefreshed": "已重新整理",
  "designs.status.notStarted": "未開始",
  "designs.status.queued": "等待中",
  "designs.status.running": "執行中",
  "designs.status.awaitingInput": "等待回覆",
  "designs.status.incomplete": "未完成",
  "designs.status.succeeded": "已完成",
  "designs.status.published": "已發佈",
  "designs.status.failed": "失敗",
  "designs.status.canceled": "已取消",
  "designs.viewToggleAria": "檢視模式",
  "designs.viewGrid": "網格檢視",
  "designs.viewKanban": "看板檢視",
  "designs.kanbanEmptyColumn": "暫無設計",
  "designs.deleteAria": "刪除專案 {name}",
  "designs.menuMore": "更多操作",
  "designs.menuRename": "重新命名",
  "designs.menuDelete": "刪除",
  "designs.renamePrompt": "為「{name}」輸入新名稱",
  "designs.selectMode": "選擇",
  "designs.cancelSelect": "取消",
  "designs.deleteSelected": "刪除所選",
  "designs.selectedCount": "已選擇 {n} 項",
  "designs.deleteSelectedConfirm": "確定刪除選取的 {n} 個專案？",
  "designs.deleteSelectedSuccess": "已成功刪除 {n} 個專案。",
  "designs.deleteSelectedPartial": "已刪除 {deleted} 個專案；{failed} 個失敗。",
  "designs.tagPrototype": "原型",
  "designs.tagLiveArtifact": "即時看板",
  "designs.tagSlide": "投影片",
  "designs.tagMedia": "媒體",
  "designs.renameTitle": "重新命名專案",
  "designs.renameSave": "確定",
  "designs.renameCancel": "取消",
  "examples.typeLabel": "類型",
  "examples.surfaceLabel": "類型",
  "examples.surfaceWeb": "網頁",
  "examples.surfaceImage": "圖片",
  "examples.surfaceVideo": "影片",
  "examples.surfaceAudio": "音訊",
  "examples.scenarioLabel": "情境",
  "examples.modeAll": "全部",
  "examples.modePrototypeDesktop": "原型 · 桌面版",
  "examples.modePrototypeMobile": "原型 · 行動版",
  "examples.modeDeck": "投影片",
  "examples.modeDocument": "文件與範本",
  "examples.modeOrbit": "Orbit",
  "examples.modeLive": "即時",
  "examples.scenarioGeneral": "通用",
  "examples.scenarioEngineering": "工程",
  "examples.scenarioProduct": "產品",
  "examples.scenarioDesign": "設計",
  "examples.scenarioMarketing": "行銷",
  "examples.scenarioSales": "業務",
  "examples.scenarioFinance": "財務",
  "examples.scenarioHr": "人力資源",
  "examples.scenarioOperations": "營運",
  "examples.scenarioSupport": "支援",
  "examples.scenarioLegal": "法務",
  "examples.scenarioEducation": "教育",
  "examples.scenarioPersonal": "個人",
  "examples.searchPlaceholder": "搜尋範例…",
  "examples.searchAria": "依名稱搜尋範例",
  "examples.emptyNoSkills": "沒有可用的技能，守護程序是否在執行？",
  "examples.emptyNoMatch": "沒有符合當前篩選的範例。",
  "examples.openPreview": "⤢ 開啟預覽",
  "examples.loadingPreview": "正在載入預覽…",
  "examples.hoverPreview": "將滑鼠懸停以檢視預覽",
  "examples.usePrompt": "使用此 Prompt",
  "examples.previewModalTitle": "在彈窗中檢視完整預覽",
  "examples.shareTitle": "分享此範例",
  "examples.shareLoadFirst": "請先懸停以載入預覽",
  "examples.unavailablePlaceholder":
    "此技能未附帶 {kind} 預覽範例 — 開啟查看詳情",
  "examples.shareUnavailable": "此技能未附帶 {kind} 預覽範例可分享",
  "examples.shareMenu": "分享 ▾",
  "examples.exportPdfAllSlides": "匯出為 PDF（全部投影片）",
  "examples.exportPptxLocked": "匯出為 PPTX…（請先開啟範本）",
  "examples.tagSlideDeck": "投影片",
  "examples.tagTemplate": "範本",
  "examples.tagDesignSystem": "設計系統",
  "examples.tagMobilePrototype": "行動版原型",
  "examples.tagDesktopPrototype": "桌面版原型",
  "examples.tagImage": "圖片",
  "examples.tagVideo": "影片",
  "examples.tagAudio": "音訊",
  "examples.previewLabel": "預覽",
  "ds.surfaceLabel": "類型",
  "ds.surfaceWeb": "網頁",
  "ds.surfaceImage": "圖片",
  "ds.surfaceVideo": "影片",
  "ds.surfaceAudio": "音訊",
  "ds.searchPlaceholder": "搜尋設計系統…",
  "ds.emptyNoMatch": "沒有符合的設計系統。",
  "ds.badgeDefault": "預設",
  "ds.preview": "預覽完整系統",
  "ds.previewTitle": "預覽完整設計系統",
  "ds.categoryAll": "全部",
  "ds.categoryUncategorized": "未分類",
  "ds.showcase": "展示",
  "ds.tokens": "Token",
  "ds.specToggle": "DESIGN.md",
  "ds.specLoading": "正在載入 DESIGN.md…",
  "avatar.title": "帳號與設定",
  "avatar.localCli": "本機 CLI",
  "avatar.anthropicApi": "Anthropic API",
  "avatar.useLocal": "使用本機 CLI",
  "avatar.useApi": "使用 API · BYOK",
  "avatar.codeAgent": "程式碼代理",
  "avatar.rescan": "重新掃描 PATH",
  "avatar.amrConsole": "Open Design Cloud 帳戶",
  "avatar.amrConsoleMeta": "餘額與儲值",
  "avatar.settings": "設定",
  "avatar.backToProjects": "返回專案列表",
  "avatar.metaActive": "使用中",
  "avatar.metaOffline": "未執行",
  "avatar.metaSelected": "已選",
  "avatar.noAgentSelected": "尚未選擇代理",
  "avatar.modelSection": "模型",
  "avatar.modelLabel": "模型",
  "avatar.reasoningLabel": "推理",
  "avatar.serviceTierLabel": "服務層級",
  "avatar.customSuffix": "（自訂）",
  "socialShare.openDesignSection": "分享 Open Design",
  "socialShare.openDesignTitle": "GitHub 上的 Open Design",
  "socialShare.openDesignText":
    "Open Design 是開源的設計智慧工作區，可以生成、編輯、部署並交付設計產物。",
  "socialShare.openDesignCopyText": "{text}\n{url}",
  "socialShare.projectSection": "社群分享",
  "socialShare.publishPageTitle": "發布分享頁",
  "socialShare.publishPageSubtitle": "發布目前預覽，以便分享到社群平台。",
  "socialShare.projectTitle": "{title} · Open Design",
  "socialShare.projectText":
    "我用 Open Design 做了 {title}。查看已部署產物，也推薦收藏倉庫：{repo}",
  "socialShare.projectCopyText":
    "我用 Open Design 做了 {title}\n{url}\nOpen Design 倉庫：{repo}",
  "socialShare.deployFirst": "先部署，再分享到社群…",
  "socialShare.copied": "已複製",
  "socialShare.platform.x": "X",
  "socialShare.platform.linkedin": "LinkedIn",
  "socialShare.platform.facebook": "Facebook",
  "socialShare.platform.reddit": "Reddit",
  "socialShare.platform.telegram": "Telegram",
  "socialShare.platform.whatsapp": "WhatsApp",
  "socialShare.platform.weibo": "微博",
  "socialShare.platform.line": "LINE",
  "socialShare.platform.instagram": "Instagram",
  "socialShare.platform.xiaohongshu": "小紅書",
  "inlineSwitcher.chipTitle": "切換 CLI / 模型",
  "inlineSwitcher.chipCli": "本機 CLI",
  "inlineSwitcher.chipByok": "自備 Key",
  "inlineSwitcher.modelDefault": "預設",
  "inlineSwitcher.noAgent": "未選擇",
  "inlineSwitcher.modeLabel": "模式",
  "inlineSwitcher.agentLabel": "代理",
  "inlineSwitcher.providerLabel": "服務商",
  "inlineSwitcher.modelLabel": "模型",
  "inlineSwitcher.useCli": "使用本機 CLI",
  "inlineSwitcher.useByok": "使用自備 API Key",
  "inlineSwitcher.daemonOffline": "守護程序離線 — 開啟設定",
  "inlineSwitcher.noAgentsDetected": "PATH 中未偵測到可用 CLI",
  "inlineSwitcher.openSettingsForModel": "在「設定」中設定該服務商",
  "inlineSwitcher.missingApiKey": "尚未填寫 API Key — 在「設定」中新增。",
  "inlineSwitcher.openFullSettings": "開啟執行設定",
  "inlineSwitcher.customSuffix": "（自訂）",
  "project.backToProjects": "返回專案列表",
  "project.brandReadyTitle": "{name} 設計體系已就緒",
  "project.brandReadyTitleGeneric": "你的設計體系已就緒",
  "project.brandReadyCta": "在設計體系中預覽",
  "project.brandReadyDismiss": "忽略",
  "project.brandReadyRefineHint":
    "自動擷取可能漏掉細節。大範圍使用前先最佳化這套體系。",
  "project.brandReadyAiOptimize": "AI 最佳化",
  "project.brandReadyEditManually": "手動編輯",
  "project.brandReadyPreviewOpened": "已跳轉到設計體系預覽。",
  "project.metaFreeform": "自由設計",
  "project.customInstructions": "專案指示",
  "project.customInstructionsPlaceholder": "此專案的指示（每則訊息都會注入）…",
  "project.resizeChatPanel": "調整聊天面板大小",
  "project.instructionsActive": "已生效 — 每則訊息都會附帶",
  "project.missing": "該專案已刪除或不存在。",
  "chat.tabChat": "對話",
  "chat.tabComments": "評論",
  "chat.commentsSoon": "評論 — 即將上線",
  "chat.comments.attached": "已附加到對話",
  "chat.comments.emptyAttached": "沒有已附加的評論。",
  "chat.comments.saved": "已儲存的評論",
  "chat.comments.emptySaved": "沒有已儲存的評論。",
  "chat.comments.add": "新增",
  "chat.comments.addAll": "全部新增",
  "chat.comments.remove": "移除",
  "chat.comments.placeholder": "評論此元素…",
  "chat.comments.addSend": "新增並傳送",
  "chat.comments.updateSend": "更新並傳送",
  "chat.comments.removeAttachment": "移除評論附件",
  "chat.comments.removeAttachmentAria": "移除 {name} 的評論附件",
  "chat.comments.comment": "留言",
  "chat.comments.sendToChat": "傳送至對話",
  "chat.comments.sending": "傳送中…",
  "chat.comments.edit": "編輯",
  "chat.comments.select": "選取",
  "chat.comments.selectAll": "全選",
  "chat.comments.deselect": "取消選取",
  "chat.comments.nSelected": "已選取 {n} 項",
  "chat.comments.pin": "釘選",
  "chat.comments.addNote": "新增備註",
  "chat.comments.savedToast": "留言已儲存",
  "chat.comments.pinSavedToast": "釘選已儲存",
  "chat.comments.pinAtCoords": "at {x}, {y}",
  "chat.comments.capturedItems": "已擷取 {n} 個項目",
  "chat.comments.clear": "清除",
  "chat.comments.targetImage": "圖片",
  "chat.comments.targetControl": "控制項",
  "chat.comments.targetLink": "連結",
  "chat.comments.targetText": "文字",
  "chat.comments.targetSection": "區段",
  "chat.comments.targetPage": "頁面",
  "chat.comments.targetArea": "區域",
  "chat.annotationNotePlaceholder": "為這個標記加入說明",
  "chat.annotationAttachImage": "加入圖片",
  "chat.annotationAttachedImages": "已加入圖片",
  "chat.annotationAttachedRemove": "移除最後一張圖片",
  "chat.annotationAddToInput": "送到輸入框",
  "chat.annotationAddingToInput": "正在加入...",
  "chat.annotationQueue": "加入佇列",
  "chat.annotationQueueing": "加入佇列中...",
  "chat.annotationSubmitOptions": "提交選項",
  "chat.annotationSending": "傳送中...",
  "chat.annotationSendDisabledReason": "目前正有任務執行中",
  "chat.annotationPreviewMissing": "無法截到下方預覽，請重試",
  "chat.annotationPreviewMissingInk":
    "無法截到下方預覽，請重試，避免只附帶筆跡",
  "chat.annotationSentWithoutScreenshot":
    "未能擷取預覽，已傳送標註（不含截圖）。",
  "chat.annotationTimeout": "標註傳送逾時，請重試",
  "chat.annotationFailed": "標註傳送失敗，請重試",
  "chat.annotationProjectCreateFailed": "無法建立專案，因此未送出標註。",
  "chat.annotationUploadFailed": "附件上傳失敗，請重試。",
  "chat.conversationsTitle": "對話紀錄",
  "chat.conversationsAria": "對話紀錄",
  "chat.newConversation": "新建對話",
  "chat.newConversationsTitle": "新建對話",
  "chat.conversationsHeading": "對話",
  "chat.new": "新建",
  "chat.emptyConversations": "還沒有對話。",
  "chat.deleteConversation": "刪除對話",
  "chat.renameConversationLabel": "重新命名「{title}」",
  "chat.deleteConversationConfirm": "確定刪除「{title}」？該操作會刪除其訊息。",
  "chat.untitledConversation": "未命名對話",
  "chat.forkedConversationTitle": "{title} 分叉",
  "chat.forkConversationFailed": "無法分叉這個對話。",
  "chat.startTitle": "開始一個對話",
  "chat.startHint": "描述你想生成的內容，或從下面的範例開始：",
  "chat.brandBrowserAssistDesktopOnly":
    "瀏覽器輔助需要桌面應用，Open Design 才能讀取即時瀏覽器頁面。",
  "chat.brandBrowserAssistReadFailed":
    "無法讀取瀏覽器頁面。請確認品牌網站已開啟並完整載入。",
  "chat.brandBrowserAssistMessage":
    "Open Design 需要瀏覽器輔助才能完成這次品牌擷取。請先在 Browser 分頁清除頁面攔截，然後在下方確認。",
  "brandEnrichment.title": "AI 優化",
  "brandEnrichment.body":
    "Open Design 會在背景執行更深度的抽取，自動套用合適的設計系統 skills，並就地更新這個系統。通常需要 10-20 分鐘，你可以繼續做其他事。",
  "brandEnrichment.cta": "AI 優化",
  "brandEnrichment.busy": "正在啟動 AI 優化...",
  "brandExtractionTranscript.sourceDesignMd": "貼上的 DESIGN.md",
  "brandExtractionTranscript.user": "從 {source} 抽取一個設計系統。",
  "brandExtractionTranscript.doneTitle": "{name} 的程式化抽取已完成。",
  "brandExtractionTranscript.doneBody":
    "我已經從 {source} 建立並註冊了 {designSystemId} 設計系統。現在可以預覽，也可以直接用於新設計。",
  "brandExtractionTranscript.next":
    "接下來，你可以選擇：讓 agent 消耗模型 token 做更深一輪語義化擷取並就地更新設計系統，或用這個已擷取的設計系統建立新設計。",
  "chat.fillInputTitle": "點擊填充到輸入框",
  "chat.jumpToLatest": "回到最新",
  "chat.scrollToLatest": "捲動到最新",
  "chat.you": "你",
  "chat.openFile": "開啟 {name}",
  "chat.copyPrompt": "複製提示詞",
  "chat.copyErrorDiagnostic": "複製錯誤診斷資訊",
  "chat.copyDone": "已複製！",
  "chat.inspect.noEditableTargets": "未找到可編輯的文字或樣式目標。",
  "chat.inspect.noCommentTargets": "未找到可評論的文字或視覺目標。",
  "chat.inspect.editHint": "在預覽中選擇文字或樣式目標進行編輯。",
  "chat.inspect.commentHint": "在預覽中選擇文字或區域進行評論。",
  "chat.composerPlaceholder": "描述你想生成的內容…",
  "chat.activeFileEditingLabel": "編輯中",
  "chat.activeFilePlaceholder": "讓 Open Design 修改 {file}...",
  "chat.designArtifactsShowMore": "再顯示 {count} 個設計檔案",
  "chat.mode.chat.label": "詢問",
  "chat.mode.chat.title": "Ask 模式",
  "chat.mode.chat.summary":
    "適合快速問答、修改建議、規劃和討論，不預設建立新的設計產物。",
  "chat.mode.chat.solves":
    "用來釐清想法、調整提示詞、比較方案，或詢問既有稿子的改進點。",
  "chat.mode.chat.query1": "總結這份稿子，並指出還缺什麼。",
  "chat.mode.chat.query2": "幫我判斷這個落地頁應該怎麼組織結構。",
  "chat.mode.chat.query3": "看一下這個設計，給我具體的改進建議。",
  "chat.mode.plan.label": "規劃",
  "chat.mode.plan.title": "規劃模式",
  "chat.mode.plan.summary":
    "先產生可編輯的規劃文件，等你確認和修改後，再交給 Design 產生最終成果。",
  "chat.mode.plan.solves":
    "適合 PRD、PPT 大綱、原型需求、線框圖、分鏡腳本，以及任何需要先確認方向的大需求。",
  "chat.mode.plan.query1": "先產生一份逐頁 PPT 大綱。",
  "chat.mode.plan.query2": "先寫 PRD，再基於 PRD 產生原型。",
  "chat.mode.plan.query3": "把這個想法整理成可編輯的設計規劃文件。",
  "chat.mode.design.label": "設計",
  "chat.mode.design.title": "設計模式",
  "chat.mode.design.summary":
    "適合建立或修改具體設計產物，例如網頁、原型、即時看板、投影片、圖片、影片、HyperFrames、音訊、資料看板和專案檔案。",
  "chat.mode.design.solves":
    "當你希望 Open Design 產生檔案、更新 workspace，或把需求變成多模態可交付結果時使用。",
  "chat.mode.design.query1":
    "根據這段需求做一個產品發布落地頁和 HyperFrames 原型。",
  "chat.mode.design.query2": "做一份 10 頁投資人 Deck，並附上講稿備註。",
  "chat.mode.design.query3": "為這次 campaign 產生圖片、影片和音訊創意。",
  "chat.mode.cardBestFor": "適合解決",
  "chat.mode.cardTry": "可以這樣問",
  "chat.mode.cardCost": "預估消耗",
  "chat.mode.chat.cost": "較低",
  "chat.mode.chat.costNote": "只是對話，不產生任何檔案，消耗最少。",
  "chat.mode.plan.cost": "中等",
  "chat.mode.plan.costNote": "先產生一份可編輯的方案文件，再進入產生階段。",
  "chat.mode.design.cost": "較高",
  "chat.mode.design.costNote": "會產生檔案和多模態內容，單次執行消耗可能最高。",
  "chat.composerHint": "⌘/Ctrl + Enter 傳送 · 說清目標、內容、風格和格式",
  "chat.cliSettingsTitle": "CLI 與模型設定",
  "chat.cliSettingsAria": "開啟 CLI 與模型設定",
  "chat.attachTitle": "附加檔案（也可以貼上/拖入）",
  "chat.addContextTitle": "新增內容",
  "chat.attachAria": "附加檔案",
  "chat.importTitle": "匯入素材（即將上線）",
  "chat.importLabel": "匯入",
  "chat.importComingSoon": "即將上線",
  "chat.importSoon": "即將",
  "chat.importFig": "上傳 .fig 檔案",
  "chat.importGitHub": "連接 GitHub",
  "chat.importWeb": "擷取網頁元素",
  "chat.importFolder": "關聯程式碼目錄",
  "chat.importSkills": "技能與設計系統",
  "chat.importProject": "引用其它專案",
  "chat.importDesignSystemHeader": "選擇一個設計系統",
  "chat.importDesignSystemBack": "返回",
  "chat.importDesignSystemSearch": "搜尋設計系統…",
  "chat.importDesignSystemEmpty": '沒有符合 "{query}" 的設計系統',
  "chat.importDesignSystemNone": "不指定 — 自由風格",
  "chat.importDesignSystemNoneSub": "此回合不錨定任何系統",
  "chat.importDesignSystemActive": "目前",
  "chat.importDesignSystemSwitched": "已切換設計系統為 {title}",
  "chat.importDesignSystemFailed": "切換設計系統失敗，請重試。",
  "chat.importDesignSystemLoadFailed": "無法載入設計體系。",
  "browserUse.title": "靈感",
  "browserUse.summary":
    "{count} 個網頁操作，優先展示素材提取、設計語言、動效、視覺校驗和元件結構。",
  "browserUse.searchAria": "搜尋靈感",
  "browserUse.searchPlaceholder": "搜尋截圖、字體、配色、a11y...",
  "browserUse.empty": "沒有符合的靈感",
  "browserUse.unavailable": "靈感暫不可用",
  "browserUse.added": "已加入輸入框",
  // Design Browser
  "designBrowser.aria": "内置浏览器",
  "designBrowser.goBack": "后退",
  "designBrowser.goForward": "前进",
  "designBrowser.reload": "重新加载",
  "designBrowser.stopLoading": "停止載入",
  "designBrowser.viewportAria": "浏览器视口",
  "designBrowser.addressPlaceholder": "输入 URL 或搜索...",
  "designBrowser.addressAria": "浏览器地址",
  "designBrowser.savePageBrief": "保存页面简报",
  "designBrowser.menu": "浏览器菜单",
  "designBrowser.suggestion.reference": "参考",
  "designBrowser.suggestion.history": "历史",
  "designBrowser.menu.copyScreenshot": "复制截图",
  "designBrowser.menu.hardReload": "强制刷新",
  "designBrowser.menu.copyUrl": "复制 URL",
  "designBrowser.menu.openInBrowser": "在浏览器中打开",
  "designBrowser.menu.savePageBrief": "保存页面简报",
  "designBrowser.menu.clearBrowsingHistory": "清除浏览历史",
  "designBrowser.menu.clearCookies": "清除 Cookie",
  "designBrowser.menu.clearAllData": "清除全部数据",
  "designBrowser.status.noUrlToCopy": "没有可复制的 URL",
  "designBrowser.status.urlCopied": "URL 已复制",
  "designBrowser.status.openHttpUrlFirst": "请先打开 http URL",
  "designBrowser.status.openPageBeforeScreenshot": "请先打开页面再截图",
  "designBrowser.status.screenshotCopied": "截图已复制到剪贴板",
  "designBrowser.status.screenshotSaved": "截图已保存到项目",
  "designBrowser.status.screenshotFailed": "截图失败",
  "designBrowser.status.openPageBeforeBrief": "请先打开页面再保存简报",
  "designBrowser.status.briefSaveFailed": "保存简报失败",
  "designBrowser.status.desktopDataUnavailable": "当前环境无法访问桌面浏览器数据",
  "designBrowser.status.browserDataCleared": "浏览器数据已清除",
  "designBrowser.status.browserDataClearFailed": "清除浏览器数据失败",
  "designBrowser.status.historyCleared": "浏览历史已清除",
  "designBrowser.status.openPageBeforeTools": "请先打开页面再使用浏览器工具",
  "designBrowser.status.clickElementToComment": "点击页面元素添加评论",
  "designBrowser.status.clickElementToTune": "点击页面元素调参",
  "designBrowser.status.noElementSelected": "未选中浏览器元素",
  "designBrowser.status.addBrowserComment": "添加浏览器评论",
  "designBrowser.status.tuneElementThenSaveHtml": "调整元素后保存 HTML",
  "designBrowser.status.tuneLiveOnly": "非项目页面只能实时预览调参",
  "designBrowser.status.pickerFailed": "浏览器元素选择失败",
  "designBrowser.status.applyStyleFailed": "无法在浏览器页面应用样式",
  "designBrowser.status.editTextFailed": "无法在浏览器页面编辑文本",
  "designBrowser.status.onlyProjectHtmlCanSave": "只能保存项目内 HTML 页面",
  "designBrowser.status.htmlSaved": "HTML 修改已保存",
  "designBrowser.status.htmlSaveFailed": "HTML 保存失败",
  "designBrowser.status.commentSavingUnavailable": "当前无法保存评论",
  "designBrowser.status.commentSaved": "浏览器评论已保存",
  "designBrowser.status.commentSendingUnavailable": "当前无法发送评论",
  "designBrowser.comments.aria": "浏览器评论",
  "designBrowser.comments.openFor": "打开 {label} 的浏览器评论",
  "designBrowser.comment.dialog": "浏览器评论",
  "designBrowser.comment.elementFallback": "浏览器元素",
  "designBrowser.comment.close": "关闭浏览器评论",
  "designBrowser.comment.noteAria": "浏览器评论备注",
  "designBrowser.comment.placeholder": "描述需要修改或检查的问题...",
  "designBrowser.comment.addNote": "添加备注",
  "designBrowser.comment.saveComment": "保存评论",
  "designBrowser.comment.sending": "正在发送...",
  "designBrowser.comment.sendToChat": "发送到对话",
  "designBrowser.inspect.editTitle": "编辑 HTML 元素",
  "designBrowser.inspect.tuneTitle": "调整浏览器元素",
  "designBrowser.inspect.closeTune": "关闭浏览器调参",
  "designBrowser.inspect.colors": "颜色",
  "designBrowser.inspect.text": "文本",
  "designBrowser.inspect.fill": "填充",
  "designBrowser.inspect.type": "字体",
  "designBrowser.inspect.size": "字号",
  "designBrowser.inspect.weight": "字重",
  "designBrowser.inspect.spacing": "间距",
  "designBrowser.inspect.pad": "内边距",
  "designBrowser.inspect.radius": "圆角",
  "designBrowser.inspect.content": "内容",
  "designBrowser.inspect.elementText": "元素文本",
  "designBrowser.inspect.saving": "正在保存...",
  "designBrowser.inspect.saveHtml": "保存 HTML",
  "designBrowser.inspect.liveOnly": "仅实时预览",
  "designBrowser.reference.kicker": "Open Design 浏览器",
  "designBrowser.reference.title": "参考看板",
  "designBrowser.reference.subtitle": "精选灵感、真实产品 UI、动效、色彩、字体、素材和设计系统参考。打开任意站点即可边浏览边收集下一个产物所需的设计语言。",
  "designBrowser.reference.categoryAria": "参考分类",
  "designBrowser.reference.searchPlaceholder": "搜索参考...",
  "designBrowser.reference.searchAria": "搜索参考",
  "designBrowser.reference.clearSearch": "清除搜索",
  "designBrowser.reference.noMatches": "没有匹配“{query}”的参考。",
  "designBrowser.reference.clearFilters": "清除筛选",
  "designBrowser.reference.open": "打开",
  "designBrowser.reference.group.inspiration": "灵感",
  "designBrowser.reference.group.interfaces": "真实界面",
  "designBrowser.reference.group.motion": "动效",
  "designBrowser.reference.group.color": "色彩",
  "designBrowser.reference.group.type": "字体",
  "designBrowser.reference.group.icons": "图标",
  "designBrowser.reference.group.illustration": "插画",
  "designBrowser.reference.group.photography": "摄影",
  "designBrowser.reference.group.3d": "3D 与图形",
  "designBrowser.reference.group.mockups": "样机",
  "designBrowser.reference.group.systems": "设计系统",
  "designBrowser.reference.group.components": "组件",
  "designBrowser.reference.group.guidelines": "规范与无障碍",
  "designBrowser.reference.group.tools": "工具与资源",
  "designBrowser.reference.site.dribbble.detail": "设计作品和 UI 灵感。",
  "designBrowser.reference.site.behance.detail": "创意作品集和案例研究。",
  "designBrowser.reference.site.awwwards.detail": "获奖网站设计参考。",
  "designBrowser.reference.site.godly.detail": "现代网页设计精选。",
  "designBrowser.reference.site.land_book.detail": "落地页图库和版式模式。",
  "designBrowser.reference.site.mobbin.detail": "真实 App 界面和 UI 模式。",
  "designBrowser.reference.site.screenlane.detail": "来自 App 的最新 UI 设计模式。",
  "designBrowser.reference.site.pageflows.detail": "真实产品用户流程和引导。",
  "designBrowser.reference.site.uisources.detail": "头部 App 的交互模式。",
  "designBrowser.reference.site.collectui.detail": "按类别整理的每日 UI 集合。",
  "designBrowser.reference.site.gsap.detail": "生产级动画引擎和示例。",
  "designBrowser.reference.site.animations.detail": "动画模式和交互示例。",
  "designBrowser.reference.site.transitions.detail": "现代界面的转场模式。",
  "designBrowser.reference.site.motionsites.detail": "高品质动效和交互参考。",
  "designBrowser.reference.site.motion.detail": "滚动和时间轴动画灵感。",
  "designBrowser.reference.site.animography.detail": "动态字体和文字动效。",
  "designBrowser.reference.site.reactbits.detail": "React 闪光文字动效参考。",
  "designBrowser.reference.site.coolors.detail": "快速配色生成器。",
  "designBrowser.reference.site.colorhunt.detail": "精选配色方案。",
  "designBrowser.reference.site.realtimecolors.detail": "在真实 UI 中预览配色。",
  "designBrowser.reference.site.color_adobe.detail": "色轮和配色和谐规则。",
  "designBrowser.reference.site.happyhues.detail": "放在真实语境中的配色。",
  "designBrowser.reference.site.fonts_google.detail": "开源字体库。",
  "designBrowser.reference.site.fontshare.detail": "可商用的高质量免费字体。",
  "designBrowser.reference.site.typewolf.detail": "字体使用案例和搭配建议。",
  "designBrowser.reference.site.fontpair.detail": "字体搭配建议。",
  "designBrowser.reference.site.fontsinuse.detail": "真实设计中的字体案例。",
  "designBrowser.reference.site.thesvg.detail": "SVG 素材和矢量参考。",
  "designBrowser.reference.site.svglogos.detail": "适合产品和品牌稿的干净 SVG Logo。",
  "designBrowser.reference.site.icons_lobehub.detail": "产品和 AI 品牌界面图标。",
  "designBrowser.reference.site.icon_sets_iconify.detail": "20 万+ 开源图标集合。",
  "designBrowser.reference.site.lucide.detail": "简洁一致的开源图标集。",
  "designBrowser.reference.site.heroicons.detail": "Tailwind 出品的 SVG 图标。",
  "designBrowser.reference.site.svgrepo.detail": "免费 SVG 矢量和图标。",
  "designBrowser.reference.site.storyset.detail": "可定制矢量插画。",
  "designBrowser.reference.site.undraw.detail": "MIT 协议开源插画。",
  "designBrowser.reference.site.blush.detail": "可混搭组合的插画。",
  "designBrowser.reference.site.lummi.detail": "免费 AI 生成视觉素材。",
  "designBrowser.reference.site.whirrls.detail": "手绘风图片参考。",
  "designBrowser.reference.site.worldindots.detail": "点阵地图和数据可视化参考。",
  "designBrowser.reference.site.unsplash.detail": "免费高分辨率照片。",
  "designBrowser.reference.site.pexels.detail": "免费图库照片和视频。",
  "designBrowser.reference.site.pixabay.detail": "免版税图片和媒体素材。",
  "designBrowser.reference.site.cosmos.detail": "视觉发现和情绪板。",
  "designBrowser.reference.site.spline.detail": "浏览器中的 3D 设计工具。",
  "designBrowser.reference.site.threejs.detail": "WebGL 3D 参考和演示。",
  "designBrowser.reference.site.womp.detail": "易上手的浏览器 3D 创作。",
  "designBrowser.reference.site.pixcap.detail": "3D 图标、样机和场景。",
  "designBrowser.reference.site.shots.detail": "设备和浏览器样机。",
  "designBrowser.reference.site.mockuuups.detail": "拖拽式设备样机。",
  "designBrowser.reference.site.angle.detail": "3D 设备样机库。",
  "designBrowser.reference.site.rotato.detail": "动画 3D 产品样机。",
  "designBrowser.reference.site.impeccable.detail": "高质量风格和界面参考。",
  "designBrowser.reference.site.styles_refero.detail": "设计风格参考和视觉系统。",
  "designBrowser.reference.site.brandfetch.detail": "品牌素材、Logo 和识别资产。",
  "designBrowser.reference.site.designsystemsrepo.detail": "公开设计系统图库。",
  "designBrowser.reference.site.startups.detail": "头部创业公司的产品和品牌参考。",
  "designBrowser.reference.site.base_ui.detail": "用于自定义系统的无样式无障碍基础组件。",
  "designBrowser.reference.site.ui_shadcn.detail": "基于 Radix 和 Tailwind 的可组合 React 组件。",
  "designBrowser.reference.site.heroui.detail": "现代 React 组件库和设计系统。",
  "designBrowser.reference.site.radix_ui.detail": "无障碍低层 UI 原语。",
  "designBrowser.reference.site.react_spectrum_adobe.detail": "Adobe 出品的无障碍行为原语。",
  "designBrowser.reference.site.headlessui.detail": "面向 Tailwind 的无样式无障碍组件。",
  "designBrowser.reference.site.mui.detail": "基于 Material 的 React 组件生态。",
  "designBrowser.reference.site.mantine.detail": "功能完整的 React 组件和 Hooks。",
  "designBrowser.reference.site.chakra_ui.detail": "带主题 token 的无障碍 React 组件。",
  "designBrowser.reference.site.ant.detail": "企业级组件系统和模式。",
  "designBrowser.reference.site.ark_ui.detail": "跨现代框架的 Headless 组件。",
  "designBrowser.reference.site.daisyui.detail": "Tailwind CSS 组件类和主题。",
  "designBrowser.reference.site.developer_apple.detail": "Apple 平台设计规范。",
  "designBrowser.reference.site.m3_material.detail": "Google Material Design 3。",
  "designBrowser.reference.site.lawsofux.detail": "UX 原则和启发式规则。",
  "designBrowser.reference.site.webaim.detail": "颜色对比度检查器。",
  "designBrowser.reference.site.a11yproject.detail": "无障碍清单和模式。",
  "designBrowser.reference.site.toolfolio.detail": "设计工具、资源和集合。",
  "designBrowser.reference.site.getdesign.detail": "精选设计资源。",
  "designBrowser.reference.site.tasteskill.detail": "设计品味训练和评审参考。",
  "designBrowser.reference.site.uigoodies.detail": "手工精选设计资源。",
  "designBrowser.reference.site.sidebar.detail": "每天五条设计链接。",
  "designBrowser.reference.site.github.detail": "嵌入式浏览器工作流的参考实现。",
  "browserUse.category.assets": "素材提取",
  "browserUse.category.tokens": "設計語言",
  "browserUse.category.motion": "動效",
  "browserUse.category.visual": "視覺校驗",
  "browserUse.category.structure": "元件結構",
  "browserUse.category.project": "專案執行",
  "browserUse.category.general": "通用操作",
  "browserUse.input.none": "無需輸入",
  "browserUse.input.assetKind": "類型：images / svgs / media / fonts，最多 200",
  "browserUse.input.optionalSelector": "可選選擇器",
  "browserUse.input.requirementSelector": "校驗要求，可選選擇器",
  "browserUse.input.selectorOptional": "可選選擇器",
  "browserUse.input.scaleOne": "縮放 1x",
  "browserUse.input.selectorScaleTwo": "選擇器，預設 2x",
  "browserUse.input.gridOverlay": "12 欄，最大寬 1200，間距 24",
  "browserUse.input.bodySelector": "selector='body'",
  "browserUse.input.navigate": "URL、網域或搜尋詞",
  "browserUse.input.selector": "選擇器",
  "browserUse.input.selectorText": "選擇器和文字",
  "browserUse.input.scroll": "像素、top、bottom 或 page",
  "browserUse.input.terminalRun": "命令，逾時 120 秒",
  "browserUse.input.command": "命令",
  "browserUse.input.maxChars": "最多 8000 字元",
  "browserUse.input.custom": "{input}",
  "browserUse.action.extract_logo.output":
    "從 header、nav、類名、位置、OG 圖片和 favicon 中找出最可能的 Logo。",
  "browserUse.action.list_images.output":
    "枚舉 img、srcset、source 和 CSS 背景圖，並帶尺寸和 alt。",
  "browserUse.action.download_assets.output":
    "下載素材資料夾，並生成支援 referer/cookie 的 _manifest.json。",
  "browserUse.action.extract_svgs.output":
    "提取內聯 SVG 和外鏈 .svg，分別儲存為 SVG 檔案。",
  "browserUse.action.optimize_svgs.output":
    "輸出最佳化後的 SVG 檔案和壓縮比例。",
  "browserUse.action.extract_colors.output":
    "頻率加權配色板和 :root CSS 顏色變數，輸出 palette.json 與 palette.html。",
  "browserUse.action.extract_fonts.output":
    "字體家族、字號、字重和 @font-face Top 列表，輸出 typography.json。",
  "browserUse.action.extract_design_tokens.output":
    "圓角、陰影、間距和 CSS 變數，輸出 tokens.json。",
  "browserUse.action.extract_type_scale.output":
    "標題、正文、按鈕的字號階梯、字重、行高和比例。",
  "browserUse.action.extract_buttons.output":
    "去重後的按鈕樣式庫，輸出 buttons.html 和 buttons.json。",
  "browserUse.action.extract_grid_system.output":
    "Grid/Flex 容器、方向、間距、欄數和最大寬度，輸出 layout.json。",
  "browserUse.action.extract_breakpoints.output":
    "響應式媒體查詢斷點，輸出 breakpoints.json。",
  "browserUse.action.extract_gradients.output":
    "CSS 漸層，輸出 gradients.css、gradients.json 和 HTML 預覽。",
  "browserUse.action.extract_shadows.output":
    "box-shadow、text-shadow 和 drop-shadow，輸出 shadows.json 和預覽。",
  "browserUse.action.extract_easings.output":
    "過渡和動畫緩動函式，輸出 easings.json。",
  "browserUse.action.export_tokens.output":
    "匯出 tokens.css、tokens.scss、tailwind.theme.js 和 style-dictionary.tokens.json。",
  "browserUse.action.extract_animations.output":
    "@keyframes、transition、transform 規則和動效庫偵測，輸出 motion.css 與 motion.json。",
  "browserUse.action.validate_view.output": "截圖路徑和結構化視覺/版面問題。",
  "browserUse.action.audit_layout.output":
    "版面缺陷偵測：溢出、越界、重疊、文字裁切，輸出 audit.json。",
  "browserUse.action.audit_accessibility.output":
    "A11y 問題：選擇器、標籤、角色、焦點、對比度，以及必要截圖。",
  "browserUse.action.responsive_screenshots.output":
    "mobile 390、tablet 834、desktop 1440 三檔截圖。",
  "browserUse.action.screenshot_full.output": "超出視口的整頁長截圖。",
  "browserUse.action.screenshot_element.output": "單元素截圖，預設 2x。",
  "browserUse.action.screenshot_with_grid.output": "帶版面柵格疊加的截圖。",
  "browserUse.action.screenshot_dark_mode.output":
    "模擬 prefers-color-scheme: dark 後截圖。",
  "browserUse.action.generate_styleguide.output":
    "一頁式樣式指南，包含配色、字號階梯、圓角和陰影。",
  "browserUse.action.extract_html.output":
    "清洗後的自包含 HTML，移除 script、noscript 和內聯事件屬性。",
  "browserUse.action.extract_component_inventory.output":
    "重複元件模式、選擇器、數量和截圖。",
  "browserUse.action.extract_copy.output":
    "標題、CTA、正文和描述，輸出 copy.md 與 copy.json。",
  "browserUse.action.extract_nav.output":
    "主導覽和頁腳連結，輸出 sitemap.md 與 nav.json。",
  "browserUse.action.extract_forms.output":
    "表單欄位、標籤、校驗提示和提交動作，輸出 forms.json。",
  "browserUse.action.run_project.output":
    "識別 dev server URL 並在 Browser 標籤中開啟。",
  "browserUse.action.detect_project.output":
    "框架、套件管理器、安裝命令、dev 命令和連接埠。",
  "browserUse.action.page_info.output":
    "URL、標題、描述、OG 圖片、主題色、favicon 和 viewport。",
  "browserUse.action.snapshot.output":
    "最多 120 個可見互動/文字元素，含 tag、label、href 和座標。",
  "browserUse.action.navigate.output": "開啟頁面並返回 page_info。",
  "browserUse.action.click.output": "捲動到可見後點擊第一個匹配元素。",
  "browserUse.action.type_text.output":
    "填寫輸入框，並觸發 input/change 事件。",
  "browserUse.action.scroll.output": "目前和最大捲動位置。",
  "browserUse.action.extract_og_metadata.output":
    "Meta 標題/描述/canonical、OG/Twitter 卡片、社交圖和主題色。",
  "browserUse.action.terminal_run.output": "stdout、stderr 和退出碼。",
  "browserUse.action.terminal_run_background.output":
    "背景任務 id 和最近輸出。",
  "browserUse.action.terminal_read.output": "共享終端最近輸出。",
  "chat.designToolbox.title": "設計百寶箱",
  "chat.designToolbox.tooltip": "设计百宝箱",
  "chat.designToolbox.aria": "開啟設計百寶箱",
  "chat.designToolbox.searchPlaceholder":
    "搜索 skills / MCP / plugins / connectors / design files…",
  "chat.designToolbox.searchAria": "搜尋設計百寶箱資源",
  "chat.designToolbox.followupSection": "後續動作",
  "chat.designToolbox.resourcesSection": "全域資源",
  "chat.designToolbox.selected": "已選",
  "chat.designToolbox.noResources": "找不到與「{query}」相關的資源。",
  "chat.designToolbox.badge.video": "影片",
  "chat.designToolbox.badge.image": "圖像",
  "chat.designToolbox.badge.motion": "動效",
  "chat.designToolbox.badge.polish": "潤色",
  "chat.designToolbox.action.auto-match.title": "智慧匹配下一步",
  "chat.designToolbox.action.auto-match.badge": "匹配",
  "chat.designToolbox.action.auto-match.description":
    "先定義好看標準，再全域匹配 skills / MCP / plugins / connectors / files。",
  "chat.designToolbox.action.asset-search.title": "找图 / 找参考图",
  "chat.designToolbox.action.asset-search.badge": "素材",
  "chat.designToolbox.action.asset-search.description":
    "为当前设计搜索可用图片、参考截图、moodboard 和素材来源候选。",
  "chat.designToolbox.action.icon-workflow.title": "找 icon / 替换 icon",
  "chat.designToolbox.action.icon-workflow.badge": "图标",
  "chat.designToolbox.action.icon-workflow.description":
    "查找、生成或替换图标、SVG、Lucide icon 和视觉符号，并保持风格一致。",
  "chat.designToolbox.action.image-replace.title": "替换页面图片",
  "chat.designToolbox.action.image-replace.badge": "换图",
  "chat.designToolbox.action.image-replace.description":
    "审查当前配图，把薄弱的 hero、分区、背景或卡片图片替换成更合适的素材。",
  "chat.designToolbox.action.reference-extract.title": "参考图获取 / 风格提取",
  "chat.designToolbox.action.reference-extract.badge": "参考",
  "chat.designToolbox.action.reference-extract.description":
    "分析参考截图或网站，提取配色、字体、布局姿态、动效和素材方向。",
  "chat.designToolbox.action.motion.title": "加动画 / 动效",
  "chat.designToolbox.action.motion.badge": "动画",
  "chat.designToolbox.action.motion.description":
    "给当前 HTML 或页面元素加入入场、滚动、状态切换和微交互。",
  "chat.designToolbox.action.motion-polish.title": "動效潤色",
  "chat.designToolbox.action.motion-polish.badge": "节奏",
  "chat.designToolbox.action.motion-polish.description":
    "检查现有动效的节奏、缓动、性能和 reduced-motion 兜底。",
  "chat.designToolbox.action.transition-motion.title": "设计过场动画",
  "chat.designToolbox.action.transition-motion.badge": "过场",
  "chat.designToolbox.action.transition-motion.description":
    "设计页面、场景、加载和状态切换过场，并补上克制节奏和 reduced-motion 兜底。",
  "chat.designToolbox.action.threejs-scene.title": "3D / Three.js 场景",
  "chat.designToolbox.action.threejs-scene.badge": "3D",
  "chat.designToolbox.action.threejs-scene.description":
    "加入或规划 Three.js、Spline、Vanta、粒子、WebGL、地图或 deck.gl 风格交互视觉。",
  "chat.designToolbox.action.anti-ai-polish.title": "反 AI 味美化",
  "chat.designToolbox.action.anti-ai-polish.badge": "去味",
  "chat.designToolbox.action.anti-ai-polish.description":
    "移除模板感、AI 紫蓝渐变、廉价卡片堆叠和空泛 copy。",
  "chat.designToolbox.action.visual-polish.title": "設計潤色 / 可交付",
  "chat.designToolbox.action.visual-polish.badge": "润色",
  "chat.designToolbox.action.visual-polish.description":
    "审一次视觉层级、排版、间距、响应式、可访问性和交付状态。",
  "chat.designToolbox.action.image-gen.title": "生图 / 视觉参考",
  "chat.designToolbox.action.image-gen.badge": "生图",
  "chat.designToolbox.action.image-gen.description":
    "为当前页面生成分区视觉参考、素材、图标、社媒图或 moodboard。",
  "chat.designToolbox.action.chart-gen.title": "图表 / 图解生成",
  "chat.designToolbox.action.chart-gen.badge": "图表",
  "chat.designToolbox.action.chart-gen.description":
    "生成 ECharts、React Flow、图解、数据看板、关系图或数据可视化素材。",
  "chat.designToolbox.action.logo-gen.title": "logo / 品牌标识生成",
  "chat.designToolbox.action.logo-gen.badge": "Logo",
  "chat.designToolbox.action.logo-gen.description":
    "为当前品牌创建 logo 路线、字标、组合标、符号和身份系统生成 prompt。",
  "chat.designToolbox.action.plan-outline.title": "基於想法產生 PPT 大綱",
  "chat.designToolbox.action.plan-outline.badge": "規劃",
  "chat.designToolbox.action.plan-outline.description":
    "先把粗略想法變成可編輯的 Markdown PPT 大綱，再建立投影片。",
  "chat.designToolbox.action.video-gen.title": "生视频 / 动画脚本",
  "chat.designToolbox.action.video-gen.badge": "视频",
  "chat.designToolbox.action.video-gen.description":
    "把设计转成短视频、Remotion / Hyperframes 分镜或可生成视频的 prompt。",
  "chat.designToolbox.kind.skill": "技能",
  "chat.designToolbox.kind.plugin": "外掛",
  "chat.designToolbox.kind.mcp": "MCP",
  "chat.designToolbox.kind.mcpTemplate": "MCP 模板",
  "chat.designToolbox.kind.connector": "連接器",
  "chat.designToolbox.kind.designFile": "設計檔案",
  "chat.designToolbox.context.browser": "瀏覽器",
  "chat.designToolbox.context.designFiles": "設計檔案",
  "chat.designToolbox.context.designSystem": "設計系統",
  "chat.designToolbox.context.folder": "資料夾",
  "chat.designToolbox.context.terminal": "終端機",
  "chat.designToolbox.context.sideChat": "侧边对话",
  "chat.designToolbox.context.liveArtifact": "即時看板",
  "chat.designToolbox.context.file": "文件",
  "chat.designToolbox.prompt.contextGeneric":
    "当前目标：当前打开的 HTML / 设计文件 / 网页元素。",
  "chat.designToolbox.prompt.contextSpecific": "当前目标：{kind} · {label}。",
  "chat.designToolbox.prompt.preserveDraft":
    "保留我输入框里已有的意图：{draft}",
  "chat.designToolbox.prompt.selectedSkill":
    "已选 skill：{skill}。请把它作为本轮主要工作流。",
  "chat.designToolbox.prompt.noSkill":
    "如果没有匹配到具体 skill，请先从当前可用 skills / MCP / plugins / connectors / design files 中选择最合适的组合。",
  "chat.designToolbox.prompt.autoMatchIntro":
    "请作为 Creative Director 总调度完成一套设计流程：",
  "chat.designToolbox.prompt.autoMatchStep1":
    "1. 先帮我定义“什么是好看的设计”：受众、业务目标、品牌气质、风格参考、信息密度、色彩/字体/动效/素材标准，以及不能出现的 AI 味/模板感。",
  "chat.designToolbox.prompt.autoMatchStep2":
    "2. 搜索并匹配上面的全量资源索引，不要只看设计百宝箱推荐项；需要时组合 skills、MCP、plugins、connectors 和 design files。",
  "chat.designToolbox.prompt.autoMatchStep3":
    "3. 如果目标或审美标准还不够清楚，用结构化 question-form 引导我选择，给出推荐默认项，并确保每个有限选项问题都有可编辑的自定义填写入口；如果已经足够清楚，直接执行下一步。",
  "chat.designToolbox.prompt.autoMatchStep4":
    "4. 按“诊断 -> 风格方向 -> 资源选择 -> 具体改动/生成 -> 验证”的顺序走完全程。每一步说明为什么选这些资源，以及下一步需要我确认什么。",
  "chat.designToolbox.prompt.assetSearch":
    "为当前设计寻找最合适的图片/参考素材。搜索现有文件、connectors、MCP、浏览器截图和生成工具，给出具体候选、使用方式、必要的授权/来源提醒；如果没有可用素材，给出可执行的生图 prompt。",
  "chat.designToolbox.prompt.iconWorkflow":
    "优化当前设计的 icon 系统：找出缺失图标，替换薄弱图标，保持描边/填充/圆角/线宽一致；优先使用现有图标库，库里没有合适图标时再生成 SVG/icon prompt。",
  "chat.designToolbox.prompt.imageReplace":
    "审查当前设计里的每个图片位，找出占位感或质量弱的配图，然后替换或指定更好的 hero、分区、背景、卡片和社媒图。保持布局不乱，并给出明确文件/prompt/来源选择。",
  "chat.designToolbox.prompt.referenceExtract":
    "把当前参考图/参考网站/design file 当作视觉输入，提取配色、字号阶梯、布局节奏、组件姿态、动效线索和素材风格，再应用到当前设计；不要逐字复制受保护的品牌资产。",
  "chat.designToolbox.prompt.motion":
    "请基于当前 HTML / 页面元素加入高质量动效：入场、滚动、状态切换、过场、Rive/Lottie 风格图标动效或 GSAP/Motion 微交互任选最有效的 1-2 处。保持克制，优先 transform / opacity，并加 prefers-reduced-motion 兜底。",
  "chat.designToolbox.prompt.planOutline":
    "基于这个想法创建或更新一份 Markdown PPT/Deck 规划文档。暂时不要生成最终 PPT。请包含逐页标题、页面目标、内容要点、视觉方向、所需数据/素材和开放问题。把它保存为 Design Files 里的 `.md` 文件，并告诉我需要 review 哪个文件。",
  "chat.designToolbox.prompt.motionPolish":
    "请审查并润色现有动效的节奏、缓动、性能和可访问性。修掉突兀、廉价或影响阅读的动画；必要时改成更细腻的时间线。",
  "chat.designToolbox.prompt.transitionMotion":
    "为当前设计规划高质量过场动画：页面/场景切换、加载承接、状态变化和分区衔接。需要时使用 GSAP/Motion/CSS，保持性能和克制节奏，并提供 reduced-motion 行为。",
  "chat.designToolbox.prompt.threejsScene":
    "为当前设计规划或实现一个聚焦的 Three.js/WebGL 视觉。可考虑 Three.js、Spline 风格场景、Vanta 背景、粒子系统、Mapbox/deck.gl 数据层或浏览器 Portal 效果，但必须有用并验证可渲染。",
  "chat.designToolbox.prompt.antiAiPolish":
    "请做一次反 AI 味美化：移除模板化布局、廉价渐变/光晕、无意义卡片堆叠和空泛文案；保持信息不丢失，直接改到更像真实设计师交付。",
  "chat.designToolbox.prompt.visualPolish":
    "请把这个设计打磨到可交付：检查视觉层级、排版、间距、响应式、按钮状态、空/加载/错误状态和可访问性，并直接完成最重要的修正。",
  "chat.designToolbox.prompt.imageGen":
    "请为当前设计生成下一步视觉资产方案：可以是分区参考图、hero 素材、插画、icon、社媒图或 moodboard。先判断最缺哪类图，再给可执行的生成 prompt / 文件计划。",
  "chat.designToolbox.prompt.chartGen":
    "为当前设计生成最合适的图表、图解或数据可视化。根据数据和用户目标，在 ECharts、React Flow、SVG/CSS 图解、雷达图、关系图、看板或 deck.gl/地图可视化之间选择。",
  "chat.designToolbox.prompt.logoGen":
    "为当前品牌创建 logo 和身份方向。输出多条字标、符号、组合标、配色、使用规则和生成 prompt 路线；确保结果原创，并能落到当前 artifact 里。",
  "chat.designToolbox.prompt.videoGen":
    "请把当前设计转成视频方向：生成短视频分镜、Hyperframes / Remotion 帧结构或 Sora/fal 可用 prompt。优先让现有 HTML / 页面内容自然变成镜头。",
  "chat.designToolbox.prompt.useSkill": "使用 {skill} 处理当前设计。",
  "chat.designToolbox.prompt.skillInstruction":
    "请先判断最合适的加工目标，再直接完成一轮具体改动；如果它依赖外部素材或 API，请给出可运行的替代方案或明确需要我补充什么。",
  "chat.designToolbox.prompt.selectedResource":
    "已选资源：{kind} · {title}（{id}）。",
  "chat.designToolbox.prompt.resourceDescription": "资源说明：{description}",
  "chat.designToolbox.prompt.pluginResource":
    "请把这个 plugin 当作当前设计流程的主要上下文。如果它暴露输入项或 GenUI，请在需要时引导我选择；如果不适合当前目标，请改选更合适的全局资源并说明原因。",
  "chat.designToolbox.prompt.mcpResource":
    "请优先使用这个 MCP 能力完成当前设计下一步。需要外部素材、网页截图、图像/视频生成或数据时，先判断它能否完成，再给出可执行计划。",
  "chat.designToolbox.prompt.mcpTemplateResource":
    "这个 MCP 是可配置模板。如果它是完成当前设计最需要的工具，请先引导我完成配置；如果已有替代资源可用，请先用替代资源继续。",
  "chat.designToolbox.prompt.connectorResource":
    "请在需要真实数据、素材、账号内容或外部工作流时使用这个 connector；使用前先说明会读取/写入什么，必要时让我确认。",
  "chat.designToolbox.prompt.fileResource":
    "请把这个 design file 作为当前设计对象或参考资产，基于它完成下一步加工；如果需要同时比较其他文件，请从全量 design files 中继续搜索。",
  "chat.designToolbox.prompt.resourceIndex":
    "全局资源索引：skills({skills})、plugins({plugins})、MCP({mcpEnabled} enabled / {mcpTemplates} templates)、connectors({connectors} connected)、design files({files})。",
  "chat.designToolbox.prompt.searchableSkills": "可搜索 skills",
  "chat.designToolbox.prompt.searchablePlugins": "可搜索 plugins",
  "chat.designToolbox.prompt.availableMcp": "可用 MCP",
  "chat.designToolbox.prompt.connectedConnectors": "已连接 connectors",
  "chat.designToolbox.prompt.referenceDesignFiles": "可参考 design files",
  "chat.designToolbox.prompt.mcpTemplateName": "{name} 範本",
  "chat.designToolbox.prompt.processRule":
    "流程规则：先定义审美目标和约束，再搜索/匹配资源；需要用户选择时生成结构化 question-form，并为有限选项保留可编辑的自定义答案，确认后继续执行。",
  "chat.designToolbox.prompt.moreSuffix": "，+{count} more",
  "chat.designToolbox.prompt.compactLine": "{label}：{values}{suffix}。",
  "chat.mentionTabsAria": "提及來源",
  "chat.mentionTabAll": "全部",
  "chat.mentionTabTabs": "分頁",
  "chat.mentionTabPlugins": "外掛",
  "chat.mentionTabSkills": "技能",
  "chat.mentionTabMcp": "MCP",
  "chat.mentionTabConnectors": "連接器",
  "chat.mentionTabFiles": "設計檔案",
  "chat.mentionNoResults": "找不到「{query}」的結果。",
  "chat.mentionSearchPrompt":
    "搜尋設計檔案、分頁、外掛、技能、MCP 伺服器和連接器。",
  "chat.mentionSectionTabs": "分頁",
  "chat.mentionSectionPlugins": "外掛",
  "chat.mentionSectionSkills": "技能",
  "chat.mentionSectionMcp": "MCP",
  "chat.mentionSectionConnectors": "連接器",
  "chat.mentionSectionFiles": "設計檔案",
  "chat.mentionActiveSkill": "已啟用",
  "chat.mentionUseMcpTitle": "使用 {name}",
  "chat.mentionUseConnectorTitle": "使用 {name}",
  "chat.mentionPluginOfficial": "官方",
  "chat.mentionPluginMine": "我的外掛",
  "chat.linkedFolderRemoveAria": "移除關聯資料夾 {path}",
  "chat.linkedFolderNotFound": "資料夾不存在",
  "chat.linkedFolderAlready": "該資料夾已關聯",
  "chat.linkedFolderPickError": "無法開啟資料夾選擇器",
  "chat.queuedHeader": "已排入佇列",
  "chat.queuedToSend": "待傳送",
  "chat.queuedEditQueuedTaskAria": "編輯佇列中的任務",
  "chat.queuedSave": "儲存",
  "chat.queuedCancel": "取消",
  "chat.queuedReorder": "拖曳調整順序",
  "chat.queuedEdit": "編輯",
  "chat.queuedMore": "則待處理",
  "chat.queuedFollowUpFallback": "已排入佇列的後續任務",
  "chat.send": "傳送",
  "chat.stop": "停止",
  "chat.removeAria": "移除 {name}",
  "chat.example1Title": "編輯風路演 PPT",
  "chat.example1Tag": "雜誌",
  "chat.example1Prompt":
    "為一家正在融種子輪的設計工作室製作 10 張編輯風路演 PPT —— 瑞士格線佈局，超大號襯線標題加粗體首字下沉，等寬字體的章節編號，留白充足，整頁大圖與文字密集頁穿插出現。封面、願景、市場、產品、成長、團隊、融資需求、聯絡方式。",
  "chat.example2Title": "SaaS 分析儀表板",
  "chat.example2Tag": "資料",
  "chat.example2Prompt":
    "為一款面向開發者的 SaaS 設計一份資訊密度高的分析儀表板 —— 頂端 KPI 條帶（含週環比變化）、兩張堆疊折線圖（MRR 與活躍工作區）、全球使用熱力圖、留存矩陣、客戶排行榜以及即時事件流。深色主題，等寬數字，迷你圖作為點綴。",
  "chat.example3Title": "長捲動年度報告",
  "chat.example3Tag": "編輯",
  "chat.example3Prompt":
    "為一家關注氣候議題的非營利機構製作互動式年度報告 —— 長捲動編輯式佈局，混合大段引言區塊、資料視覺化（堆疊柱狀圖、動態計數器、專案地點分布的等值線地圖）、攝影分隔頁、捐贈者牆，以及最終行動號召。現代襯線內文、無襯線圖表標籤、大地紙張配色。",
  'home.recommendation.eyebrow': '為你推薦',
  'home.recommendation.primaryCta': '開始創作',
  'home.recommendation.change': '換一換',
  'home.recommendation.browseAll': '全部類型',
  'home.recommendation.defaultProjectName': '新增專案',
  'home.recommendation.startFailed': '無法開始建立，請重試。',
  'studio.firstArtifactHint.title': '你的第一個設計已就緒',
  'studio.firstArtifactHint.body': '試試直接編輯和標註，滿意後隨時匯出分享。',
  'studio.firstArtifactHint.dismiss': '知道了',
  'home.starter.product_ui_prototype.title': '從可編輯的產品原型開始',
  'home.starter.product_ui_prototype.desc': '根據你的目標，從一個可點擊、可反覆打磨的介面開始。',
  'home.starter.product_ui_prototype.firstPrompt': '為 [你的產品] 設計一個可編輯的產品原型，包含關鍵頁面和清晰的核心流程。',
  'home.starter.product_ui_component.title': '從可重複使用的元件開始',
  'home.starter.product_ui_component.desc': '先做一個元件，再把它組合成完整頁面。',
  'home.starter.product_ui_component.firstPrompt': '設計一個可重複使用的 [元件名稱] 元件，包含它的主要狀態和變體。',
  'home.starter.product_ui_lowfi.title': '從低保真原型開始',
  'home.starter.product_ui_lowfi.desc': '先勾勒結構，再逐步提升保真度。',
  'home.starter.product_ui_lowfi.firstPrompt': '為 [你的產品] 製作主要頁面的低保真線框圖。',
  'home.starter.marketing_landing.title': '從著陸頁開始',
  'home.starter.marketing_landing.desc': '把你的行銷活動變成一個可直接上線的著陸頁。',
  'home.starter.marketing_landing.firstPrompt': '為 [你的產品] 設計一個著陸頁，包含主視覺、核心賣點和清晰的行動號召。',
  'home.starter.marketing_multivariant.title': '從多個著陸頁版本開始',
  'home.starter.marketing_multivariant.desc': '在確定方案前，先生成幾個版本進行比較。',
  'home.starter.marketing_multivariant.firstPrompt': '為 [你的產品] 製作 3 個著陸頁版本，採用不同的主視覺文案以便比較。',
  'home.starter.internal_dashboard.title': '從內部儀表板開始',
  'home.starter.internal_dashboard.desc': '從貼合你工作流程的儀表板佈局開始。',
  'home.starter.internal_dashboard.firstPrompt': '設計一個內部儀表板，顯示 [關鍵指標]，並配有篩選器和資料表格。',
  'home.starter.internal_report.title': '從報表開始',
  'home.starter.internal_report.desc': '描述你想看到的資料和欄位。',
  'home.starter.internal_report.firstPrompt': '製作一個報表頁面，彙整 [描述你關心的資料、欄位和指標]。',
  'home.starter.general_menu.title': '從你的第一個專案開始',
  'home.starter.general_menu.desc': '描述你想要的內容，我們會生成一個可編輯的初始版本。',
  'home.starter.general_menu.firstPrompt': '為 [描述你想製作的內容] 生成一個可編輯的初始版本。',
  "chat.example4Title": "產品動效影片",
  "chat.example4Tag": "影片",
  "chat.example4Prompt":
    "為一款生產力 App 發布製作 15 秒動效影片分鏡：開場鉤子、UI 局部特寫、動態排版、功能轉場、結尾 logo 和 CTA。請寫清時間軸、鏡頭描述、轉場方式、畫面文案和節奏感。",
  "preview.usePlugin": "使用外掛",
  "preview.usePluginOnly": "不帶提示詞使用",
  "preview.usePluginOnlyDesc": "使用外掛結構，但不載入範例提示詞",
  "preview.replicateContent": "使用",
  "preview.replicateContentDesc": "使用範例提示詞重現預覽",
  "preview.duplicateTemplate": "Remix",
  "preview.duplicateTemplateDesc": "將這個範例 Remix 成可編輯的新專案",
  "preview.shareMenu": "分享",
  "preview.exportMenu": "匯出",
  "preview.shareTemplateBadge": "範本",
  "preview.shareToX": "X / Twitter",
  "preview.shareToReddit": "Reddit",
  "preview.shareToFacebook": "Facebook",
  "preview.shareToLinkedIn": "LinkedIn",
  "preview.shareToInstagram": "Instagram",
  "preview.shareToXiaohongshu": "小红书",
  "preview.copyTemplateLink": "複製範本連結",
  "preview.copyShareText": "複製分享文案",
  "preview.shareSocialGroup": "分享到社群",
  "preview.shareCopyGroup": "複製",
  "preview.shareExportGroup": "匯出檔案",
  "preview.shareCopied": "已複製",
  "preview.shareCopyFailed": "複製失敗",
  "preview.shareTextDefault": "Open Design 模板：{title}",
  "preview.openInNewTab": "在新分頁中開啟",
  "preview.exit": "⤓ 離開",
  "preview.fullscreen": "⤢ 全螢幕",
  "preview.closeTitle": "關閉（Esc）",
  "preview.loading": "正在載入{label}…",
  "preview.errorTitle": "無法載入此範例。",
  "preview.errorBody":
    "範例 HTML 載入失敗。請確認 Open Design 正在執行後重試。",
  "preview.retry": "重試",
  "preview.unavailableTitle": "{noun}尚未附帶預覽範例。",
  "preview.unavailableBody": "請在對話中執行此 Prompt 來產生 {kind} 產物。",
  "preview.nounSkill": "此技能",
  "preview.nounPlugin": "此外掛",
  "preview.nounTemplate": "此範本",
  "preview.showSidebar": "展開{label}",
  "preview.hideSidebar": "收合{label}",
  "misc.savedTemplate": "已儲存的範本",
  "misc.primary": "主系統",
  "misc.designSystem": "設計系統",
  "workspace.designFiles": "設計檔案",
  "workspace.focusMode": "專注工作區",
  "workspace.showChat": "顯示聊天",
  "workspace.closeTab": "關閉分頁",
  "workspace.deleteFileConfirm": "從專案資料夾中刪除「{name}」？",
  "workspace.deleteSelectedFilesConfirm":
    "從專案資料夾中刪除選中的 {n} 個檔案？",
  "workspace.deleteSelectedFilesPartial": "有 {n} 個檔案刪除失敗。",
  "workspace.openFromDesignFiles": "請從",
  "previewRunStatus.analyzing": "正在梳理資訊架構",
  "previewRunStatus.generating": "正在建構設計方案",
  "previewRunStatus.verifying": "正在驗證交付結果",
  "previewRunStatus.succeeded": "設計已就緒",
  "previewRunStatus.failed": "交付需要處理 · 請在對話中重試",
  "previewRunStatus.elapsed": "已用時 {time}",
  "workspace.designFilesLink": "設計檔案",
  "workspace.loadingSketch": "正在載入草圖…",
  "workspace.newTab": "新增分頁",
  "workspace.searchFilesPlaceholder": "搜尋分頁或檔案…",
  "workspace.openTabs": "開啟分頁",
  "workspace.openFile": "開啟檔案",
  "workspace.noFilesMatch": "沒有符合的檔案",
  "workspace.allFiles": "全部",
  "workspace.createNew": "新增",
  "workspace.tabOpen": "已開啟",
  "workspace.sideChatContextBanner": "已整合目前對話的上下文",
  "workspace.sideChatDefaultTitle": "側邊對話",
  "workspace.newTerminal": "新增終端機",
  "workspace.newTerminalDescription": "在新分頁中開啟專案目錄的終端機",
  "workspace.newBrowser": "新增瀏覽器",
  "workspace.newBrowserDescription":
    "在新分頁中開啟內建瀏覽器，用於參考網站與設計研究",
  "workspace.newSketchDescription": "繪製粗略版面與標註，作為 agent 的設計脈絡",
  "workspace.terminalStarting": "正在啟動專案終端機…",
  "workspace.terminalStartingDescription": "正在連接專案目錄，通常只需幾秒。",
  "workspace.terminalSessionEnded": "工作階段已結束",
  "workspace.terminalReconnecting": "正在重新連線…",
  "workspace.terminalStartFailed": "無法啟動終端機工作階段",
  "workspace.terminalRestart": "重新啟動",
  "designFiles.title": "設計檔案",
  "designFiles.upload": "上傳圖片",
  "designFiles.pasteText": "貼上為文字檔案",
  "designFiles.newSketch": "新建草圖",
  "designFiles.empty": "生成的設計會出現在這裡",
  "designFiles.refresh": "重新整理",
  "designFiles.delete": "刪除",
  "designFiles.searchPlaceholder": "搜尋檔案…",
  "designFiles.up": "上一層",
  "designFiles.back": "返回",
  "designFiles.crumbs": "專案",
  "designFiles.rowMenu": "列選單",
  "designFiles.openInTab": "在分頁中開啟",
  "designFiles.download": "下載",
  "designFiles.downloadSelected": "下載選中的 {n} 個檔案為 ZIP",
  "designFiles.deleteSelected": "刪除 {n} 個",
  "designFiles.clearSelection": "取消選擇",
  "designFiles.selectPage": "全選此頁",
  "designFiles.selectAll": "全選",
  "designFiles.dropTitle": "⤓ 把檔案拖到這裡",
  "designFiles.dropDesc":
    "圖片、文件、參考資料或資料夾 — 智慧體都會用作上下文。",
  "designFiles.dropLabel": "拖曳檔案到這裡",
  "designFiles.upload.title": "上傳一張圖片",
  "designFiles.paste.title": "建立文件",
  "designFiles.upload.label": "上傳",
  "designFiles.paste.label": "建立文件",
  "designFiles.documentTemplate.titleFallback": "文件",
  "designFiles.documentTemplate.goalHeading": "目標",
  "designFiles.documentTemplate.goalBody":
    "說明希望 Open Design 基於這份文件生成、修改或判斷什麼。",
  "designFiles.documentTemplate.capabilitiesHeading": "如何使用這份文件",
  "designFiles.documentTemplate.capabilityMarkdown":
    "可以自由使用 Markdown：標題、表格、清單、連結、引用、程式碼區塊和圖片。",
  "designFiles.documentTemplate.capabilityAgent":
    "Open Design agent 可以讀取、編輯這份檔案，並把它作為專案上下文。",
  "designFiles.documentTemplate.capabilityImages":
    "可以貼上圖片，或把圖片拖到編輯器裡；上傳後的圖片會插入到目前游標位置。",
  "designFiles.documentTemplate.scenarioHeading": "場景說明",
  "designFiles.documentTemplate.scenario.prototype":
    "做原型時，寫清楚產品目標、目標使用者、流程、頁面、模組、互動狀態、響應式斷點，以及顏色、字體、間距、圓角、動效等 design tokens。",
  "designFiles.documentTemplate.scenario.wireframe":
    "做線框圖時，描述使用者流程、頁面清單、版面層級、內容區塊、低保真約束，以及視覺設計前需要驗證的問題。",
  "designFiles.documentTemplate.scenario.mobile":
    "做行動應用時，列出目標平台、頁面、導覽模型、手勢、原生模式、裝置尺寸、狀態和行動端 design tokens。",
  "designFiles.documentTemplate.scenario.slideDeck":
    "做簡報時，寫成分頁 PPT 大綱：每頁包含標題、目的、核心訊息、證據、視覺方向、講稿備註和匯出要求。",
  "designFiles.documentTemplate.scenario.document":
    "做文件時，定義受眾、語氣、章節結構、資料來源、引用或數據、版式預期和 PDF/匯出要求。",
  "designFiles.documentTemplate.scenario.image":
    "做圖片時，說明主體、比例、構圖、視覺風格、品牌 tokens、參考檔案和負向約束。",
  "designFiles.documentTemplate.scenario.video":
    "做影片時，寫出分鏡：場景、時長、字幕、動效、素材、音訊備註和輸出格式。",
  "designFiles.documentTemplate.scenario.hyperframes":
    "做 HyperFrames 時，描述 HTML 動態內容：場景、時間軸、字幕、音訊響應點、轉場和錄製/匯出要求。",
  "designFiles.documentTemplate.scenario.audio":
    "做音訊時，定義人聲或音樂方向、時長、情緒、腳本或文案、節奏、發音備註和最終用途。",
  "designFiles.documentTemplate.scenario.liveArtifact":
    "做即時看板時，說明資料來源、刷新頻率、元件、篩選、互動、空/載入/錯誤狀態，以及提醒或自動化要求。",
  "designFiles.documentTemplate.scenario.designSystem":
    "做設計系統時，列出品牌目標、tokens、字體、顏色、間距、元件、素材、參考和需要遵守/避免的規則。",
  "designFiles.documentTemplate.scenario.default":
    "描述受眾、交付物、必要內容、參考、約束，以及什麼狀態算完成。",
  "designFiles.documentTemplate.nextHeading": "下一步",
  "designFiles.documentTemplate.nextBody":
    "檢查並編輯這份文件，然後讓 Open Design 基於它生成、修改或執行操作。",
  "designFiles.previewOpen": "開啟",
  "designFiles.previewClose": "關閉預覽",
  "designFiles.modified": "修改於 {time} · {size}",
  "designFiles.weeksAgo": "{n} 週前",
  "designFiles.groupBy": "分組方式",
  "designFiles.groupByKind": "類型",
  "designFiles.groupByModified": "修改時間",
  "designFiles.filterBy": "依類型篩選",
  "designFiles.filterClear": "清除",
  "designFiles.filterCount": "{n} 種類型",
  "designFiles.expandGroup": "展開",
  "designFiles.collapseGroup": "折疊",
  "designFiles.sectionPages": "頁面",
  "designFiles.sectionScripts": "腳本",
  "designFiles.sectionImages": "圖片",
  "designFiles.sectionSketches": "草圖",
  "designFiles.sectionLiveArtifacts": "即時看板",
  "designFiles.sectionOther": "其它",
  "designFiles.modifiedToday": "今天",
  "designFiles.modifiedYesterday": "昨天",
  "designFiles.modifiedPrevious7Days": "最近 7 天",
  "designFiles.modifiedPrevious30Days": "最近 30 天",
  "designFiles.modifiedOlder": "更早",
  "designFiles.showMore": "再顯示 {n} 個",
  "designFiles.kindHtml": "HTML 頁面",
  "designFiles.kindImage": "圖片",
  "designFiles.kindSketch": "草圖",
  "designFiles.kindText": "文字",
  "designFiles.kindCode": "腳本",
  "designFiles.kindPdf": "PDF",
  "designFiles.kindDocument": "文件",
  "designFiles.kindPresentation": "簡報",
  "designFiles.kindSpreadsheet": "試算表",
  "designFiles.kindLiveArtifact": "即時看板",
  "designFiles.kindBinary": "二進位",
  "designFiles.kindFolder": "資料夾",
  "designFiles.folderCount": "{n} 個檔案",
  "designFiles.newFolderTitle": "新增資料夾",
  "designFiles.newFolderLabel": "資料夾名稱",
  "designFiles.moveTitle": "移動到資料夾",
  "designFiles.moveLabel": "目標資料夾",
  "designFiles.moveRoot": "專案根目錄",
  "designFiles.moveNewFolder": "新增資料夾…",
  "designFiles.move": "移動",
  "designFiles.copyPath": "複製檔案路徑",
  "designFiles.copiedPath": "已複製路徑",
  "designFiles.copyLocalPath": "複製本機檔案路徑",
  "designFiles.copiedLocalPath": "已複製本機檔案路徑",
  "designFiles.deleteFolderConfirm": "刪除資料夾「{name}」及其全部內容?",
  "designFiles.folderCreated": "已建立資料夾「{name}」",
  "designFiles.folderDeleted": "已刪除資料夾「{name}」",
  "designFiles.filesMoved": "已移動 {n} 項到 {dest}",
  "designFiles.colName": "名稱",
  "designFiles.colKind": "類型",
  "designFiles.colModified": "修改時間",
  "designFiles.perPage": "顯示",
  "designFiles.all": "全部",
  "designFiles.prev": "上一頁",
  "designFiles.next": "下一頁",
  "designFiles.jumpToPage": "跳轉到頁面",
  "designFiles.pageInfo": "{start}–{end} / {total}",
  "designFiles.sectionFolders": "資料夾",
  "designFiles.sectionStylesheets": "樣式表",
  "designFiles.sectionDocuments": "文件",
  "designFiles.kindStylesheet": "樣式表",
  "designFiles.modifiedExt": "修改於 {time} · {size} · {ext}",
  "designFiles.usefulInfoLabel": "使用提示",
  "designFiles.usefulInfoTip": "雙擊任意檔案即可在獨立分頁中開啟。",
  "designFiles.usefulInfoTip2": "在聊天中輸入 @ 即可把檔案引用為上下文。",
  "designFiles.usefulInfoTip4":
    "選好設計系統再生成，結果會與品牌風格保持一致。",
  "designFiles.usefulInfoTip5":
    "沒有想法？試試首頁「社群」的外掛模板，一鍵生成同款。",
  "designFiles.usefulInfoTip6": "遇到問題或有建議？加入 Discord 和我們聊聊。",
  "designFiles.usefulInfoTip7": "覺得好用？在 GitHub 給我們點個 Star。",
  "designFiles.usefulInfoTip8":
    "在 X 上關注 @OpenDesignHQ，第一時間了解新功能。",
  "designFiles.usefulInfoTip9":
    "把圖片、文件甚至整個資料夾拖到目前面板，智慧體都會用作上下文。",
  "designFiles.usefulInfoTip10":
    "點「新建草圖」手繪一個版面，讓智慧體照著生成。",
  "designFiles.usefulInfoTip11":
    "在預覽中圈選任意元素發表評論，智慧體會針對性修改。",
  "designFiles.usefulInfoTip12": "生成結果不滿意？直接圈選標註比重新描述更快。",
  "designFiles.usefulInfoTip13": "設計可以一鍵匯出為 PDF、圖片或獨立 HTML。",
  "designFiles.usefulInfoTip14":
    "滿意的專案可透過「分享」選單儲存為範本，下次直接複用。",
  "designFiles.usefulInfoTip15": "部署後可以直接生成社群分享卡片。",
  "designFiles.usefulInfoTip16":
    "在 Threads 上追蹤 @opendesign.ai，看團隊幕後動態。",
  "designFiles.usefulInfoTip17":
    "在 Instagram 上追蹤 @opendesign.ai，獲取設計靈感。",
  "designFiles.usefulInfoTip18":
    "在 YouTube 上訂閱 Open Design，觀看教學和示範。",
  "designFiles.usefulInfoTip19":
    "在 LinkedIn 上追蹤 Open Design，了解產品動態。",
  "designFiles.usefulInfoTip20":
    "在小紅書上追蹤 Open Design，獲取技巧和靈感。",
  "quickSwitcher.placeholder": "開啟分頁或檔案…",
  "quickSwitcher.empty": "此專案中沒有檔案",
  "quickSwitcher.noMatches": "無符合項目",
  "quickSwitcher.navigate": "導覽",
  "quickSwitcher.open": "開啟",
  "quickSwitcher.close": "關閉",
  "pasteDialog.title": "貼上文字",
  "pasteDialog.hint": "將儲存到專案資料夾中，名稱隨你定。",
  "pasteDialog.fileNameLabel": "檔案名稱",
  "pasteDialog.namePlaceholder": "notes.txt",
  "pasteDialog.contentLabel": "內容",
  "pasteDialog.contentPlaceholder": "在此貼上任何內容…",
  "pasteDialog.save": "儲存",
  "pasteDialog.cancel": "取消",
  "sketch.save": "儲存草圖",
  "sketch.cancel": "取消",
  "sketch.saving": "儲存中…",
  "sketch.saved": "已儲存",
  "sketch.tooltipMainMenu": "主選單：儲存、匯出、說明與畫布設定",
  "sketch.tooltipLock": "鎖定目前工具，連續繪製同一種元素",
  "sketch.tooltipHand": "抓手工具：拖動畫布視圖，不選取元素",
  "sketch.tooltipSelection": "選取工具：選取、移動、縮放或編輯畫布元素",
  "sketch.tooltipRectangle": "矩形工具：繪製矩形或卡片區域",
  "sketch.tooltipDiamond": "菱形工具：繪製判斷節點或分支結構",
  "sketch.tooltipEllipse": "橢圓工具：繪製圓形或橢圓",
  "sketch.tooltipArrow": "箭頭工具：繪製方向關係或流程連線",
  "sketch.tooltipLine": "直線工具：繪製分隔線或簡單連線",
  "sketch.tooltipFreedraw": "手繪工具：自由繪製線條",
  "sketch.tooltipText": "文字工具：在畫布上新增可編輯文字",
  "sketch.tooltipImage": "圖片工具：插入圖片素材",
  "sketch.tooltipEraser": "橡皮擦：刪除畫布上的元素",
  "sketch.tooltipFrame": "框架工具：把一塊畫布區域整理成框架",
  "sketch.tooltipEmbeddable": "Web 嵌入僅支援有效的 https:// 或 http:// 連結",
  "sketch.tooltipLaser": "雷射筆：暫時指示畫布內容，不修改元素",
  "sketch.tooltipMoreTools": "更多工具：開啟框架、Web 嵌入、雷射筆等工具",
  "sketch.tooltipDirty": "尚未儲存",
  "sketch.tooltipClean": "已儲存",
  "fileViewer.empty": "請選擇一個檔案檢視。",
  "fileViewer.loading": "載入中…",
  "fileViewer.exportPptx": "匯出為 PPTX",
  "fileViewer.openInNewTab": "在新分頁中開啟",
  "fileViewer.copyPath": "複製路徑",
  "fileViewer.copied": "已複製！",
  "fileViewer.share": "分享",
  "fileViewer.binaryMeta": "二進位 · {size}",
  "fileViewer.binaryNote":
    "二進位檔案（{size} 位元組）。請下載或在本機開啟檢視。",
  "fileViewer.pdfMeta": "PDF · {size}",
  "fileViewer.documentMeta": "文件",
  "fileViewer.presentationMeta": "簡報",
  "fileViewer.spreadsheetMeta": "試算表",
  "fileViewer.previewUnavailable": "無法產生預覽，請下載或開啟檔案檢視。",
  "fileViewer.download": "下載",
  "fileViewer.open": "開啟",
  "fileViewer.imageMeta": "圖片 · {size}",
  "fileViewer.reactMeta": "React 元件 · {size}",
  "fileViewer.sketchMeta": "草圖 · {size}",
  "fileViewer.markdownStreamingMeta": "正在串流預覽…",
  "fileViewer.markdownErrorMeta": "預覽可能不完整（產生錯誤）。",
  "fileViewer.markdownStreamingStatus": "正在串流產生…顯示部分 Markdown。",
  "fileViewer.markdownErrorStatus": "產生錯誤。正在顯示最後可用內容。",
  "fileViewer.markdownSaving": "儲存中...",
  "fileViewer.markdownSaveFailed": "儲存失敗",
  "fileViewer.markdownSaved": "已儲存",
  "fileViewer.markdownAutoSaved": "已自動儲存 · {time}",
  "fileViewer.markdownAutoSaveHint": "已開啟自動儲存",
  "fileViewer.markdownViewMode": "Markdown 视图模式",
  "fileViewer.split": "分栏",
  "fileViewer.markdownEditor": "Markdown 编辑器",
  "fileViewer.markdownEditorPlaceholder": "輸入這份文件的備註、需求或說明...",
  "fileViewer.markdownPreview": "Markdown 预览",
  "fileViewer.videoMeta": "影片 · {size}",
  "fileViewer.audioMeta": "音訊 · {size}",
  "fileViewer.reload": "重新載入",
  "fileViewer.reloadDisk": "從磁碟重新載入",
  "fileViewer.copy": "複製",
  "fileViewer.copyTitle": "複製檔案內容",
  "fileViewer.saveDisabled": "儲存（唯讀預覽）",
  "fileViewer.save": "儲存",
  "fileViewer.preview": "預覽",
  "fileViewer.source": "程式碼",
  "fileViewer.tweaks": "調整",
  "fileViewer.tweaksUnavailable": "此作品中沒有調整面板",
  "fileViewer.jsxModuleTitle": "無獨立預覽",
  "fileViewer.jsxModuleBody": "此檔案是由其他頁面載入的元件模組。",
  "fileViewer.jsxModuleCta": "請開啟轉譯它的頁面：",
  "fileViewer.comment": "註釋",
  "fileViewer.edit": "編輯",
  "fileViewer.draw": "繪製",
  "fileViewer.mark": "標記",
  "fileViewer.markTool": "標記工具",
  "fileViewer.boxSelect": "框選",
  "fileViewer.textTool": "文字",
  "fileViewer.textAnnotationRemove": "移除文字",
  "fileViewer.screenshot": "截圖",
  "manualEdit.layers": "圖層",
  "manualEdit.editableCount": "{count} 個可編輯",
  "manualEdit.hiddenBadge": "隱藏",
  "manualEdit.title": "手動編輯器",
  "manualEdit.fallbackTitle": "編輯",
  "manualEdit.movePanel": "移動編輯面板",
  "manualEdit.editParams": "編輯參數",
  "manualEdit.closePanel": "關閉編輯面板",
  "manualEdit.selectLayer": "選取圖層",
  "manualEdit.empty": "在預覽中點選元素，或選擇一個圖層。",
  "manualEdit.noEditableLayers": "未找到可編輯圖層。",
  "manualEdit.noClass": "無類別",
  "manualEdit.tabsAria": "手動編輯分頁",
  "manualEdit.tabContent": "內容",
  "manualEdit.tabStyle": "樣式",
  "manualEdit.tabAttributes": "屬性",
  "manualEdit.tabHtml": "Html",
  "manualEdit.tabSource": "原始碼",
  "manualEdit.attributesJson": "屬性 JSON",
  "manualEdit.selectedHtml": "所選元素的 HTML",
  "manualEdit.fullSource": "完整成品原始碼",
  "manualEdit.applyContent": "套用內容",
  "manualEdit.applyStyle": "套用樣式",
  "manualEdit.applyAttributes": "套用屬性",
  "manualEdit.applyHtml": "套用 HTML",
  "manualEdit.applySource": "套用原始碼",
  "manualEdit.invalidAttributes": "屬性 JSON 無效。",
  "manualEdit.changes": "變更",
  "manualEdit.undo": "復原",
  "manualEdit.redo": "重做",
  "manualEdit.noChanges": "尚無手動編輯。",
  "manualEdit.imageUrl": "圖片 URL",
  "manualEdit.altText": "替代文字",
  "manualEdit.label": "標籤",
  "manualEdit.text": "文字",
  "manualEdit.href": "Href",
  "manualEdit.textColor": "文字顏色",
  "manualEdit.background": "背景",
  "manualEdit.fontSize": "字型大小",
  "manualEdit.weight": "字重",
  "manualEdit.align": "對齊",
  "manualEdit.padding": "內距",
  "manualEdit.margin": "外距",
  "manualEdit.radius": "圓角",
  "manualEdit.border": "邊框",
  "manualEdit.width": "寬度",
  "manualEdit.minHeight": "最小高度",
  "manualEdit.deleteElement": "刪除元素",
  "manualEdit.deleteElementConfirm":
    "要刪除選取的元素嗎？此操作可使用「復原」還原。",
  "manualEdit.uploadImage": "上傳圖片",
  "manualEdit.uploadingImage": "上傳圖片中…",
  "manualEdit.uploadImageFailed": "無法上傳圖片。",
  "manualEdit.focusSlides": "聚焦投影片",
  "manualEdit.showPanels": "顯示面板",
  "fileViewer.zoomOut": "縮小",
  "fileViewer.zoomIn": "放大",
  "fileViewer.resetZoom": "重設縮放",
  "fileViewer.viewportAria": "預覽視區",
  "fileViewer.viewportDesktop": "桌面",
  "fileViewer.viewportDesktopTitle": "全寬桌面預覽",
  "fileViewer.viewportTablet": "平板",
  "fileViewer.viewportTabletTitle": "平板預覽 820 × 1180（現代直向基準）",
  "fileViewer.viewportMobile": "行動裝置",
  "fileViewer.viewportMobileTitle": "行動裝置預覽 390 × 844",
  "fileViewer.reloadAria": "重新載入",
  "fileViewer.previousSlide": "上一張",
  "fileViewer.nextSlide": "下一張",
  "fileViewer.slideNavAria": "投影片導覽",
  "fileViewer.speakerNotes": "演講者備註",
  "fileViewer.speakerNotesSlide": "第 {current} / {total} 頁",
  "fileViewer.speakerNotesEmpty": "這一頁還沒有演講者備註。",
  "fileViewer.speakerNotesEdit": "編輯",
  "fileViewer.speakerNotesSave": "儲存備註",
  "fileViewer.speakerNotesSaving": "儲存中...",
  "fileViewer.speakerNotesSaved": "已儲存",
  "fileViewer.speakerNotesSaveFailed": "無法儲存演講者備註。",
  "fileViewer.speakerNotesPlaceholder": "為這一頁新增演講者備註...",
  "fileViewer.previewAssetBlockedTitle": "預覽資源已被阻止",
  "fileViewer.previewAssetBlockedDetail": "無法載入 {filePath}。請將外部符號連結替換為此專案內的檔案。",
  "fileViewer.presenterReset": "重設",
  "fileViewer.present": "簡報",
  "fileViewer.presentInTab": "在當前分頁",
  "fileViewer.presentFullscreen": "全螢幕",
  "fileViewer.presentNewTab": "新分頁",
  "fileViewer.exitPresentation": "離開簡報",
  "fileViewer.shareLabel": "分享",
  "fileViewer.shareMenuShareLink": "分享",
  "fileViewer.shareMenuPublishOnline": "發布到線上",
  "fileViewer.shareMenuDownload": "下載",
  "fileViewer.shareMenuPresentation": "簡報",
  "fileViewer.shareMenuSourceFiles": "原始檔案",
  "fileViewer.shareMenuSave": "儲存",
  "fileViewer.copyShareLink": "複製分享連結",
  "fileViewer.openSharePage": "開啟分享頁面",
  "fileViewer.shareLinkRequiresDeploy": "先發布到線上以取得連結",
  "fileViewer.shareLinkPublishGuide": "先發布線上，即可分享 ↑",
  "fileViewer.shareAfterGenerationComplete": "生成完成後可分享",
  "fileViewer.copyProviderLink": "複製 {provider} 連結",
  "fileViewer.copyCloudflareLink": "複製 Cloudflare 連結",
  "fileViewer.screenshotCopying": "正在複製截圖…",
  "fileViewer.screenshotCopied": "截圖已儲存到剪貼簿",
  "fileViewer.screenshotClipboardDenied": "瀏覽器拒絕寫入剪貼簿",
  "fileViewer.screenshotPreviewLoading": "預覽仍在載入，請稍後再試",
  "fileViewer.screenshotCaptureFailed": "無法截取預覽，請重試",
  "fileViewer.exportPdf": "匯出為 PDF",
  "fileViewer.exportPdfAllSlides": "匯出為 PDF（全部投影片）",
  "fileViewer.exportPptxBusy": "請等待當前任務完成。",
  "fileViewer.exportPptxHint": "請求代理將此設計轉換為 PPTX。",
  "fileViewer.exportPptxNa": "此處暫不支援匯出 PPTX。",
  "fileViewer.exportZip": "下載為 .zip",
  "fileViewer.exportHtml": "匯出為獨立 HTML",
  "fileViewer.exportMd": "匯出為 Markdown",
  "fileViewer.exportImage": "匯出為圖片",
  "fileViewer.exportPptxImages": "匯出為 PPTX（圖片）",
  "fileViewer.exportPptxEditable": "匯出為 PPTX（可編輯）",
  "fileViewer.exportPptxEditableHint": "原生可編輯形狀與文字(非像素級還原)",
  "fileViewer.exportPptxModalSubtitle": "選擇匯出方式後點擊匯出。",
  "fileViewer.exportPptxScreenshot": "截圖 PPTX",
  "fileViewer.exportPptxScreenshotHint":
    "每頁一張圖,像素級 100% 還原,但不可編輯。",
  "fileViewer.exportPptxConfirm": "匯出",
  "fileViewer.exportPptxRecommended": "推薦",
  "fileViewer.exportingProgress": "正在匯出…",
  "fileViewer.exportSlideProgress": "正在匯出第 {current}/{total} 張…",
  "fileViewer.exportingElapsed": "正在匯出… {seconds} 秒",
  "fileViewer.exportSlideEta":
    "正在匯出第 {current}/{total} 張 · 約剩 {seconds} 秒",
  "fileViewer.exportFailed": "匯出失敗，請重試。",
  "fileViewer.exportDone": "匯出完成",
  "fileViewer.exportImageFailed":
    "圖片擷取失敗，請重試或使用瀏覽器的截圖工具。",
  "fileViewer.exportImageModalSubtitle":
    "選擇圖片格式後，將目前預覽下載為圖片。",
  "fileViewer.exportImageFormatLabel": "格式",
  "fileViewer.exportImageSaving": "正在儲存圖片…",
  "fileViewer.exportImageSaved": "圖片已儲存",
  "fileViewer.exportImageDownloadStarted": "已開始下載",
  "fileViewer.exportImageDownloadDetails":
    "如果沒有跳出儲存視窗，請在瀏覽器下載資料夾中查看 {filename}。",
  "fileViewer.exportJsx": "匯出為 JSX",
  "fileViewer.exportReactHtml": "匯出預覽 HTML",
  "fileViewer.exportStarted": "已開始匯出",
  "fileViewer.saveAsTemplate": "儲存為範本…",
  "fileViewer.savingTemplate": "正在儲存範本…",
  "fileViewer.savedTemplate": "已儲存為「{name}」",
  "fileViewer.savedTemplateFail": "儲存範本失敗，請重試。",
  "fileViewer.templateNamePrompt": "範本名稱",
  "fileViewer.templateNameDefault": "未命名範本",
  "fileViewer.templateDescPrompt": "簡短描述（可選 — 這個範本用於什麼情境？）",
  "liveArtifact.refresh.button": "重新整理",
  "liveArtifact.refresh.buttonTitle": "刷新此即時看板",
  "liveArtifact.refresh.loadingTitle": "正在載入即時看板…",
  "liveArtifact.refresh.noSourceTitle": "尚無已核准的唯讀重新整理來源。",
  "liveArtifact.refresh.running": "重新整理中…",
  "liveArtifact.refresh.runningMessage":
    "正在重新整理資料和預覽，可能需要一點時間。",
  "liveArtifact.refresh.runningAction": "重新整理成功前會繼續顯示上一次預覽。",
  "liveArtifact.refresh.successOne": "重新整理完成，資料已更新。",
  "liveArtifact.refresh.successMany": "重新整理完成，資料已更新。",
  "liveArtifact.refresh.successAction": "預覽已使用最新提交的資料重新載入。",
  "liveArtifact.refresh.previousFailure": "上次重新整理失敗：{message}",
  "liveArtifact.refresh.failureAction":
    "請檢查「重新整理紀錄」，修復來源或權限問題後重試。",
  "liveArtifact.refresh.networkFailure":
    "重新整理請求失敗。請檢查網路連線後重試。",
  "liveArtifact.refresh.genericFailure": "重新整理失敗。",
  "liveArtifact.refresh.statusNever": "不可重新整理",
  "liveArtifact.refresh.statusReady": "可重新整理",
  "liveArtifact.refresh.statusSucceeded": "已是最新",
  "liveArtifact.refresh.statusFailed": "重新整理失敗",
  "liveArtifact.refresh.statusRunning": "重新整理中",
  "liveArtifact.refresh.statusRunningDescription": "目前正在執行重新整理。",
  "liveArtifact.refresh.statusSucceededDescription": "上次重新整理已成功完成。",
  "liveArtifact.refresh.statusFailedDescription":
    "上次重新整理嘗試並未成功完成。",
  "liveArtifact.refresh.statusReadyDescription":
    "已設定可重新整理的來源，但目前沒有執行中的作業。",
  "liveArtifact.refresh.statusNeverDescription":
    "此即時產出物尚未設定重新整理來源。",
  "liveArtifact.refresh.eventStarted": "已開始",
  "liveArtifact.refresh.eventSucceeded": "成功",
  "liveArtifact.refresh.eventFailed": "失敗",
  "liveArtifact.refresh.eventStartedDetail": "已開始重新整理…",
  "liveArtifact.refresh.sourcesUpdatedOne": "已更新 {n} 個來源",
  "liveArtifact.refresh.sourcesUpdatedMany": "已更新 {n} 個來源",
  "liveArtifact.refresh.timelineEmpty":
    "此工作階段尚無重新整理活動。觸發「重新整理」以記錄時間軸，或等待自動執行。",
  "liveArtifact.refresh.heroLastRefreshedLabel": "上次重新整理",
  "liveArtifact.refresh.heroLastRefreshedNever": "從未",
  "liveArtifact.refresh.justNow": "剛剛",
  "liveArtifact.refresh.factCreated": "已建立",
  "liveArtifact.refresh.factLastUpdated": "上次更新",
  "liveArtifact.refresh.factUnknown": "未知",
  "liveArtifact.refresh.persistedTitle": "已保存的重新整理紀錄",
  "liveArtifact.refresh.persistedHint": "從 refreshes.jsonl 載入的項目",
  "liveArtifact.refresh.persistedEmpty": "尚無已保存的重新整理紀錄。",
  "liveArtifact.refresh.persistedStatusSucceeded": "成功",
  "liveArtifact.refresh.persistedStatusRunning": "執行中",
  "liveArtifact.refresh.persistedStatusFailed": "失敗",
  "liveArtifact.refresh.persistedStatusCancelled": "已取消",
  "liveArtifact.refresh.persistedStatusSkipped": "已略過",
  "liveArtifact.refresh.sessionTitle": "工作階段活動",
  "liveArtifact.refresh.sessionHint": "此分頁開啟期間觀察到的事件",
  "liveArtifact.refresh.docSourceTitle": "文件來源",
  "liveArtifact.refresh.docSourceHint": "已設定來源",
  "liveArtifact.refresh.docSourceType": "類型",
  "liveArtifact.refresh.docSourceTool": "工具",
  "liveArtifact.refresh.docSourceConnector": "連接器",
  "liveArtifact.refresh.debugSummary": "進階除錯中繼資料",
  "liveArtifact.refresh.debugNote":
    "可能包含連接器 ID、檔案名稱、來源中繼資料及內部產出物路徑。",
  "liveArtifact.viewer.tabPreview": "預覽",
  "liveArtifact.viewer.tabCode": "程式碼",
  "liveArtifact.viewer.tabData": "資料",
  "liveArtifact.viewer.tabRefreshHistory": "重新整理歷史",
  "liveArtifact.viewer.dataEmpty": "沒有可用的 data.json 快取。",
  "liveArtifact.viewer.code.templateHeading": "範本 HTML",
  "liveArtifact.viewer.code.renderedHeading": "渲染後 HTML",
  "liveArtifact.viewer.code.templateHelp":
    "與 data.json 搭配產生預覽的可編輯範本。",
  "liveArtifact.viewer.code.renderedHelp":
    "Preview 目前載入的已產生 index.html。",
  "liveArtifact.viewer.code.variantAria": "程式碼版本",
  "liveArtifact.viewer.code.variantTemplate": "範本",
  "liveArtifact.viewer.code.variantRendered": "已渲染",
  "liveArtifact.viewer.code.loading": "正在載入程式碼…",
  "liveArtifact.viewer.code.unavailable": "程式碼尚不可用。",
  "liveArtifact.viewer.code.empty": "此程式碼檔案是空的。",
  "fileViewer.deployToVercel": "部署到 Vercel",
  "fileViewer.redeployToVercel": "重新部署",
  "fileViewer.deployingToVercel": "正在部署到 Vercel…",
  "fileViewer.deployProviderLabel": "部署平台",
  "fileViewer.vercelProvider": "Vercel",
  "fileViewer.cloudflarePagesProvider": "Cloudflare Pages",
  "fileViewer.deployTargetLabel": "目標",
  "fileViewer.deployTargetPreview": "預覽",
  "fileViewer.deployTargetProduction": "正式環境",
  "fileViewer.deployToProvider": "部署到 {provider}",
  "fileViewer.redeployToProvider": "重新部署到 {provider}",
  "fileViewer.deployingToProvider": "正在部署到 {provider}…",
  "fileViewer.preparingPublicLink": "正在準備公開連結…",
  "fileViewer.copyDeployLink": "複製連結",
  "fileViewer.deployModalTitle": "部署",
  "fileViewer.deployModalSubtitle": "使用所選平台帳號部署目前 HTML 預覽。",
  "fileViewer.vercelToken": "Vercel token",
  "fileViewer.vercelTokenGetLink": "取得 Vercel token",
  "fileViewer.vercelTokenPlaceholder": "貼上你的 Vercel token",
  "fileViewer.vercelTokenReuseHint": "將使用已儲存的代碼。輸入新代碼可替換。",
  "fileViewer.vercelTokenRequired": "請先輸入並儲存 Vercel 代碼。",
  "fileViewer.cloudflareApiToken": "Cloudflare API 代碼",
  "fileViewer.cloudflareApiTokenGetLink": "取得 API token",
  "fileViewer.cloudflareApiTokenPlaceholder": "貼上你的 Cloudflare API 代碼",
  "fileViewer.cloudflareApiTokenReuseHint":
    "將使用已儲存的 Cloudflare API 代碼。輸入新代碼可替換。",
  "fileViewer.cloudflareApiTokenRequired":
    "請先輸入並儲存 Cloudflare API 代碼。",
  "fileViewer.cloudflareApiTokenScopeHint":
    "建立 API token 時勾選 Pages Edit；自訂網域需 Zone Read / DNS Edit。",
  "fileViewer.vercelTeamId": "團隊 ID",
  "fileViewer.vercelTeamSlug": "團隊標記",
  "fileViewer.cloudflareAccountId": "帳戶 ID",
  "fileViewer.cloudflareAccountIdHint": "可在 Cloudflare 控制台中找到帳戶 ID。",
  "fileViewer.cloudflareAccountIdRequired":
    "請先輸入並儲存 Cloudflare 帳戶 ID。",
  "fileViewer.cloudflareZoneLabel": "網域",
  "fileViewer.cloudflareZonePlaceholder": "儲存 Cloudflare 設定以載入網域",
  "fileViewer.cloudflareZoneRequired": "請先選取一個 Cloudflare 網域。",
  "fileViewer.cloudflareZonesLoading": "正在載入 Cloudflare 網域…",
  "fileViewer.cloudflareZonesRefresh": "重新整理網域",
  "fileViewer.cloudflareZonesLoadFailed": "無法載入 Cloudflare 網域。",
  "fileViewer.cloudflareZonesEmpty": "找不到此帳戶可用的完整 Cloudflare 網域。",
  "fileViewer.cloudflareDomainPrefixLabel": "子網域前綴",
  "fileViewer.cloudflareDomainPrefixPlaceholder": "demo",
  "fileViewer.cloudflareDomainPrefixInvalid":
    "僅使用一個 DNS 標籤：小寫字母、數字與連字號。",
  "fileViewer.cloudflareHostnamePreview": "自訂網域預覽：{hostname}",
  "fileViewer.cloudflareCustomDomainHint":
    "可選：綁定自訂網域。不填也會產生 pages.dev 連結。",
  "fileViewer.cloudflarePagesDevLinkLabel": "pages.dev URL",
  "fileViewer.cloudflareCustomDomainLinkLabel": "自訂網域",
  "fileViewer.optional": "可選",
  "fileViewer.vercelPreviewOnly": "目前僅部署 Preview。",
  "fileViewer.cloudflarePagesPreviewHint":
    "Cloudflare Pages 使用 Direct Upload。",
  "fileViewer.savingConfig": "儲存中…",
  "fileViewer.deployConfigSaveFailed": "儲存 Vercel 設定失敗。",
  "fileViewer.deployFailed": "部署失敗，請檢查 Vercel 設定後重試。",
  "fileViewer.deployProviderConfigSaveFailed": "無法儲存 {provider} 設定。",
  "fileViewer.deployProviderFailed": "{provider} 部署失敗。請檢查設定後重試。",
  "fileViewer.deployResultLabel": "部署連結",
  "fileViewer.deployLinkReady": "已就緒",
  "fileViewer.deploySuccessToast": "部署已成功上傳",
  "fileViewer.deploySuccessToastDetails": "{provider} · {url}",
  "fileViewer.deployLinkPreparingLabel": "公開連結準備中",
  "fileViewer.deployLinkDelayed": "站點已部署，平台仍在準備公開連結。",
  "fileViewer.deployLinkFailed": "自訂網域失敗",
  "fileViewer.deployLinkProtectedLabel": "部署存取保護已開啟",
  "fileViewer.deployLinkProtected":
    "站點已部署，但此預覽連結要求登入後才能存取。請關閉 Deployment Protection 或使用自訂網域。",
  "fileViewer.retryLink": "立即重試",
  "questionForm.submit": "提交",
  "questionForm.skip": "跳過",
  "questionForm.locked": "已回答",
  "conv.switch": "切換對話",
  "conv.label": "對話",
  "conv.heading": "對話紀錄",
  "conv.new": "+ 新建",
  "conv.empty": "還沒有對話。",
  "conv.untitled": "未命名對話",
  "conv.renameTooltip": "雙擊重新命名",
  "conv.delete": "刪除對話",
  "conv.deleteConfirm": "確定刪除「{title}」？該操作會刪除其訊息。",
  "agentPicker.label": "代理",
  "agentPicker.modeChoose": "選擇執行模式",
  "agentPicker.localCli": "本機 CLI",
  "agentPicker.daemonOff": "守護程序未執行",
  "agentPicker.byok": "API · BYOK",
  "agentPicker.selectAgent": "選擇已偵測到的程式碼代理 CLI",
  "agentPicker.noAgents": "PATH 中未發現代理",
  "agentPicker.notInstalled": "未安裝",
  "agentPicker.rescan": "重新掃描 PATH 中的代理",
  "tool.openInTab": "在分頁中開啟 {name}",
  "tool.open": "開啟",
  "tool.todos": "待辦",
  "tool.todosExpand": "展開任務",
  "tool.todosCollapse": "收起任務",
  "tool.todosDone": "完成",
  "tool.todosDismiss": "關閉任務清單",
  "tool.write": "寫入",
  "tool.edit": "編輯",
  "tool.read": "讀取",
  "tool.delete": "刪除",
  "tool.bash": "Bash",
  "tool.glob": "Glob",
  "tool.grep": "Grep",
  "tool.fetch": "擷取",
  "tool.search": "搜尋",
  "tool.lines": "{n} 行",
  "tool.changeSingular": "處變更",
  "tool.changePlural": "處變更",
  "tool.in": "於 {path}",
  "tool.hide": "隱藏",
  "tool.output": "輸出",
  "tool.running": "執行中…",
  "tool.error": "錯誤",
  "tool.done": "完成",
  "assistant.role": "助手",
  "assistant.workingLabel": "執行中",
  "assistant.doneLabel": "已完成",
  "assistant.copyMarkdown": "複製回覆 Markdown",
  "assistant.forkConversation": "從這裡分叉",
  "assistant.forkingConversation": "正在分叉…",
  "assistant.shareToOpenDesign": "分享到 Open Design",
  "assistant.shareToOpenDesignBusy": "正在準備投稿…",
  "assistant.feedbackPrompt": "意見回饋",
  "assistant.feedbackPositive": "有幫助",
  "assistant.feedbackNegative": "沒有幫助",
  "assistant.feedbackReasonTitle": "選擇原因",
  "assistant.feedbackReasonPositiveMatched": "理解了我的需求",
  "assistant.feedbackReasonPositiveVisual": "視覺效果滿意",
  "assistant.feedbackReasonPositiveUseful": "結構有幫助",
  "assistant.feedbackReasonPositiveEasy": "方便繼續修改",
  "assistant.feedbackReasonPositiveDesignSystem": "嚴格按照設計系統生成",
  "assistant.feedbackReasonNegativeMissed": "沒有理解需求",
  "assistant.feedbackReasonNegativeVisual": "視覺效果不理想",
  "assistant.feedbackReasonNegativeIncomplete": "產物不完整",
  "assistant.feedbackReasonNegativeHard": "不方便使用",
  "assistant.feedbackReasonNegativeDesignSystem": "沒有嚴格按照設計系統生成",
  "assistant.feedbackReasonOther": "其他",
  "assistant.feedbackReasonPlaceholder": "補充說明...",
  "assistant.feedbackReasonSubmit": "提交",
  "assistant.emptyResponseLabel": "無輸出",
  "assistant.emptyResponseMessage":
    "服務商結束了請求，但沒有返回文字或設計產物。請嘗試更換模型或服務商、檢查額度，或重試。",
  "assistant.unfinishedLabel": "已停止，仍有未完成任務",
  "assistant.unfinishedSummary": "剩餘 {n} 個任務",
  "assistant.unfinishedMore": "還有 {n} 個",
  "assistant.continueRemaining": "繼續剩餘任務",
  "chat.resumeRunCta": "繼續執行",
  "assistant.outTokens": "{n} 輸出",
  "assistant.producedFiles": "本輪產出的檔案",
  "assistant.openFile": "開啟",
  "assistant.downloadFile": "下載",
  "nextStep.title": "下一步",
  "nextStep.more": "更多",
  "nextStep.share": "分享",
  "nextStep.download": "下載",
  "nextStep.contribute": "貢獻社區",
  "nextStep.planGenerateTitle": "產生產物",
  "nextStep.planGenerateBody":
    "以已確認的 Markdown 規劃文件為依據產生下一版產物。",
  "nextStep.planImproveTitle": "繼續優化文件",
  "nextStep.planImproveBody": "先把目前規劃文件補完整，再進入最終生成。",
  "nextStep.planGeneratePrompt":
    "以 `{file}` 作為唯一事實來源。先讀取這份文件，保留其中已經確定的決策，然後產生與文件匹配的最終設計產物。如果它是逐頁大綱，就產生 PPT/Deck；如果它是 PRD 或原型規劃，就產生原型或線框圖；如果它是分鏡或創意 brief，就產生對應的視覺/媒體產物。產生前請指出你無法自行解決的阻塞 TODO 或矛盾點。",
  "nextStep.planImprovePrompt":
    "讀取 `{file}`，並直接在原文件中優化這份可編輯規劃文件。收緊範圍，補齊薄弱章節，增加驗收標準；仍需要使用者輸入的地方保留 TODO / open question。暫時不要產生最終設計產物。",
  "nextStep.planImproveArtifactTitle": "繼續優化產物",
  "nextStep.planImproveArtifactBody":
    "基於目前產物繼續打磨，而不是回到規劃階段。",
  "nextStep.planImproveArtifactPrompt":
    "直接優化 `{artifact}`。保留目前已經可用的產物和行為，優先改進產品結構、視覺層級、互動細節和內容表達。完成後總結改動檔案和仍需注意的風險。",
  "nextStep.planMergeTitle": "融合文件與產物",
  "nextStep.planMergeBody": "把規劃意圖和已生成產物對齊，讓兩者一起推進。",
  "nextStep.planMergePrompt":
    "同時讀取 `{document}` 和 `{artifact}`。把文件視為意圖來源，把產物視為目前實作，然後融合兩者：讓產物對齊已確認決策，只在文件過時時更新文件，仍未確定的內容保留 TODO / open question。保留目前已可用的行為，最後總結文件和產物分別改了什麼。",
  "nextStep.brandAiOptimizeTitle": "深化擷取設計系統",
  "nextStep.brandAiOptimizeBody":
    "啟動 agent 消耗模型 token，重新擷取來源內容，並就地更新這個設計系統。",
  "nextStep.brandCreateDesignTitle": "用此系統建立新設計",
  "nextStep.brandCreateDesignBody":
    "基於已擷取的顏色、字體、素材和設計規範建立一個新設計。",
  "nextStep.createDesignBusy": "正在建立設計...",
  "assistant.thinking": "思考中",
  "assistant.thought": "思考完畢",
  "assistant.thoughtFor": "已深度思考（用時 {s} 秒）",
  "assistant.systemReminder": "系統提示",
  "assistant.possiblePromptInjection": "可能的提示詞注入",
  "assistant.waitingFirstOutput": "等待首批輸出中",
  "assistant.statusBootingAgent": "正在啟動代理",
  "assistant.statusPreparing": "準備中...",
  "assistant.statusStarting": "啟動中",
  "assistant.statusRequesting": "正在傳送請求",
  "assistant.statusThinking": "思考中",
  "assistant.statusStreaming": "串流輸出中",
  "assistant.slowHint":
    "耗時比平時更久。一般 5–10 秒內會出現表單，可以「停止」後重新表達。",
  "assistant.verbEditing": "編輯",
  "assistant.verbWriting": "寫入",
  "assistant.verbReading": "讀取",
  "assistant.verbSearching": "搜尋",
  "assistant.verbRunning": "執行",
  "assistant.verbTodos": "待辦",
  "assistant.verbFetching": "擷取",
  "assistant.verbCalling": "呼叫",
  "qf.answered": "已回答",
  "qf.choose": "請選擇…",
  "qf.customLabel": "自定义填写",
  "qf.customPlaceholder": "输入你自己的答案…",
  "qf.otherOption": "其他",
  "qf.required": "必填",
  "qf.lockedSubmitted": "答案已傳送，代理將在本次工作階段後續使用。",
  "qf.lockedPrev": "該表單來自先前的對話。",
  "qf.hint": "挑選合適的選項；可選項可以跳過，代理會使用合理的預設值。",
  "qf.submitDefault": "傳送答案",
  "qf.submitDisabledTitle": "請先填寫必填項",
  "qf.submitTitle": "傳送答案",
  "qf.cardSelected": "已選",
  "qf.cardRefs": "參考：",
  "qf.cardSampleText": "飛燕環宇 · 0123",
  "questions.tabLabel": "問題",
  "questions.banner": "方便問你幾個簡短的問題嗎？",
  "questions.bannerAnswered": "已回答這些問題",
  "questions.continue": "繼續",
  "questions.generating": "正在產生問題…",
  "questions.skipAll": "全部略過",
  "questions.autoSkipHint": "計時器結束時自動繼續",
  "questions.submitting": "正在提交…",
  "sketch.toolSelect": "選擇（佔位）",
  "sketch.toolPen": "鋼筆",
  "sketch.toolText": "文字",
  "sketch.toolRect": "矩形",
  "sketch.toolArrow": "箭頭",
  "sketch.toolEraser": "橡皮擦",
  "sketch.color": "顏色",
  "sketch.strokeSize": "描邊粗細",
  "sketch.undo": "復原",
  "sketch.clear": "清除",
  "sketch.close": "關閉",
  "sketch.closeConfirm": "關閉草圖並放棄未儲存的變更嗎？",
  "sketch.textPrompt": "請輸入文字：",
  "sketch.textModalTitle": "新增文字",
  "critiqueTheater.userFacingName": "設計評審團",
  "critiqueTheater.roleDesigner": "設計師",
  "critiqueTheater.roleCritic": "評審",
  "critiqueTheater.roleBrand": "品牌",
  "critiqueTheater.roleA11y": "無障礙",
  "critiqueTheater.roleCopy": "文案",
  "critiqueTheater.roundLabel": "第 {n} 輪 / 共 {m} 輪",
  "critiqueTheater.mustFix": "{n} 項必改",
  "critiqueTheater.composite": "綜合分",
  "critiqueTheater.threshold": "門檻",
  "critiqueTheater.consensus": "共識",
  "critiqueTheater.interrupt": "中斷",
  "critiqueTheater.interrupting": "中斷中…",
  "critiqueTheater.interrupted": "已中斷",
  "critiqueTheater.degradedHeading": "本次評審不可用",
  "critiqueTheater.degradedReasonMalformed": "評審區塊格式錯誤，剖析器已拒絕。",
  "critiqueTheater.degradedReasonOversize": "評審輸出超出了安全位元組預算。",
  "critiqueTheater.degradedReasonAdapter": "介接器 {adapter} 不支援評審協定。",
  "critiqueTheater.degradedReasonProtocol":
    "介接器 {adapter} 使用了不支援的協定版本。",
  "critiqueTheater.degradedReasonMissingArtifact": "執行結束但未產出最終成果。",
  "critiqueTheater.replay": "回放",
  "critiqueTheater.replaySpeed": "回放速度",
  "critiqueTheater.readOnly": "唯讀",
  "critiqueTheater.shippedSummary":
    "已於第 {round} 輪發布 · 綜合分 {composite}",
  "critiqueTheater.interruptedSummary":
    "已於第 {round} 輪中斷 · 最佳綜合分 {composite}",
  "critiqueTheater.shippedBadge": "已發布",
  "critiqueTheater.belowThresholdBadge": "低於門檻",
  "critiqueTheater.timedOutBadge": "已逾時",
  "critiqueTheater.failedHeading": "執行失敗",
  "critiqueTheater.failedReasonCliExit": "智慧體 CLI 在評審完成前異常結束。",
  "critiqueTheater.failedReasonPerRoundTimeout": "某一輪超出了時間預算。",
  "critiqueTheater.failedReasonTotalTimeout": "整次執行超出了總時間預算。",
  "critiqueTheater.failedReasonOrchestrator": "編排器內部錯誤。",
  "critiqueTheater.transcriptEmpty": "尚無可回放的記錄。執行一次評審即可記錄。",
  "critiqueTheater.transcriptLoading": "正在載入會談記錄…",
  "critiqueTheater.transcriptError": "無法載入會談記錄：{error}",
  "critiqueTheater.replaySpeedPaused": "暫停",
  "critiqueTheater.replaySpeedInstant": "瞬時",
  "critiqueTheater.replaySpeedLive": "即時",
  "critiqueTheater.replaySpeedFast": "快進",
  "critiqueTheater.settingsNav": "設計評審團",
  "critiqueTheater.settingsNavHint": "為代理執行啟用五人設計評審",
  "critiqueTheater.settingsEnabledLabel": "在代理執行期間顯示設計評審團",
  "critiqueTheater.settingsEnabledDescription":
    "啟用後，五人評審面板會在代理產生時同步進行，並在交付前為結果評分。可隨時中斷。",
  "critiqueTheater.settingsEnabledProjectHint":
    "已為此專案儲存。此專案的新執行將在伺服器端經過設計評審團。",
  "critiqueTheater.settingsEnabledNoProjectHint":
    "請開啟專案以將設定持久化至伺服器端。目前僅修改瀏覽器內偏好。",
  "pet.title": "寵物",
  "pet.subtitle":
    "「顯示寵物」控制它是否出現在工作區；下方可以選擇內建、自訂或社群寵物。",
  "pet.navTitle": "寵物",
  "pet.navHint": "領養與自訂",
  "pet.tabBuiltIn": "內建",
  "pet.tabBuiltInHint": "Open Design 內建的精選寵物 — 一鍵領養。",
  "pet.builtInEmpty":
    "目前無法載入內建寵物。等本地服務恢復後,重新整理「社群」頁籤再試。",
  "pet.tabCustom": "自訂",
  "pet.tabCustomHint": "自己命名、選符號或上傳精靈圖。",
  "pet.tabCommunity": "社群",
  "pet.tabCommunityHint": "來自 Codex 的孵化寵物 — 領養或用 AI 生成新的。",
  "pet.tabsAria": "選擇寵物",
  "pet.adopt": "領養",
  "pet.adoptedBadge": "已領養",
  "pet.adoptCallout": "領養一隻寵物",
  "pet.changePet": "更換寵物",
  "pet.wake": "顯示寵物",
  "pet.tuck": "隱藏寵物",
  "pet.wakeTitle": "在工作區顯示寵物。尚未選擇時，會預設使用第一隻內建寵物。",
  "pet.tuckTitle": "從工作區隱藏寵物。",
  "pet.settingsTitle": "開啟寵物設定",
  "pet.useCustom": "使用我的寵物",
  "pet.customTitle": "自訂你的寵物",
  "pet.customHint": "挑一個名字、表情和主題色，浮窗會即時更新。",
  "pet.customGreetingPlaceholder": "來自寵物的問候…",
  "pet.fieldName": "名字",
  "pet.fieldGlyph": "表情",
  "pet.fieldGlyphHint": "建議使用單個 emoji（例如 🐝、🦄、🐢）。",
  "pet.fieldGreeting": "問候語",
  "pet.fieldAccent": "主題色",
  "pet.fieldAccentCustom": "自訂顏色",
  "pet.fieldAccentDefault": "預設主題色",
  "pet.overlayAria": "寵物夥伴",
  "pet.spriteAria": "{name} — 拖曳可移動，點擊與它互動",
  "pet.spriteTitle": "{name} 來打招呼啦！點擊聊天。",
  "pet.taskSummarySingle": "正在執行 {count} 個 Agent 任務。",
  "pet.taskSummaryMultiple":
    "正在執行 {count} 個 Agent 任務，分布在 {projects} 個專案。",
  "pet.taskSummaryRecentSingle": "最近完成 {count} 個 Agent 任務。",
  "pet.taskSummaryRecentMultiple": "最近完成 {count} 個 Agent 任務。",
  "pet.taskListAria": "執行中的 Agent 任務",
  "pet.taskOpenProject": "開啟 {project}",
  "pet.taskGroup.running": "正在執行",
  "pet.taskGroup.queued": "等待中",
  "pet.taskGroup.recent": "最近完成",
  "pet.idleQuote.leonardo.text": "學習從不會使心靈疲憊。",
  "pet.idleQuote.leonardo.author": "李奧納多·達文西",
  "pet.idleQuote.michelangelo.text":
    "我看見天使在大理石中，於是不斷雕刻，直到讓他自由。",
  "pet.idleQuote.michelangelo.author": "米開朗基羅",
  "pet.idleQuote.bernini.text": "有兩樣東西能幫助雕塑家：光與影。",
  "pet.idleQuote.bernini.author": "吉安·洛倫佐·貝尼尼",
  "pet.idleQuote.raphael.text": "作畫時，人並不思考。",
  "pet.idleQuote.raphael.author": "拉斐爾",
  "pet.idleQuote.caravaggio.text": "作品若不是從生活中來，終究只是細枝末節。",
  "pet.idleQuote.caravaggio.author": "卡拉瓦喬",
  "pet.idleQuote.rodin.text":
    "最重要的是被打動、去愛、去希望、去顫抖、去生活。",
  "pet.idleQuote.rodin.author": "奧古斯特·羅丹",
  "pet.composerTitle": "寵物 — 喚醒、收起或挑一隻",
  "pet.composerMenuTitle": "寵物",
  "pet.composerMenuHint": "小提示：輸入 /pet 即可切換",
  "pet.composerOpenSettings": "管理寵物",
  "pet.welcomeTeaserTitle": "領養一隻寵物",
  "pet.welcomeTeaserBody": "一隻小小的浮窗夥伴，會陪你工作。",
  "pet.welcomeTeaserCta": "挑一隻",
  "pet.imageUpload": "上傳形象",
  "pet.imageReplace": "替換形象",
  "pet.imageRemove": "改用 emoji",
  "pet.imageHintIdle":
    "支援 PNG / JPG / WebP / GIF / SVG。要做精靈動畫？傳一張橫向序列圖並設定影格數。",
  "pet.imageHintActive":
    "正在使用你上傳的形象。把影格數設為 > 1，橫向序列圖就會動起來。",
  "pet.fieldFrames": "影格數",
  "pet.fieldFramesHint": "1 = 靜態；> 1 = 橫向序列圖。",
  "pet.fieldFps": "速度 (fps)",
  "pet.fieldFpsHint": "控制序列圖播放速度。",
  "pet.atlasImport": "匯入 Codex 精靈圖",
  "pet.atlasImportTitle": "匯入 hatch-pet 8x9 / 192x208 精靈圖(PNG 或 WebP)。",
  "pet.atlasPickerTitle": "選擇動畫列",
  "pet.atlasPickerHint":
    "Codex 寵物自帶 9 個動畫狀態。預設會保留完整精靈圖,寵物會根據懸停、拖曳方向、長時間閒置自動切換動畫。也可以只保留一個迴圈。",
  "pet.atlasCancel": "捨棄精靈圖",
  "pet.atlasAdopt": "鎖定這一列",
  "pet.atlasAdoptFull": "使用完整精靈圖(動態)",
  "pet.atlasAdoptFullTitle":
    "保留所有動畫列,讓寵物對懸停、拖曳方向以及長時間閒置做出反應。",
  "pet.atlasAdoptRowTitle": "只把高亮的這一列切成單迴圈條帶。",
  "pet.atlasActiveHint":
    "動態精靈圖已啟用 — 寵物會依據你的互動(懸停、拖曳、閒置)自動切換動畫。",
  "pet.atlasRow.idle": "待機",
  "pet.atlasRow.running-right": "向右跑",
  "pet.atlasRow.running-left": "向左跑",
  "pet.atlasRow.waving": "揮手",
  "pet.atlasRow.jumping": "跳躍",
  "pet.atlasRow.failed": "失敗",
  "pet.atlasRow.waiting": "等待",
  "pet.atlasRow.running": "奔跑",
  "pet.atlasRow.review": "審視",
  "pet.hatchTitle": "用 AI 孵化新寵物",
  "pet.hatchHint":
    "透過聊天呼叫內建的 hatch-pet 技能產生 Codex 風格的精靈圖,完成後回到這裡匯入。",
  "pet.hatchConcept": "寵物概念(可選)",
  "pet.hatchConceptPlaceholder": "例如:一隻穿著毛衣的像素風柴犬",
  "pet.hatchCopy": "複製提示詞",
  "pet.hatchCopied": "已複製!",
  "pet.hatchFoot": "技能儲存好寵物後,回到這裡點擊「匯入 Codex 精靈圖」即可。",
  "pet.slashPopoverAria": "斜線命令",
  "pet.slashPopoverTitle": "命令",
  "pet.slashPopoverHint": "↑↓ 切換 · enter 選擇 · esc 關閉",
  "pet.slashPet": "切換、領養或跳到寵物設定。",
  "pet.slashPetWake": "喚醒漂浮的寵物。",
  "pet.slashPetTuck": "把寵物收起來。",
  "pet.slashHatch": "呼叫 hatch-pet 技能生成一隻 Codex 寵物。",
  "pet.slashHatchArg": "<概念>",
  "pet.slashSearch": "透過 OD research 指令搜尋網頁。",
  "pet.slashSearchArg": "<查詢>",
  "pet.codexTitle": "最近孵化",
  "pet.codexSubtitle": "hatch-pet 技能打包的寵物會出現在這裡,可一鍵領養。",
  "pet.codexSubtitleWithDir": "正在掃描 {dir},尋找 hatch-pet 技能打包的寵物。",
  "pet.codexEmpty": "還沒有孵化的寵物。在聊天中輸入 /hatch 來生成一隻。",
  "pet.codexLoading": "正在尋找已孵化的寵物…",
  "pet.codexRefresh": "重新整理",
  "pet.codexAdopt": "領養",
  "pet.codexAdopting": "領養中…",
  "pet.communitySync": "下載社群寵物",
  "pet.communitySyncing": "下載中…",
  "pet.communitySyncTitle":
    "從 Codex Pet Share 與 j20 Hatchery 同步最新寵物到 ~/.codex/pets/。",
  "pet.communitySyncDone": "已同步 {wrote} 個新寵物（共 {total} 個）。",
  "pet.communitySyncFailed": "同步失敗：{error}",
  "pet.codexBundled": "內建",
  "pet.codexBundledTitle": "Open Design 內建寵物，無需下載。",
  "settings.notifications": "通知",
  "settings.notificationsHint": "任務完成時的音效和桌面通知",
  "settings.notifyCompletionSound": "完成提示音",
  "settings.notifyCompletionSoundHint": "一輪任務結束時播放，預設關閉",
  "settings.notifySuccessSound": "成功音色",
  "settings.notifyFailureSound": "失敗音色",
  "settings.notifyDesktop": "桌面通知",
  "settings.notifyDesktopHint": "視窗不在前景時跳出系統通知",
  "settings.notifyDesktopBlocked": "瀏覽器已拒絕通知權限，請在網站設定中開啟",
  "settings.notifyDesktopUnsupported": "當前環境不支援桌面通知",
  "settings.notifyTest": "測試通知",
  "settings.notifyTestSent":
    "測試通知已送出；如果沒有彈窗，請檢查瀏覽器和系統通知設定。",
  "settings.notifyTestFailed": "通知呼叫失敗，請檢查瀏覽器和系統通知設定。",
  "settings.notifySoundDing": "叮",
  "settings.notifySoundChime": "風鈴",
  "settings.notifySoundTwoToneUp": "上行雙音",
  "settings.notifySoundPluck": "撥弦",
  "settings.notifySoundBuzz": "蜂鳴",
  "settings.notifySoundTwoToneDown": "下行雙音",
  "settings.notifySoundThud": "低響",
  "settings.skills": "技能",
  "settings.skillsHint": "代理可在任務中呼叫的功能技能",
  "settings.skillsNew": "新增技能",
  "settings.skillsEmpty": "請於左側選擇一個技能，或新增一個。",
  "settings.skillsEdit": "編輯",
  "settings.skillsDelete": "刪除",
  "settings.skillsDeleteConfirm": "確認刪除",
  "settings.skillsName": "名稱",
  "settings.skillsTriggers": "觸發詞（逗號或換行分隔）",
  "settings.skillsDescription": "描述",
  "settings.skillsBody": "SKILL.md 內容",
  "settings.skillsCreate": "建立",
  "settings.skillsSave": "儲存",
  "settings.skillsSaving": "儲存中…",
  "settings.skillsOverrideCreate": "建立使用者覆寫",
  "settings.skillsOverrideSave": "另存為使用者覆寫",
  "settings.skillsBuiltInOverrideWarning":
    "編輯此內建技能會建立一份使用者覆寫。在你刪除該覆寫之前，內建項目將從清單中隱藏。是否繼續？",
  "settings.skillsFiles": "檔案",
  "settings.skillsNoFiles": "此技能資料夾沒有檔案。",
  "settings.skillsNameRequired": "技能名稱為必填項。",
  "settings.skillsBodyRequired": "技能內容為必填項。",
  "settings.designSystems": "設計系統",
  "settings.designSystemsHint": "管理首頁 Gallery 中顯示的設計系統",
  "settings.designSystemsInstalled": "已安裝",
  "settings.designSystemsAdd": "新增設計系統",
  "settings.designSystemsHiddenCount": "{count} 個已從首頁 Gallery 隱藏",
  "settings.designSystemsShowAll": "顯示全部",
  "settings.designSystemsShowHidden": "顯示隱藏項目",
  "settings.designSystemsSource": "來源",
  "settings.designSystemsSourceLocal": "本機",
  "settings.designSystemsSourceGithub": "GitHub",
  "settings.designSystemsSourceShadcn": "shadcn",
  "settings.designSystemsShadcnReference": "shadcn 註冊表參考",
  "settings.designSystemsImportShadcn": "從 shadcn 匯入",
  "settings.designSystemsStructure": "結構",
  "settings.designSystemsModeHybrid": "混合",
  "settings.designSystemsModeNormalized": "規範化",
  "settings.designSystemsModeVerbatim": "原樣保留",
  "settings.designSystemsCraft": "工藝",
  "settings.designSystemsCraftColor": "色彩",
  "settings.designSystemsCraftAccessibility": "無障礙",
  "settings.designSystemsGithubUrl": "GitHub URL",
  "settings.designSystemsProjectPath": "專案路徑",
  "settings.designSystemsImportGithub": "從 GitHub 匯入",
  "settings.designSystemsImportProject": "從專案匯入",
  "settings.designSystemsImportedStatus": "已匯入 {title}",
  "settings.designSystemsViewImported": "查看匯入的設計系統",
  "settings.designSystemsCategory": "分類",
  "settings.designSystemsAllCategories": "所有分類",
  "settings.designSystemsShowInHomeGallery": "在首頁 Gallery 中顯示",
  "settings.projectLocations": "專案位置",
  "settings.projectLocationsHint": "工作區儲存根目錄",
  "settings.projectLocationsDescription":
    "新增可包含多個 Open Design 專案資料夾的工作基目錄。新專案會儲存為所選基目錄中的一個資料夾。",
  "settings.projectLocationsSaveError":
    "無法儲存專案位置。請確認每個路徑都是可存取的資料夾。",
  "settings.projectLocationsSaved": "專案位置已儲存。",
  "settings.projectLocationsScanError": "無法掃描專案位置。",
  "settings.projectLocationsScanComplete":
    "掃描完成：已匯入 {imported} 個，已有 {existing} 個。",
  "settings.projectLocationsNoFolderSelected": "未選取資料夾。",
  "settings.projectLocationsDuplicate": "這個工作基目錄已新增。",
  "settings.projectLocationsWorkBaseMeta":
    "工作基目錄 · 專案會在這裡建立為子資料夾",
  "settings.projectLocationsAddFolder": "新增資料夾…",
  "settings.projectLocationsDefaultBadge": "預設位置",
  "settings.projectLocationsMakeDefault": "設為預設",
  "settings.projectLocationsDefaultSaved": "預設專案位置已更新。",
  "settings.librarySkills": "技能",
  "settings.libraryDesignSystems": "設計系統",
  "settings.librarySearch": "搜尋...",
  "settings.libraryAll": "全部",
  "settings.libraryPreview": "預覽",
  "settings.libraryPreviewClose": "關閉",
  "settings.libraryLoading": "載入中...",
  "settings.libraryNoResults": "沒有符合的項目。",
  "settings.libraryEnabled": "已啟用",
  "settings.libraryDisabled": "已停用",
  "settings.connectorsNavHint": "外部系統連線",
  "settings.connectorsHint": "管理此裝置的連接器與工具供應商設定。",
  "settings.connectorsComposioApiKey": "Composio API 金鑰",
  "settings.connectorsSavedTitle": "已儲存到本機 daemon",
  "settings.connectorsSavedWithTail": "已儲存 · ••••{tail}",
  "settings.connectorsSaved": "已儲存",
  "settings.connectorsGetApiKey": "取得 API 金鑰",
  "settings.connectorsReplaceKeyPlaceholder": "貼上新金鑰以取代已儲存的金鑰",
  "settings.connectorsApiKeyPlaceholder": "貼上 Composio API 金鑰",
  "settings.connectorsClear": "清除",
  "settings.connectorsClearConfirmTitle": "清除已儲存的 Composio API 金鑰？",
  "settings.connectorsClearConfirmBody":
    "移除金鑰會將此工作區下所有的 Composio 連接器全部斷開。已連線的帳戶、OAuth 授權與工具存取權限都將一併移除。",
  "settings.connectorsClearConfirmContinue": "繼續",
  "settings.connectorsClearFinalTitle": "此動作會斷開所有連接器",
  "settings.connectorsClearFinalBody":
    "無法復原。貼上新金鑰後，每個整合都必須從頭重新連線。",
  "settings.connectorsClearFinalConfirm": "刪除金鑰並斷線",
  "settings.connectorsClearArming": "稍候…",
  "settings.connectorsClearCancel": "取消",
  "settings.connectorsSaveKey": "儲存金鑰",
  "settings.connectorsSaveKeyTitle": "將此金鑰送往本機 daemon",
  "settings.connectorsKeySaving": "儲存中…",
  "settings.connectorsKeySaved": "已儲存 ✓",
  "settings.connectorsKeyError":
    "儲存金鑰失敗。請確認本機 daemon 已啟動後再試。",
  "settings.connectorsHelpSaved":
    "你的金鑰會解鎖下方目錄，並保留在本機 daemon 中。貼上新金鑰可取代，或清除以移除。",
  "settings.connectorsHelpUnsaved":
    "尚未儲存 — 點擊「儲存金鑰」即可將其存入本機 daemon，並解鎖下方目錄。",
  "settings.connectorsHelpEmpty":
    "新增金鑰以解鎖下方目錄。金鑰會本機儲存在 daemon 中，絕不會透過環境變數傳送。",
  "settings.connectorsLoadingSavedKey": "正在從本機 daemon 檢查已儲存的金鑰…",
  "settings.autosaveSaving": "儲存中…",
  "settings.autosaveSaved": "所有變更已儲存",
  "settings.autosaveError": "無法儲存變更。本機 daemon 可能離線。",
  "settings.libraryToggleLabel": "切換",
  "settings.memory": "記憶",
  "settings.memoryHint": "從對話中自動沉澱的個人化資訊",
  "settings.customInstructionsTitle": "全域規則",
  "settings.customInstructionsHint":
    "Open Design 在每次聊天中都應遵循的固定指示。將事實、偏好與專案脈絡儲存為記憶。",
  "settings.customInstructionsPlaceholder":
    "例如「一律使用 TypeScript。優先採用函式型元件。回覆保持簡潔。」",
  "settings.memoryDescription":
    "自動從聊天中提取出的關於你的偏好和上下文的事實，以 Markdown 檔案形式保存，並自動注入到每次對話中。",
  "settings.memoryEnabled": "已啟用",
  "settings.memoryDisabled": "已關閉",
  "settings.memoryEnableLabel": "啟用記憶注入",
  "settings.memoryDisabledBanner":
    "記憶目前已關閉。已有的事實檔案保留在磁碟上，但不會被注入到新對話，也不會從新對話中提取新事實。",
  "settings.memoryNew": "新增記憶",
  "settings.memoryEdit": "編輯",
  "settings.memoryDelete": "刪除",
  "settings.memoryPreview": "預覽",
  "settings.memoryEmpty": "還沒有記憶。",
  "settings.memoryEmptyHintZh": "记住: 用户偏好深色主题",
  "settings.memoryEmptyHintEn": "我偏好深色模式",
  "settings.memoryName": "名稱",
  "settings.memoryDesc": "一行描述",
  "settings.memoryBody": "記憶正文（支援 Markdown）",
  "settings.memoryBodyHint": "先寫規則本身，再補「為什麼」和「何時適用」兩行。",
  "settings.memoryStartersLabel": "不知道寫什麼？點一下填到表單裡：",
  "settings.memoryStarterUserName": "我的角色",
  "settings.memoryStarterUserDesc": "我是一名前端工程師，主要做 SaaS 設計工具",
  "settings.memoryStarterUserBody":
    "- 角色：高級前端工程師\n- 技術棧：React、TypeScript、Vite\n- 方向：設計 / 協作工具\n- 時區：GMT+8（Asia/Shanghai）\n\n何時適用：任何對話裡舉例時優先用前端 / Web 場景。",
  "settings.memoryStarterFeedbackName": "UI 偏好",
  "settings.memoryStarterFeedbackDesc": "深色主題、字號偏大、資訊密度低",
  "settings.memoryStarterFeedbackBody":
    "- 主題：預設深色\n- 正文字號：≥ 18px\n- 資訊密度：留白多一些，一屏不要塞太多東西\n\n為什麼：長時間使用眼睛不容易累。\n何時適用：讓你畫 UI、網頁、PPT 時都按這個走。",
  "settings.memoryStarterProjectName": "當前專案",
  "settings.memoryStarterProjectDesc":
    "Open Design v0.5 — 聊天驅動的設計編輯器",
  "settings.memoryStarterProjectBody":
    "- 目標：本季交付聊天驅動的編輯體驗\n- 優先級：串流渲染、本地多模態、離線優先\n- 技術棧：Next.js 16、Express daemon、SQLite\n\n何時適用：與本專案相關的所有對話。",
  "settings.memorySaveHint": "不會自動儲存 — 點擊「建立」/「儲存」才會生效。",
  "settings.memoryIndexSaveHint":
    "索引不會自動儲存 — 改完後點擊「儲存索引」才會生效。",
  "settings.memoryIndexUnsaved": "有尚未儲存的修改",
  "settings.memoryFlashCreated": "✓ 已建立",
  "settings.memoryFlashSaved": "✓ 已儲存",
  "settings.memoryFlashDeleted": "✓ 已刪除",
  "settings.memoryFlashIndexSaved": "✓ 索引已儲存",
  "settings.memoryFlashPathCopied": "✓ 路徑已複製",
  "settings.memoryNameLabel": "標題",
  "settings.memoryTypeLabel": "類型",
  "settings.memoryDescLabel": "描述",
  "settings.memoryBodyLabel": "內容",
  "settings.memoryTypeUser": "使用者",
  "settings.memoryTypeFeedback": "回饋",
  "settings.memoryTypeProject": "專案",
  "settings.memoryTypeReference": "參考",
  "settings.memoryTypeProfile": "檔案",
  "settings.memoryTypeRule": "規則",
  "settings.memoryTabMemories": "記憶",
  "settings.memoryTabMemoriesCaption": "查看與管理已儲存的記憶",
  "settings.memoryTabHow": "運作方式",
  "settings.memoryTabHowCaption": "兩個循環及其控制項",
  "settings.memoryAddDisclosure": "新增或匯入記憶",
  "settings.memoryAddDisclosureHint": "檔案、手動輸入或已連接的應用",
  "settings.memoryProfileTab": "工作檔案",
  "settings.memoryProfileTabCaption": "你的身分與預設偏好",
  "settings.memoryProfileTitle": "你的工作檔案",
  "settings.memoryProfileHint":
    "關於你和你預設偏好的幾項資訊。記憶會在每次任務前注入這些內容，讓代理人能從簡短的需求推斷你的意圖。",
  "settings.memoryProfileName": "工作檔案",
  "settings.memoryProfileDescription":
    "角色、公司、領域、受眾、品味，以及助理應重複使用的預設偏好。",
  "settings.memoryProfileSave": "儲存檔案",
  "settings.memoryProfileSaving": "儲存中…",
  "settings.memoryProfileSaved": "檔案已儲存",
  "settings.memoryProfileRole": "角色",
  "settings.memoryProfileRolePlaceholder": "e.g. 創辦人、設計師、PM",
  "settings.memoryProfileCompany": "公司／團隊",
  "settings.memoryProfileCompanyPlaceholder": "e.g. Acme、成長團隊",
  "settings.memoryProfileDomain": "領域",
  "settings.memoryProfileDomainPlaceholder": "e.g. B2B SaaS、fintech、devtools",
  "settings.memoryProfileAudience": "主要受眾",
  "settings.memoryProfileAudiencePlaceholder": "e.g. 主管、工程師、終端使用者",
  "settings.memoryProfileAesthetic": "美感／品味",
  "settings.memoryProfileAestheticPlaceholder":
    "e.g. 簡潔有編輯感、淺色背景、充裕的留白",
  "settings.memoryProfileDeliverables": "預設交付物",
  "settings.memoryProfileDeliverablesPlaceholder":
    "e.g. 著陸頁、簡報、一頁式文件",
  "settings.memoryProfileLocale": "地區／語言",
  "settings.memoryProfileLocalePlaceholder": "e.g. English (US)、簡體中文",
  "settings.memoryProfileGoals": "目前目標",
  "settings.memoryProfileGoalsPlaceholder":
    "e.g. 推出新的定價頁、提升試用流程的轉換率",
  "settings.memoryHooksTitle": "記憶掛鉤",
  "settings.memoryHooksHint":
    "選擇要自動執行的記憶環節。上方的總開關會將全部關閉。",
  "settings.memoryHooksProfileLabel": "使用我的檔案",
  "settings.memoryHooksProfileDesc": "在每次任務中注入你的工作檔案。",
  "settings.memoryHooksRewriteLabel": "改寫簡短需求",
  "settings.memoryHooksRewriteDesc": "PRE：將簡短的需求展開為完整的任務簡報。",
  "settings.memoryHooksVerifyLabel": "自我驗證輸出",
  "settings.memoryHooksVerifyDesc":
    "POST：依照你的規則檢查結果，然後顯示評分卡。",
  "settings.memoryHooksExtractionLabel": "從對話中學習",
  "settings.memoryHooksExtractionDesc": "從對話輪次中擷取有用的事實與偏好。",
  "artifact.odCardTaskBriefChip": "已套用記憶 · 查看簡報",
  "artifact.odCardScorecardTitle": "自我檢查",
  "artifact.odCardScorecardStatusPass": "通過",
  "artifact.odCardScorecardStatusPartial": "部分通過",
  "artifact.odCardScorecardStatusFail": "需改進",
  "artifact.odCardRuleKicker": "建議規則",
  "artifact.odCardRuleNameLabel": "名稱",
  "artifact.odCardRuleDescriptionLabel": "描述",
  "artifact.odCardRuleAssertionLabel": "必須成立",
  "artifact.odCardRuleCheckLabel": "如何檢查",
  "artifact.odCardRuleRationaleLabel": "原因",
  "artifact.odCardRuleKeep": "保留",
  "artifact.odCardRuleEdit": "編輯",
  "artifact.odCardRuleDone": "完成",
  "artifact.odCardRuleDiscard": "捨棄",
  "artifact.odCardRuleSaving": "儲存中…",
  "artifact.odCardRuleSaved": "已將「{name}」儲存為規則",
  "artifact.odCardRuleError": "無法儲存規則，請再試一次。",
  "artifact.odCardBrandAssistDone": "已確認瀏覽器輔助",
  "artifact.odCardBrandAssistKicker": "需要瀏覽器輔助：{reason}",
  "artifact.odCardBrandAssistBody":
    "在瀏覽器中開啟品牌網站，讓 Open Design 繼續擷取此設計體系。",
  "artifact.odCardBrandAssistError": "無法啟動瀏覽器輔助，請重試。",
  "artifact.odCardBrandAssistWorking": "正在啟動...",
  "artifact.odCardBrandAssistConfirm": "開啟瀏覽器輔助",
  "settings.memoryIndex": "MEMORY.md（索引）",
  "settings.memoryIndexSave": "儲存索引",
  "settings.memoryIndexReset": "重設",
  "settings.memoryToastChanged": "記憶已更新",
  "settings.memoryToastClickHint": "查看",
  "settings.memoryAll": "全部",
  "settings.memoryExtractions": "抽取歷史",
  "settings.memoryExtractionsHint":
    "最近的 LLM 抽取記錄。每次對話結束後，啟發式正則會先跑，LLM 抽取在背景非同步進行。",
  "settings.memoryExtractionsEmpty":
    "暫無抽取記錄。下一次對話結束後會出現在這裡。",
  "settings.memoryExtractionsRefresh": "重新整理",
  "settings.memoryExtractionsRefreshing": "重新整理中…",
  "settings.memoryExtractionPhaseRunning": "抽取中…",
  "settings.memoryExtractionPhaseSuccess": "成功",
  "settings.memoryExtractionPhaseSkipped": "已跳過",
  "settings.memoryExtractionPhaseFailed": "失敗",
  "settings.memoryExtractionSkipNoProvider": "未設定 API key，LLM 抽取未執行。",
  "settings.memoryExtractionSkipUnsupportedProvider":
    "已儲存的媒體 Provider 不能用於 LLM 記憶抽取。",
  "settings.memoryExtractionSkipDisabled": "記憶功能已關閉。",
  "settings.memoryExtractionSkipEmpty": "使用者訊息為空，沒有可抽取的內容。",
  "settings.memoryExtractionSkipNoMatch": "本輪沒有命中任何正則規則。",
  "settings.memoryExtractionKindHeuristic": "正則",
  "settings.memoryExtractionKindLlm": "LLM",
  "settings.memoryExtractionProviderEnv": "環境變數",
  "settings.memoryExtractionProviderMediaConfig": "媒體設定",
  "settings.memoryExtractionProviderOverride": "記憶設定",
  "settings.memoryExtractionProposed": "候選",
  "settings.memoryExtractionWritten": "寫入",
  "settings.memoryExtractionDuration": "耗時",
  "settings.memoryExtractionDelete": "刪除",
  "settings.memoryExtractionsClear": "清空",
  "settings.memoryExtractionsClearTitle": "清空整個抽取歷史",
  "settings.memoryExtractionsClearConfirm":
    "要清除所有擷取記錄嗎？此動作無法復原。",
  "settings.memoryNoProviderBannerTitle": "LLM 抽取未啟用",
  "settings.memoryNoProviderBannerBody":
    "未找到可用的 API key，LLM 抽取已跳過。可以在媒體提供者裡填入 OpenAI key，或設定環境變數 ANTHROPIC_API_KEY / OPENAI_API_KEY 來啟用。啟發式抽取仍在執行。",
  "settings.memoryUnsupportedProviderBannerBody":
    "已儲存媒體 Provider key，但 Memory 只能複用支援文字抽取的 Provider：OpenAI、MiniMax、AIHubMix 和 SenseAudio。請在媒體提供者中設定其中一個，設定 ANTHROPIC_API_KEY / OPENAI_API_KEY，或在進階設定中選擇 Memory model。",
  "settings.libraryInstall": "安裝",
  "settings.libraryInstallGithub": "GitHub",
  "settings.libraryInstallLocal": "本機路徑",
  "settings.libraryInstallUrl": "https://github.com/owner/repo",
  "settings.libraryInstallPath": "/path/to/skill-folder",
  "settings.libraryInstallButton": "安裝",
  "settings.libraryUninstall": "解除安裝",
  "settings.libraryBuiltIn": "內建",
  "settings.libraryInstalled": "已安裝",
  "notify.successTitle": "任務已完成",
  "notify.failureTitle": "任務失敗",
  "notify.successBody": "一輪回答已經寫完。",
  "notify.failureBody": "本輪任務出錯，請查看錯誤訊息。",
  "updater.available": "有可用更新",
  "updater.activeRunsTitle": "Open Design 仍在執行任務",
  "updater.activeRunsBody": "仍有 {count} 個任務正在執行。現在重新啟動會中斷這些任務。",
  "updater.activeRunsUnknownBody": "Open Design 無法確認是否仍有任務執行。現在重新啟動可能會中斷進行中的工作。",
  "updater.availableBody":
    "Open Design {version} 可用。下載完成後即可開啟安裝器。",
  "updater.checking": "正在檢查更新",
  "updater.download": "下載更新",
  "updater.downloading": "正在下載更新",
  "updater.downloadingPercent": "正在下載更新 {percent}%",
  "updater.done": "完成",
  "updater.failed": "更新失敗",
  "updater.installerOpenBody":
    "安裝器已開啟。Open Design 正在結束，以便你完成更新。",
  "updater.installerOpened": "安裝器已開啟",
  "updater.later": "稍後",
  "updater.allowSilentUpdates": "允許以後自動安裝應用內更新",
  "updater.openFailedFallback": "無法開啟安裝器。",
  "updater.installRestart": "安裝並重新啟動",
  "updater.installingRestart": "Installing and restarting...",
  "updater.openInstaller": "安裝更新",
  "updater.opening": "正在開啟安裝器…",
  "updater.dialogAvailableGeneric": "發現新版本。\n下載後即可安裝。",
  "updater.dialogAvailableVersion": "v{version} 可供更新。\n下載後即可安裝。",
  "updater.dialogCheckFailed": "檢查更新失敗。\n請稍後再試。",
  "updater.dialogReadyGeneric":
    "新版本已準備就緒。\n更好的體驗、更智慧的設計，歡迎體驗新版本。",
  "updater.dialogReadyVersion":
    "v{version} 已準備就緒。\n更好的體驗、更智慧的設計，歡迎體驗新版本。",
  "updater.dialogUnsupported":
    "目前環境不支援應用程式內更新。\n可前往發布頁面手動下載。",
  "updater.payloadReadyGeneric":
    "A new Open Design update is ready. Open Design will close and restart automatically.",
  "updater.payloadReadyVersion":
    "Open Design {version} is ready. Open Design will close and restart automatically.",
  "updater.quitButton": "結束 Open Design",
  "updater.quitFailedBody":
    "安裝器已開啟，但 Open Design 無法結束。替換應用程式前請先結束 Open Design。",
  "updater.quitFailedTitle": "無法結束",
  "updater.quitting": "正在結束…",
  "updater.ready": "更新已就緒",
  "updater.readyGeneric": "新版本已就緒。Open Design 會關閉並開啟安裝器。",
  "updater.readyVersion":
    "Open Design {version} 已就緒。Open Design 會關閉並開啟安裝器。",
  "updater.upToDate": "您已經是最新版本啦",
  "updater.viewVersionFeatures": "查看新版本特色",
  "updater.manualDownload": "手動下載",
  "updater.restartAnyway": "仍然重新啟動",

  "whatsNew.cta": "看看有什麼新功能",
  "whatsNew.dismissAria": "關閉更新亮點",

  'designBrowser.copyScreenshot': '複製截圖',
  'designBrowser.hardReload': '強制重新整理',
  'designBrowser.copyUrl': '複製 URL',
  'designBrowser.openExternal': '在外部開啟',
  'designBrowser.downloadPage': '下載頁面',
  'designBrowser.downloadPageBusy': '正在下載頁面...',
  'designBrowser.clearHistory': '清空歷史',
  'designBrowser.clearCookies': '清除 Cookie',
  'designBrowser.clearAllData': '清除所有瀏覽器資料',
  'designBrowser.status.openHttpFirst': '請先開啟 http 或 https 頁面。',
  'designBrowser.status.openBeforeScreenshot': '請先開啟頁面再截圖。',
  'designBrowser.status.openBeforeBrief': '請先開啟頁面再儲存簡報。',
  'designBrowser.status.openBeforeDownload': '請先開啟頁面再儲存快照。',
  'designBrowser.status.pageSnapshotStarted': '正在儲存頁面快照...',
  'designBrowser.status.pageSnapshotUnsupported': '目前頁面無法封存。',
  'designBrowser.status.pageSnapshotFailed': '頁面快照儲存失敗。',
  'designBrowser.status.pageSnapshotSaved': '已儲存頁面快照（HTML + CSS）。',
  'designBrowser.status.viewDesignFiles': '查看設計檔案',
  'designBrowser.status.downloadAssistHint': '頁面載入完成後，點擊「下載頁面」。儲存成功後，返回左側繼續擷取。',
  'settings.amrBalance': '餘額',
  'settings.amrPlan': '方案',
  'settings.amrUpgrade': '升級',
  'settings.amrModelUpgradeHint': '升級後使用',
  'settings.updateCheck': '檢查更新',
  'settings.updateNow': '立即更新',
  'settings.updateRecheck': '重新檢查',
  'settings.updateRetry': '重試',
  'settings.updateViewReleases': '查看發佈記錄',
  'settings.updateActionFailed': '無法完成更新操作。',
  'settings.updateQuitFailed': '安裝程式已開啟，但 Open Design 未能自動結束。',
  'settings.updateStatusNotChecked': '未檢查更新',
  'settings.updateStatusDevelopment': '開發環境不支援應用程式內更新。',
  'settings.updateStatusUnsupported': '目前環境不支援應用程式內更新。',
  'settings.updateStatusChecking': '正在檢查更新…',
  'settings.updateStatusUpToDate': '您已經是最新版本。',
  'settings.updateStatusAvailable': '發現新版本 {version}，正在準備下載',
  'settings.updateStatusAvailableUnknown': '發現新版本，正在準備下載',
  'settings.updateStatusDownloading': '正在下載更新…',
  'settings.updateStatusDownloadingPercent': '正在下載更新 {percent}%。',
  'settings.updateStatusReady': '版本 {version} 已準備好安裝。',
  'settings.updateStatusReadyUnknown': '更新已準備好安裝。',
  'settings.updateStatusInstalling': '正在安裝更新…',
  'settings.updateStatusFailed': '檢查失敗，請重試',
  'designs.menuDuplicate': '複製專案',
  'project.typePrototype': '原型',
  'project.typeDeck': '簡報',
  'project.typeTemplate': '範本',
  'project.typeImage': '圖片',
  'project.typeVideo': '影片',
  'project.typeAudio': '音訊',
  'chat.brandBrowserLocalSnapshotMissing': '此 URL 沒有已儲存的頁面快照。',
  'chat.brandBrowserLocalSnapshotReadFailed': '無法讀取已儲存的頁面快照。',
  'chat.brandBrowserSnapshotSaveFailed': '無法從瀏覽器儲存頁面快照。',
  'chat.brandBrowserAssistDownloadGuideTitle': '已開啟 Browser',
  'chat.brandBrowserAssistDownloadGuideDetails': '第 1 步：開啟或切到右側 Browser tab，並完成必要的人機驗證。第 2 步：點擊 More，再點擊「下載頁面」。第 3 步：等待頁面快照儲存成功提示。第 4 步：回到左側「下一步」卡片，點擊「繼續擷取」繼續程式化擷取。',
  'designFiles.projectMenu': '專案操作',
  'designFiles.createDesignSystemFromProject': '基於此專案創建設計系統',
  'designFiles.duplicateProject': '複製專案',
  'fileViewer.versions.entry': '版本',
  'fileViewer.versions.title': '版本管理',
  'fileViewer.versions.countOne': '1 個版本',
  'fileViewer.versions.countMany': '{count} 個版本',
  'fileViewer.versions.current': '目前',
  'fileViewer.versions.sourceAi': 'AI 編輯',
  'fileViewer.versions.sourceManual': '手動編輯',
  'fileViewer.versions.sourceRestore': '回退生成',
  'fileViewer.versions.restoredFrom': '從 v{version} 回退',
  'fileViewer.versions.versionLabel': '版本 {version}',
  'fileViewer.versions.listAria': '檔案版本',
  'fileViewer.versions.loading': '正在載入版本...',
  'fileViewer.versions.empty': '尚無版本。',
  'fileViewer.versions.loadFailed': '無法載入版本。',
  'fileViewer.versions.previewFailed': '無法載入此版本預覽。',
  'fileViewer.versions.previewLoading': '正在載入版本預覽...',
  'fileViewer.versions.noPrompt': '未記錄提示詞',
  'fileViewer.versions.noPromptBody': '此版本沒有記錄提示詞。',
  'fileViewer.versions.promptTitle': '提示詞',
  'fileViewer.versions.copyPrompt': '複製提示詞',
  'fileViewer.versions.fullscreen': '全螢幕預覽',
  'fileViewer.versions.open': '開啟預覽',
  'fileViewer.versions.currentHelp': '這已經是目前版本。',
  'fileViewer.versions.restoreHelp': '切換會將此 HTML 還原為新的目前版本。',
  'fileViewer.versions.restore': '切換到此版本',
  'fileViewer.versions.restoreConfirmTitle': '切換到此版本？',
  'fileViewer.versions.restoreConfirmCta': '切換',
  'fileViewer.versions.restoring': '切換中...',
  'fileViewer.versions.restoreFailed': '無法切換到此版本。',
  'fileViewer.versions.restoreSuccess': '已切換到此版本。',
  'nextStep.createDesignSystemTitle': '創建設計系統',
  'nextStep.createDesignSystemBody': '複製目前專案為設計系統工作區，並基於所有目前檔案和參考啟動 agent 生成。',
  'nextStep.createDesignSystemBusy': '正在創建設計系統...',
  'nextStep.projectContinueTitle': '繼續處理',
  'nextStep.projectGenerateArtifactTitle': '產生產物',
  'nextStep.designSystemAiRefineTitle': 'AI 優化設計系統',
  'nextStep.designSystemAuditKitTitle': '檢查 tokens 和元件套件',
  'nextStep.brandCreateDesignPrompt': '用「{designSystem}」設計系統建立一個新設計。',
  'nextStep.brandContinueExtractionTitle': '繼續擷取',
  'nextStep.brandContinueExtractionBody': 'Browser 分頁完成驗證後，讀取目前頁面並繼續填充已儲存的設計系統。',
  'nextStep.brandContinueExtractionBusy': '正在繼續擷取...',
  'nextStep.brandContinueAiExtractionTitle': '繼續 agent 擷取',
  'nextStep.brandContinueAiExtractionProgrammaticBody': '如果程式化擷取仍無法完成，使用目前 agent 從已儲存草稿繼續擷取。',
  'nextStep.brandContinueAiExtractionAiBody': '從目前品牌腳手架恢復 agent 擷取，並完成同一個設計系統。',
  'nextStep.brandContinueAiExtractionBusy': '正在繼續 agent 擷取...',


  "newsletter.label": "訂閱產品更新（選填）",
  "newsletter.placeholder": "you@studio.com",
  "settings.memoryModelInlineLabel": "Memory 模型",
  "settings.memoryModelInlineSameAsChat": "與聊天一致",
  "settings.memoryModelInlineSameAsChatWithModel": "與聊天一致（{model}）",
  "settings.memoryModelInlineSameAsChatWithProvider":
    "與聊天一致（{provider}）",
  "settings.memoryModelInlineHintCli":
    "可選。支援時會直接使用目前的 Local CLI；只在想覆寫預設模型時選擇。",
  "settings.memoryModelInlineHintCliConstrained":
    "可選。支援時會直接使用目前的 Local CLI；{provider} 只作為不支援 CLI 時的備用供應商。",
  "settings.memoryModelInlineHintByok":
    "可選。沿用你聊天用的 API key，在同供應商上換成（通常更便宜的）模型跑背景 memory 擷取。",
  "settings.memoryModelInlineFlashSaved": "已儲存",
  "settings.memoryModelInlineFlashCleared": "已清除",
  "settings.orbit.eyebrow": "自動化",
  "settings.orbit.title": "Orbit",
  "settings.orbit.navHint": "每日連接器摘要",
  "settings.orbit.lede":
    "依排程收集連接器活動，並將結果發布為可重新整理的即時看板。",
  "settings.orbit.statusOnTitle": "每日排程執行已開啟",
  "settings.orbit.statusOffTitle": "每日排程執行已關閉",
  "settings.orbit.statusActive": "啟用",
  "settings.orbit.statusOff": "關閉",
  "settings.orbit.runTitle": "啟動一次 Orbit 執行並開啟即時對話",
  "settings.orbit.running": "執行中…",
  "settings.orbit.runOpen": "立即執行",
  "settings.orbit.dailySummaryTitle": "每日摘要",
  "settings.orbit.dailySummarySub": "每天在排定的本地時間執行一次。",
  "settings.orbit.on": "開啟",
  "settings.orbit.off": "關閉",
  "settings.orbit.runTimeTitle": "執行時間",
  "settings.orbit.runTimeSub": "預設 08:00。儲存後套用到 daemon 排程。",
  "settings.orbit.runTimeAria": "每日 Orbit 執行時間",
  "settings.orbit.nextRun": "下次執行",
  "settings.orbit.nextRunScheduledAfterSave": "儲存後排程",
  "settings.orbit.schedule": "排程",
  "settings.orbit.pausedManualOnly": "已暫停 — 僅手動執行",
  "settings.orbit.templateTitle": "提示詞範本",
  "settings.orbit.templateMissing": "範本 {id} 尚未安裝。",
  "settings.orbit.templateMissingOption": "{id}（缺少）",
  "settings.orbit.templateMissingInstall": "安裝 Orbit skill 以引導提示詞。",
  "settings.orbit.templateMissingPickAnother": "從下拉選單選擇其他範本。",
  "settings.orbit.templateResetTitle": "重設為 {id}",
  "settings.orbit.templateReset": "重設",
  "settings.orbit.templateHelp":
    "用 skill 引導 Orbit — 所選範本的範例提示詞會注入每次 Orbit 執行，讓摘要遵循該範本結構。",
  "settings.orbit.templateAria": "Orbit 提示詞範本",
  "settings.orbit.templatesLoading": "正在載入範本…",
  "settings.orbit.templatesOptgroup": "Orbit skill 範本",
  "settings.orbit.lastRun": "上次執行",
  "settings.orbit.triggerManual": "手動",
  "settings.orbit.triggerScheduled": "排程",
  "settings.orbit.meterAria":
    "成功 {succeeded}，略過 {skipped}，失敗 {failed}，共檢查 {checked}",
  "settings.orbit.countChecked": "已檢查",
  "settings.orbit.countSucceeded": "成功",
  "settings.orbit.countSkipped": "已略過",
  "settings.orbit.countFailed": "失敗",
  "settings.orbit.runError":
    "無法執行 Orbit。請確認本機 daemon 正在執行且連接器已設定。",
  "settings.orbit.gateAriaLabel": "使用 Orbit 需要先設定連接器",
  "settings.orbit.gateEyebrow": "需要先完成設定",
  "settings.orbit.gateTitle": "連接一個工具，讓 Orbit 開始運作",
  "settings.orbit.gateBody":
    "Orbit 會彙整你已連接服務的活動。你目前還沒有任何連接 —— 至少加入一個整合，讓 Orbit 有內容可回報。",
  "settings.orbit.gateBodyNoKey":
    "Orbit 會彙整連接器的活動，而連接器透過 Composio 執行。在「連接器」中填入 Composio API 金鑰即可解鎖目錄並挑選第一個整合。",
  "settings.orbit.gateAction": "開啟連接器",
  "settings.orbit.gateActionNoKey": "設定 Composio",
  "settings.orbit.gateLoading": "正在檢查連接器…",
  "settings.orbit.controlsLockedBadge": "已鎖定",
  "settings.orbit.controlsLockedHint":
    "連接一個工具後即可解鎖 Orbit 的排程與範本設定。",
  "settings.orbit.artifactKickerLive": "即時看板",
  "settings.orbit.artifactKickerLegacy": "舊版摘要",
  "settings.orbit.artifactTitle": "每日 Orbit 活動摘要",
  "settings.orbit.artifactMetaLive":
    "由連接器活動產生的可重新整理 HTML artifact。",
  "settings.orbit.artifactMetaLegacy":
    "在啟用即時看板支援之前產生 — 再次執行 Orbit 以發布一個。",
  "settings.orbit.copyMarkdownTitle": "複製 Markdown 摘要到剪貼簿",
  "settings.orbit.copied": "已複製",
  "settings.orbit.copy": "複製",
  "settings.orbit.openArtifact": "開啟 artifact",
  "settings.orbit.sourceMarkdown": "來源 Markdown",
  "settings.memoryModelInlineHintByokNeutral":
    "記憶使用與聊天不同的模型。預設為你的聊天模型。",
  "diagnostics.exportTitle": "匯出診斷日誌",
  "diagnostics.exportButton": "匯出診斷日誌",
  "diagnostics.exportHint":
    "將近期的應用日誌與機器資訊打包成 zip,方便傳給我們排查問題。",
  "diagnostics.exporting": "匯出中…",
  "diagnostics.exportSuccess": "診斷日誌已儲存至 {path}",
  "diagnostics.exportFailed": "匯出診斷日誌失敗：{message}",
  "automations.eyebrow": "定時智慧體工作階段",
  "automations.title": "自動化",
  "automations.lede": "為專案工作、Orbit 摘要與即時看板規劃週期性對話。",
  "automations.summaryAria": "自動化概覽",
  "automations.metricActive": "執行中",
  "automations.metricPaused": "已暫停",
  "automations.metricTemplates": "範本",
  "automations.newAutomation": "新增自動化",
  "automations.yourAutomations": "你的自動化",
  "automations.loading": "載入中",
  "automations.emptyTitle": "還沒有自動化",
  "automations.emptyBody": "從範本建立一個，或從空白排程開始。",
  "automations.targetNewEachRun": "每次執行新建專案",
  "automations.targetCreateEachRun": "每次執行新建專案",
  "automations.lastRun": "上次執行 {time}",
  "automations.openResult": "開啟結果",
  "automations.run": "執行",
  "automations.runNowTitle": "立即執行並開啟對話",
  "automations.history": "歷史記錄",
  "automations.hideHistory": "隱藏歷史記錄",
  "automations.edit": "編輯",
  "automations.pause": "暫停",
  "automations.resume": "恢復",
  "automations.deleteAria": "刪除自動化",
  "automations.deleteTitle": "刪除此自動化",
  "automations.deleteConfirm": "刪除此自動化？過去的執行及其專案會保留。",
  "automations.proposalsTitle": "演進提案",
  "automations.proposalsSub":
    "在自動化輸出變更記憶、技能或設計體系之前先審閱。",
  "automations.proposalsPending": "{n} 個待處理",
  "automations.apply": "套用",
  "automations.reject": "拒絕",
  "automations.proposalsDismissReason": "在自動化中已忽略",
  "automations.templatesTitle": "範本",
  "automations.templatesSub": "Orbit 與即時看板都是同一自動化流程中的範本。",
  "automations.templatesCount": "{total} 個中的 {filtered} 個",
  "automations.templateFiltersAria": "範本篩選器",
  "automations.templatesEmptyTitle": "此分類下還沒有範本。",
  "automations.templatesEmptyBody": "換一個篩選條件，或從空白自動化開始。",
  "automations.useTemplate": "使用範本",
  "automations.promptPlaceholder": "輸入此自動化要執行的任務說明。",
  "automations.runHistoryLoading": "正在載入執行歷史…",
  "automations.runHistoryEmpty": "還沒有執行記錄。",
  "automations.runHistoryTitle": "執行歷史",
  "automations.runHistoryLatest": "最近 10 筆",
  "automations.crystallize": "沉澱",
  "automations.crystallizing": "沉澱中",
  "automations.crystallizeTitle": "根據本次執行起草技能與記憶提案",
  "automations.crystallizeFailed": "Crystallize failed: {error}",
  "automations.crystallizePartialSuccess":
    "Crystallize created proposals, but Automations could not refresh the proposal list. Review the visible proposals or try refreshing.",
  "automations.crystallizeRefreshFailed":
    "Crystallize finished, but Automations could not refresh proposals. Try refreshing before running it again.",
  "automations.crystallizeNoProposals":
    "Crystallize finished, but no proposals were returned. Try refreshing or check the run details.",
  "automations.openConversation": "開啟對話",
  "automations.runHistoryAria": "自動化執行歷史",
  "automations.proposalsAria": "自動化演進提案",
  "automations.templatesAria": "自動化範本",
  "automations.runInProgress": "進行中",
  "automations.scheduleStatusPaused": "已暫停",
  "automations.nextRunManualOnly": "僅手動",
  "automations.nextRunScheduled": "已排程",
  "automations.nextRunAt": "下次 {time}",
  "automations.statusSucceeded": "成功",
  "automations.statusFailed": "失敗",
  "automations.statusRunning": "執行中",
  "automations.statusQueued": "排隊中",
  "automations.statusCanceled": "已取消",
  "automations.kindOrbit": "Orbit",
  "automations.kindLiveArtifact": "即時看板",
  "automations.kindAutomation": "自動化",
  "automations.proposalTargetMemory": "記憶",
  "automations.proposalTargetDesignSystem": "設計體系",
  "automations.proposalTargetSkill": "技能",
  "automations.proposalTargetTemplate": "自動化範本",
  "automations.proposalActionCreate": "建立",
  "automations.proposalActionUpdate": "更新",
  "automations.proposalActionMerge": "合併",
  "automations.proposalActionMove": "移動",
  "automations.proposalActionDelete": "刪除",
  "automations.proposalActionPromote": "提升",
  "automations.filterAll": "全部",
  "automations.filterOrbit": "Orbit",
  "automations.filterLiveArtifacts": "即時看板",
  "automations.filterMemory": "記憶",
  "automations.filterDesignSystems": "設計體系",
  "automations.filterSkills": "技能",
  "automations.filterConnectors": "連接器",
  "automations.filterCompression": "壓縮",
  "automations.filterRelease": "發佈",
  "automations.filterQuality": "品質",
  "automations.tpl.memoryRefresh.title": "根據近期工作重新整理專案記憶。",
  "automations.tpl.memoryRefresh.desc":
    "將重複的決策、偏好與回饋轉化為可重複使用的記憶更新。",
  "automations.tpl.designSystemRefresh.title": "根據已交付的產物更新設計體系。",
  "automations.tpl.designSystemRefresh.desc":
    "在近期設計工作中找出可重複使用的 token、元件與規則。",
  "automations.tpl.liveArtifactRegistry.title":
    "稽核即時看板並重新整理過時版本。",
  "automations.tpl.liveArtifactRegistry.desc":
    "讓持久的儀表板、報告與預覽保持最新，而非重複建立。",
  "automations.tpl.orbitDashboard.title": "建立連接器活動儀表板。",
  "automations.tpl.orbitDashboard.desc":
    "將選定的連接器彙整成 Orbit 風格的即時儀表板。",
  "automations.tpl.releaseNotes.title": "根據已交付的設計工作起草發佈說明。",
  "automations.tpl.releaseNotes.desc":
    "將已合併的 PR、產物與面向產品的變更整合成發佈說明。",
  "automations.tpl.qualityRegressionWatch.title": "監測設計與實作的回歸問題。",
  "automations.tpl.qualityRegressionWatch.desc":
    "將近期變更與基準、追蹤記錄與已採納的參考進行比對。",
  "automations.tpl.orbitDaily.title": "每日連接器摘要。",
  "automations.tpl.orbitDaily.desc": "依排程重新整理連接器活動摘要。",
  "automations.tpl.liveStatusBoard.title": "保持即時狀態產物始終最新。",
  "automations.tpl.liveStatusBoard.desc":
    "更新同一個持久產物，而非每次執行都新建報告。",
  "dsManager.areaAria": "設計體系區域",
  "dsManager.tabDesignSystem": "設計體系",
  "dsManager.tabTemplate": "範本",
  "dsManager.sourceAria": "設計體系來源",
  "dsManager.templateSourceAria": "範本來源",
  "dsManager.yourSystems": "你的體系",
  "dsManager.officialPresets": "官方預設",
  "dsManager.enterprise": "企業版",
  "dsManager.yourTemplates": "你的範本",
  "dsManager.yourSystemsAria": "你的設計體系",
  "dsManager.eyebrowDesignSystems": "設計體系",
  "dsManager.yourSystemsHeading": "你的體系",
  "dsManager.filterAria": "篩選設計體系",
  "dsManager.filterAll": "全部",
  "dsManager.filterPublished": "已發佈",
  "dsManager.filterDraft": "草稿",
  "dsManager.createTitle": "新增設計體系",
  "dsManager.createBody":
    "把你的品牌、產品、程式碼、素材與設計參考教給 Open Design。",
  "dsManager.createAction": "建立",
  "dsManager.emptyMine":
    "還沒有設計體系。從真實的產品脈絡建立一個，審閱草稿後再發佈，供日後的專案使用。",
  "dsManager.badgeDefault": "對話預設",
  "dsManager.rowMetaUpdated": "你 · 更新於 {date}",
  "dsManager.edit": "編輯",
  "dsManager.openSystem": "編輯系統",
  "dsManager.editWithAgent": "用 Agent 編輯",
  "dsManager.downloadTitle": "下載設計體系（.zip + SKILLS.md）",
  "dsManager.downloadAria": "下載 {title} 為 .zip",
  "dsManager.downloadFailed": "無法下載該設計體系，請重試。",
  "dsManager.deleteConfirm":
    "刪除「{title}」？這會從本裝置移除該草稿設計體系。",
  "dsManager.makeDefault": "設為新對話預設",
  "dsManager.statusPublished": "已發佈",
  "dsManager.statusDraft": "草稿",
  "dsManager.openSystemAria": "編輯 {title}",
  "dsManager.deleteSystemAria": "刪除 {title}",
  "dsManager.presetsAria": "官方設計體系預設",
  "dsManager.eyebrowLibrary": "資料庫",
  "dsManager.eyebrowTemplates": "範本",
  "dsManager.yourTemplatesAria": "你的範本",
  "dsManager.emptyTemplates":
    "還沒有範本。啟用範本發佈後，可透過任一已產生專案的「分享」來建立。",
  "dsManager.templateDescFallback": "從專案建立",
  "dsManager.comingSoonBadge": "敬請期待",
  "dsManager.enterpriseDsTitle": "企業設計體系",
  "dsManager.enterpriseDsBody": "團隊共享的設計體系與受治理的品牌庫即將推出。",
  "dsManager.enterpriseTplTitle": "企業範本",
  "dsManager.enterpriseTplBody": "團隊核准的範本與組織級發佈即將推出。",
  "settings.instructionsTitle": "指令 / 規則",
  "settings.instructionsSubtitle": "助手應始終遵循的固定行為",
  "settings.instructionsNavSub": "固定的助手行為",
  "settings.customInstructionsDesc":
    "Open Design 在每次對話中都會遵循的固定指令。它們不是儲存的記憶；事實、偏好與專案脈絡請使用「記憶」。",
  "mcpClient.forwardedToLabel": "已轉發給：",
  "mcpClient.notForwardedToLabel": "未轉發給：",
  "mcpClient.forwardedAcpNote":
    "標記為 stdio only 的 ACP 介面卡只會從此清單接收 stdio 類型的 MCP 伺服器；HTTP 與 SSE 項目會在啟動時被捨棄。",
  "mcpClient.notForwardedNote":
    "對於這些智慧體，請在其各自的設定檔中設定 MCP 伺服器（例如 ~/.codex/config.toml、~/.gemini/settings.json）；下方的伺服器在那裡不會生效。",

  // Brands library + extraction
  "brand.libraryTitle": "品牌套件",
  "brand.librarySubtitle":
    "把你的品牌套件教給 Open Design——從網站擷取一個品牌套件，然後在任意對話中套用它。",
  "brand.newBrand": "新增品牌套件",
  "brand.searchPlaceholder": "搜尋你的品牌套件…",
  "brand.empty": "還沒有品牌套件。從一個網站擷取一個品牌套件即可開始。",
  "brand.colorsCount": "{count} 種顏色",
  "brand.extracting": "擷取中…",
  "brand.failed": "擷取失敗",
  "brand.needsInput": "需要操作",
  "brand.needsInputHint": "提取已暫停 —— 開啟專案完成驗證或回答問題。",
  "brand.appliedToChat": "正在使用 {name}",
  "brand.previewEmpty": "選擇一個品牌進行預覽",
  "brand.viewDetails": "查看詳情",
  "newBrand.title": "新增品牌",
  "newBrand.subtitle":
    "貼上一個網站，或在下方挑選一個品牌，我們會擷取它的顏色、字型和標誌。",
  "newBrand.urlLabel": "品牌網站",
  "newBrand.urlPlaceholder": "yourcompany.com",
  "newBrand.extract": "擷取設計系統",
  "newBrand.cancel": "取消",
  "newBrand.close": "關閉",
  "newBrand.stage1": "正在抓取網站並測量其設計",
  "newBrand.stage2": "正在建立品牌預覽",
  "newBrand.stage3": "正在推導並註冊設計體系",
  "newBrand.measured": "{colors} 種顏色 · {fonts} 種字型 · {logos} 個標誌",
  "newBrand.done": "品牌已就緒",
  "brandDetail.identity": "品牌識別",
  "brandDetail.designLanguage": "設計語言",
  "brandDetail.colors": "顏色",
  "brandDetail.fonts": "字型",
  "brandDetail.tone": "語氣",
  "brandDetail.aesthetic": "美學風格",
  "brandDetail.tagline": "標語",
  "brandDetail.voice": "聲音",
  "brandDetail.useInChat": "在新對話中使用",
  "brandDetail.delete": "刪除品牌",
  "brandDetail.back": "品牌套件",
  "brandDetail.refining": "正在優化此品牌…",
  "brandDetail.notFound": "找不到品牌。",
  "brandDetail.logo": "Logo",
  "brandDetail.typography": "字體排版",
  "brandDetail.palette": "調色盤",
  "brandDetail.voiceTone": "語氣與調性",
  "brandDetail.imageryLayout": "圖像與版面",
  "brandDetail.images": "圖像",
  "brandDetail.designSystem": "設計系統",
  "brandDetail.brandAssets": "品牌素材",
  "brandDetail.openProject": "開啟專案",
  "brandDetail.themeLight": "淺色",
  "brandDetail.themeDark": "深色",
  "brandDetail.subjects": "主題",
  "brandDetail.treatment": "處理方式",
  "brandDetail.useLabel": "使用",
  "brandDetail.avoidLabel": "避免",
  "brandDetail.layoutPosture": "版面準則",
  "brandDetail.deleteConfirm": "刪除「{name}」？這會移除該品牌及其設計系統。",
  "brandDetail.viewMore": "檢視全部 {count} 張",
  "brandDetail.viewLess": "收合",
  "settings.resetOnboarding": "重置引導流程",
  "settings.resetOnboardingDesc": "重新進行首次設定，包括品牌擷取。",
  "settings.resetOnboardingButton": "重置",
  "onboarding.brandTitle": "擷取你的設計系統",
  "onboarding.brandSubtitle":
    "貼上品牌網站，我們會把品牌線索轉成後續可重用的設計系統。",
  "onboarding.brandSkip": "暫時略過",
  "onboarding.brandDone": "設計系統已擷取",
  "onboarding.buildTitle": "一次建立,處處沿用",
  "onboarding.buildBody":
    "Open Design 將你的品牌沉澱為可重用的設計系統,讓你之後打造的一切都保持品牌一致。",
  "onboarding.buildBenefitMemoryTitle": "一份品牌記憶",
  "onboarding.buildBenefitMemoryBody":
    "色彩、字體、間距、元件和語氣會沉澱成可重用的 DESIGN.md。",
  "onboarding.buildBenefitAlignedTitle": "每個產出都保持一致",
  "onboarding.buildBenefitAlignedBody":
    "原型、簡報、PDF、儀表板和行銷素材都會使用同一套規則。",
  "onboarding.buildBenefitSourcesTitle": "從既有素材開始",
  "onboarding.buildBenefitSourcesBody":
    "可以使用 GitHub repo、網站、既有 DESIGN.md、截圖、字體或 Figma 檔案。",
  "onboarding.buildPreviewLabel": "品牌系統",
  "onboarding.buildStart": "建立設計系統",
  "onboarding.buildHome": "直接進入主頁",
  "dsCreate.referenceLabel": "從現有設計系統複製",
  "dsCreate.referenceLoading": "正在載入 DESIGN.md...",
  "dsCreate.referenceLoadFailed": "無法載入該設計系統。",
  "dsCreate.heroShowGuideAria": "顯示設計系統指南",
  "dsCreate.heroHideGuideAria": "隱藏設計系統指南",
  "dsCreate.heroShowGuideTitle": "顯示指南",
  "dsCreate.heroHideGuideTitle": "隱藏指南",
  "dsCreate.heroGuide": "指南",
  "dsCreate.missingSourceError":
    "請加入網站、DESIGN.md、描述、檔案、Figma 來源或備註來建立設計系統。",
  "dsCreate.continueToGeneration": "繼續生成",
  "dsCreate.embeddedTitle": "從你的素材生成",
  "dsCreate.embeddedBody": "先加入網站或品牌參考，再補充你已有的來源檔案。",
  "dsCreate.sourceSectionTitle": "從 GitHub、網站或來源素材擷取",
  "dsCreate.sourceSectionBody":
    "從 GitHub repo、網站、DESIGN.md 或能體現風格的檔案開始。Open Design 會先快速建立一套可用系統，之後 AI 可在專案中繼續細化。",
  "dsCreate.githubWebsiteLabel": "GitHub 或網站",
  "dsCreate.add": "加入",
  "dsCreate.startFromBrand": "從品牌開始",
  "dsCreate.brandPickerSubtitle":
    "搜尋數百個品牌，選一個後我們會把它的網站加入為風格參考。",
  "dsCreate.brandPickerQuickPicks": "熱門品牌 · 點擊加入",
  "dsCreate.addedSourceLinks": "已加入的來源連結",
  "dsCreate.openSourceLabel": "開啟 {label}",
  "dsCreate.removeSourceLabel": "移除 {label}",
  "dsCreate.addFiles": "加入檔案",
  "dsCreate.describeBrand": "描述品牌",
  "dsCreate.optional": "選填",
  "dsCreate.describeBrandHelp":
    "品牌語氣、簡介和產品脈絡。會用於快速生成和 AI 細化。",
  "dsCreate.companyPlaceholder":
    "例如：Mission Impastabowl，一間支援自助點餐、行動 app 和網站的快休閒義大利麵餐廳",
  "dsCreate.pasteDesignMd": "貼上 DESIGN.md",
  "dsCreate.pasteDesignMdHelp":
    "貼上 DESIGN.md，即可直接從 token、設計理由和元件指南建立設計系統。",
  "dsCreate.reference": "參考",
  "dsCreate.designMdViewMode": "DESIGN.md 檢視模式",
  "dsCreate.advancedToggle": "進階 · repo、本機程式碼、Figma",
  "dsCreate.githubRepo": "GitHub repo",
  "dsCreate.localCodeLabel": "連結本機程式碼",
  "dsCreate.localCodeHelper": "使用此電腦上的資料夾或選取檔案。",
  "dsCreate.localCodePrompt": "拖入資料夾或瀏覽",
  "dsCreate.uploadFigLabel": "上傳 .fig",
  "dsCreate.uploadFigHelper":
    "在你的裝置上解碼成真實 token、元件和素材，無需 Figma 帳號。",
  "dsCreate.uploadFigPrompt": "拖入 .fig 或瀏覽",
  "dsCreate.figmaUrl": "Figma URL",
  "dsCreate.figmaPlaceholder": "https://figma.com/design/… 或 /file/…",
  "dsCreate.addedFigmaUrls": "已加入的 Figma URL",
  "dsCreate.savedFigmaHelp":
    "已儲存為 Figma 設計來源。Agent 會把它作為標準參考；若需完整離線解碼，請在上方匯出 .fig。",
  "dsCreate.notes": "備註",
  "dsCreate.notesPlaceholder":
    "例如：我們使用溫暖自然的配色和圓角。品牌語氣有趣但專業...",
  "dsCreate.back": "返回",
  "dsCreate.generate": "生成",
  "dsCreate.libraryPickerTitle": "從資料庫選擇",
  "dsCreate.libraryPickerConfirm": "加入到素材",
  "dsCreate.designMdPreviewKicker": "設計系統",
  "dsCreate.designMdPreviewTitle": "DESIGN.md 預覽",
  "dsCreate.componentKit": "元件套件",
  "dsCreate.defaultTheme": "預設主題",
  "dsCreate.componentKitTitle": "{name} · 元件套件",
  "dsCreate.designMdGeneratedDescription":
    "由貼上的 DESIGN.md token、設計理由和元件指南生成。",
  "dsCreate.previewButtons": "按鈕",
  "dsCreate.previewButtonsHelp": "五種類型，三種尺寸。",
  "dsCreate.buttonPrimary": "主要",
  "dsCreate.buttonDashed": "虛線",
  "dsCreate.buttonText": "文字",
  "dsCreate.buttonLink": "連結",
  "dsCreate.sizeSmall": "小",
  "dsCreate.sizeMedium": "中",
  "dsCreate.sizeLarge": "大",
  "dsCreate.previewTypeScale": "字級層級",
  "dsCreate.extractedTokens": "擷取的 DESIGN.md token",
  "brandPicker.heading": "從你喜歡的品牌開始",
  "brandPicker.subtext": "點擊任一品牌，即可直接從其網站擷取品牌套件。",
  "brandPicker.quickPicksLabel": "熱門品牌 · 點擊即可擷取",
  "brandPicker.searchPlaceholder": "搜尋品牌…",
  "brandPicker.allCategories": "全部",
  "brandPicker.extractAction": "擷取",
  "brandPicker.showMore": "顯示更多",
  "brandPicker.opening": "正在開始擷取 — 正在開啟 {brand}…",
  "ds.kitVisualize": "視覺化",
  "ds.kitEdit": "編輯",
  "ds.kitSource": "原始碼",
  "ds.saveDesignMd": "儲存 DESIGN.md",
  "ds.saving": "儲存中…",
  "ds.copyDesignMd": "複製 DESIGN.md",
  "ds.editDesignMd": "編輯 DESIGN.md",
  "ds.openDesignMd": "開啟 DESIGN.md",
  "ds.copyDesignMdModule": "複製{module}段落",
  "ds.editDesignMdModule": "編輯{module}段落",
  "ds.openDesignMdModule": "開啟{module}段落",
  "ds.uploadMd": "上傳 MD",
  "ds.uploadFont": "新增字體檔",
  "ds.pasteImage": "貼上圖片",
  "ds.refresh": "重新整理",
  "ds.download": "下載",
  "ds.importFolder": "匯入資料夾",
  "ds.reset": "重設",
  "ds.editingDesignMdHint": "編輯這份 Markdown 會更新已渲染的套件模組。",
  "ds.editingModuleHint": "僅編輯{module}模組。",
  "ds.manualEditModuleHint": "在這裡編輯{module}。懸停此模組可顯示修改控制項。",
  "ds.saveModule": "儲存模組",
  "ds.uploadLogo": "上傳 Logo",
  "ds.uploadImage": "上傳圖片",
  "ds.uploading": "上傳中…",
  "ds.moduleEmptyLogo": "尚無 Logo",
  "ds.moduleEmptyFonts": "尚無字體檔。",
  "ds.actionDone": "完成",
  "ds.actionFailed": "發生錯誤，請重試。",
  "ds.uploadDone": "已上傳",
  "ds.uploadFailed": "上傳失敗，請重試。",
  "ds.deleteLogo": "刪除 Logo",
  "ds.deleteImage": "刪除 {caption}",
  "ds.deleteProjectConfirm":
    "刪除「{title}」？這會從本裝置永久移除該設計體系及其專案。",
  "ds.deleteProjectAction": "刪除 {title}",
  "ds.editColor": "編輯{name}",
  "ds.colorLabel": "顏色",
  "ds.hexLabel": "Hex",
  "ds.hexValueLabel": "Hex 值",
  "ds.saveColor": "儲存顏色",
  "ds.invalidHexColor": "請輸入有效的 Hex 顏色，例如 #FF6A3D。",
  "ds.colorSaveFailed": "無法儲存該顏色。",
  "ds.colorResetFailed": "無法重設該顏色。",
  "ds.designMdSectionLabel": "{module} DESIGN.md 段落",
  "ds.kitErrorTitle": "此檢視遇到問題。",
  "ds.kitErrorRetry": "重新載入",
  "ds.shortcutsLabel": "鍵盤快捷鍵",
  "ds.shortcutsHint":
    "快捷鍵：E 編輯 · C 複製 · U 上傳 · R 重新整理 · ⌫ 刪除 Logo",
  "ds.moduleEmptyImages": "尚無圖片",
  "ds.noOriginalColor": "目前沒有可用於此色票的原始顏色。",
  "ds.manifestReadFailed": "無法讀取 _ds_manifest.json。",
  "ds.reviewCollapseSection": "收合{title}",
  "ds.reviewExpandSection": "展開{title}",
  "ds.reviewNeedsReview": "待審閱",
  "ds.reviewLooksGood": "看起來不錯",
  "ds.reviewActionsLabel": "審閱{title}",
  "ds.reviewNeedsWorkEllipsis": "需要修改...",
  "ds.reviewEditFile": "編輯 {file}",
  "ds.reviewFeedbackLabel": "告訴 agent 需要改什麼",
  "ds.reviewFeedbackPlaceholder":
    "例如：收緊 {title} 的間距，重新產生這個預覽...",
  "ds.reviewChangedAfterFeedback":
    "此段落已依照你的回饋變更。發布前請再次審閱。",
  "ds.reviewChangedDuringRun": "此段落在最近一次執行中變更。發布前請審閱。",
  "ds.reviewLastFeedback": "上次回饋",
  "ds.previewGenerating": "正在產生預覽...",
  "ds.creatingProjectTitle": "正在建立你的設計體系...",
  "ds.creatingProjectSubtitle": "請保持此分頁開啟。幾分鐘後可以回來查看。",
  "ds.generationProgressLabel": "設計體系產生進度 {progress}%",
  "ds.publishRepoRequiredTitle": "請先完成 GitHub 儲存庫匯入，再發布。",
  "ds.publishDesignSystem": "發布設計體系",
  "ds.unpublishDesignSystem": "取消發布設計體系",
  "ds.published": "已發布",
  "ds.publish": "发布",
  "ds.extractionRunningTitle": "正在擷取設計體系",
  "ds.extractionCompleteTitle": "擷取完成",
  "ds.extractionRunningBody": "Open Design 正在就地更新此體系。",
  "ds.extractionCompleteBody": "已擷取的模組如下所示；空段落會保持為空。",
  "ds.publishCardPublished": "團隊的新專案預設可以使用此設計體系作為上下文。",
  "ds.publishCardDraft":
    "你的設計體系已準備好，但回饋可以繼續改進它。準備好用於後續專案時再發布。",
  "ds.useSystemTitle": "使用此體系",
  "ds.useSystemBody":
    "新建設計會繼承此體系的顏色、字體和元件，並自動保持品牌一致。",
  "ds.createNewDesign": "建立新設計",
  "ds.openSourceContext": "開啟來源上下文",
  "ds.manifestNeedsAttention": "設計 manifest 需要處理",
  "ds.openManifest": "開啟 manifest",
  "ds.workspacePreparing": "正在準備設計體系工作區。",
  "ds.workspaceLoadingLabel": "設計體系工作區正在載入",
  "ds.sectionQueued": "已排队",
  "ds.sectionReviewUpdatedFiles": "審閱已更新檔案",
  "ds.reviewNeedsWork": "需要修改",
  "ds.sectionRequiredFileMissing": "缺少 {file}",
  "ds.sectionNoFilesYet": "暫無檔案",
  "ds.generationSourceTitle": "探索已提供資源",
  "ds.generationSourceDetail":
    "公司背景、GitHub 儲存庫、本機程式碼資料夾、Figma 檔案、字體、Logo 和備註。",
  "ds.generationGuidanceTitle": "建立 DESIGN.md",
  "ds.generationGuidanceDetail": "作為專案上下文使用的規範指南。",
  "ds.generationTokensTitle": "建立 tokens",
  "ds.generationTokensDetail": "顏色、字體、間距和圓角證據。",
  "ds.generationPreviewsTitle": "建立預覽卡片",
  "ds.generationPreviewsDetail": "用於設計體系分頁的 HTML 審閱卡片。",
  "ds.generationUiKitTitle": "建立 UI kit",
  "ds.generationUiKitDetail": "可重用的介面範例。",
  "ds.generationAssetsTitle": "登記資產",
  "ds.generationAssetsDetail": "Logo、圖示、字體和品牌檔案。",
  "ds.phaseQueuedTypography": "字體已排隊",
  "ds.phaseQueuedTokens": "Token 已排隊",
  "ds.phaseQueuedSpacing": "間距已排隊",
  "ds.phaseQueuedUiKit": "UI kit 已排隊",
  "ds.phaseQueuedAssets": "資產已排隊",
  "ds.phaseReadingTypography": "正在讀取字體",
  "ds.phaseReadingTokens": "正在讀取 tokens",
  "ds.phaseReadingSpacing": "正在讀取間距",
  "ds.phaseReadingUiKit": "正在讀取 UI kit",
  "ds.phaseReadingAssets": "正在讀取資產",
  "ds.phaseWritingTypography": "正在寫入字體",
  "ds.phaseWritingTokens": "正在寫入 tokens",
  "ds.phaseWritingSpacing": "正在寫入間距",
  "ds.phaseBuildingUiKit": "正在建構 UI kit",
  "ds.phaseUpdatingAssets": "正在更新資產",
  "ds.phaseNeedsAttention": "需要處理",
  "ds.phaseUpdated": "已更新",
  "ds.sectionActivityFromTodo": "{phase}，來自待辦：{todo}",
  "ds.sectionActivityReadFiles": "已讀取 {files}",
  "ds.sectionActivityPhaseFiles": "{phase}：{files}",
  "ds.sectionRunningReadingContext":
    "Open Design 正在讀取 {title} 的段落上下文。",
  "ds.sectionRunningNow": "{phase}中。",
  "ds.reviewLastReviewed": "上次審閱 {time}",
  "ds.agentFeedbackQueued": "回饋已儲存。當前執行結束後，agent 會繼續處理。",
  "ds.agentFeedbackSent": "已傳送給 agent。",
  "ds.agentFeedbackSentAt": "已於 {time} 傳送給 agent。",
  "ds.agentFeedbackFailedWithError": "Agent 任務失敗：{error}",
  "ds.agentFeedbackFailed": "Agent 任務失敗。",
  "ds.agentFeedbackUnknown": "Agent 任務狀態未知。",
  "ds.repoConnectBannerTitle": "連接你的儲存庫，以擷取設計體系資訊",
  "ds.repoConnectCardTitle": "連接儲存庫",
  "ds.repoConnectPendingBody": "正在檢查 GitHub 連線...",
  "ds.repoConnectPendingButton": "正在檢查 GitHub...",
  "ds.repoConnectedTitle": "GitHub 已連接",
  "ds.repoConnectedBody": "重新匯入此儲存庫，把檔案拉入你的設計體系。",
  "ds.repoImportButton": "匯入儲存庫",
  "ds.repoConnectBannerBody":
    "連接 GitHub 後，Open Design 可以讀取你的儲存庫，並把顏色、字體和元件擷取到此設計體系中。",
  "ds.repoConnectCardBody": "從儲存庫中擷取顏色、字體和元件到此設計體系。",
  "ds.repoConnectButton": "連接 GitHub",
  "newproj.startFromLabel": "起點",
  "newproj.startBlank": "空白",
  "newproj.startBlankHint": "從零開始",
  "workspace.pages": "頁面",
  "workspace.allProjectFiles": "全部專案檔案",
  "workspace.newBlankPage": "新增空白頁面",
  "workspace.noPagesYet": "還沒有頁面",
  "workspace.pageCreateFailed": "無法建立頁面。",
  "workspace.pageCreatorTitle": "新增頁面",
  "workspace.pageCreatorSearch": "搜尋範本",
  "workspace.pageCreatorCategoryAll": "全部場景",
  "workspace.pageCreatorEmpty": "沒有符合的頁面類型。",
  "workspace.pageCreatorPreview": "預覽",
  "workspace.pageCreatorUse": "使用",
  "fileViewer.presentInTabDeckHint": "演講者備註會在彈出視窗中開啟",
  "fileViewer.presentEscHint": "按 Esc 結束放映",
  "fileViewer.presenterPause": "暫停",
  "fileViewer.presenterResume": "繼續",
  "fileViewer.presenterPrevious": "上一頁",
  "fileViewer.presenterNext": "下一頁",
  "questions.uploadingFiles": "正在上傳檔案…",
  "questions.uploadNeedsProject": "檔案上傳需要一個使用中的專案。",
  "questions.uploadPartialFailed": "已上傳 {uploaded} 個檔案，{failed} 個失敗。",
  "questions.uploadFailed": "有 {failed} 個檔案上傳失敗。",
};
